const messagesTR = {
    code: "tr",
    messages: {
        zoho: {
            SETTING_GROUP: "Ayarlar",
            usermapping: "Kullanıcı Eşleme",
        },
        chatWindow: {
            thereIsNoChatContent: "Sohbet içeriği bulunmuyor.",
            thereIsNoChatContentDsc: "Bu kısımda sohbet içeriğini görebilir ve mesaj gönderebilirsiniz.",
            interactions: "Etkileşimler:",
            departments: "Departmanlar",
            channels: "Kanallar",
            date: "Tarih",
            lastChatStatus: "Son Sohbet Durumu",
            all: "Tümü",
            queued: "Sıraya alındı",
            open: "Açık",
            closed: "Kapalı",
            private: "Özel",
            chatbot: "Sohbet robotu",
            lostMissed: "Kayıp / Kaçırılan",
            interaction: "Etkileşim",
            myActiveInbox: "Aktif Gelen Kutum",
            activeQueueInbox: "Aktif + Kuyruktakiler",
            chatbotActiveInbox: "Chatbot Aktif Kutusu",
            myDepartmentsActiveInbox: "Departmanlarım Kutusu",
            notInteractedYesterday: "Dün Kaçan Kutusu",
            queueInbox: "Kuyruktakiler",
            whatsappActiveInbox: "Whatsapp Kutusu",
            socialMediaActiveInbox: "Sosyal Medya Kutusu",
            missedThisMonth: "Bu Ayki Kaçan Kutusu",
            chooseAFileOrDragItHere: "Bir dosya seçin veya buraya sürükleyin!",
            watching: "İzleniyor",
            selectFilter: "Filtre Seç",
            clearAll: "Hepsini temizle",
            me: "Ben",
            today: "Bugün",
            yesterday: "Dün",
            thisWeek: "Bu Hafta",
            lastWeek: "Geçen Hafta",
            last7Days: "Son 7 Gün",
            last30Days: "Son 30 Gün",
            thisMonth: "Bu Ay",
            lastMonth: "Geçen Ay",
            last24h: "Son 24 Saat",
            custom: "Özel",
            startMessage: "Mesaj Başlat",
            goToAgentReport: "Temsilci Raporuna Git",
            agentDetail: "Temsilci Detay",
            agentList: "Temsilci Listesi",
            selectedFilter: "Seçilen Filtre",
            groupBy: "Grupla",
            owner: "Sahip",
            none: "Grup Yok",
            agent: "Temsilci",
            department: "Departman",
            tag: "Etiket",
            website: "Website",
            channel: "Kanal",
            platform: "Platform",
            answerStatus: "Yanıt Durumu",
            sortBy: "Sırala",
            lastPostAbove: "Son Mesaj Üstte",
            newChatsAbove: "Yeni Chatler Üstte",
            oldChatsAbove: "Eski Chatler Üstte",
            live: "Canlı",
            systemStatus: "Sistem Durumu",
            refresh: "Yenile",
            close: "Kapat",
            totalCustomers: "Toplam Müşteri",
            totalAnswered: "Toplam Yanıtlanan",
            waitingAnswer: "Yanıt Bekleyen",
            totalAgentInChat: "Sohbetteki Toplam Temsilci",
            onlineAgentCount: "Çevrimiçi Temsilci Sayısı",
            totalCustomer: "Toplam Müşteri",
            answered: "Yanıtlanan",
            unanswered: "Yanıtlanmayan",
            noContactWasFoundMatchingTheCurrentFilters: "Mevcut filtrelere uygun bir kişi bulunamadı.",
            you: "Sen",
            others: "Diğerleri",
            queue: "Kuyruk",
            chatbotContact: "Chatbot",
            closedContact: "Kapalı",
            myInteractions: "Benim Etkileşimlerim",
            special: "Özel",
            allInteractions: "Tüm kişiler",
            waiting: "Bekleyen",
            departmentToWhichItIsAffiliated: "Bağlandığı Departman",
        },
        form: {
            title: {
                titleSettings: "Başlık Ayarları",
                fullNameSettings: "Tam Ad Ayarları",
                emailSettings: "E-posta Ayarları",
                addressSettings: "Adres Ayarları",
                phoneSettings: "Telefon Ayarları",
                datePickerSettings: "Tarih Seçici Ayarları",
                shortTextSettings: "Kısa Metin Ayarları",
                longTextSettings: "Uzun Metin Ayarları",
                dropDownListSettings: "Açılır Liste Ayarları",
                singleChoiceSettings: "Tek Seçim Ayarları",
                multipleSelectionSettings: "Çoklu Seçim Ayarları",
                numberSettings: "Sayı Ayarları",
                hourSettings: "Saat Ayarları",
                spinnerSettings: "Spinner Ayarları",
                sendSettings: "Gönderme Ayarları",
                starRatingSettings: "Yıldız Derecelendirme Ayarları",
                ratingScaleSettings: "Derecelendirme Ölçeği Ayarları",
                separationElementSettings: "Ayırma Elemanı Ayarları",
                fileUploadSettings: "Dosya Yükleme Ayarları",
                imageSettings: "Resim Ayarları"
            },
            lineColor: "Çizgi Rengi",
            separatorColorInfo: "Ayırma elemanının rengini seçin veya girin (örn. #RRGGBB)",
            separatorHeight: "Ayırma Elemanı Yüksekliği",
            separatorHeightInfo: "Ayırma elemanının yüksekliğini girin",
            bottomSpace: "Altındaki Boşluk",
            bottomSpaceInfo: "Ayırma elemanının altına boşluk ekleyin",
            topSpace: "Üstündeki Boşluk",
            topSpaceInfo: "Ayırma elemanının üstüne boşluk ekleyin",
            sideSpace: "Yan Boşluk",
            sideSpaceInfo: "Ayırma elemanının sağına ve soluna boşluk ekleyin",
            onlyImageUpload: "Sadece Resim Yükleyebilirsiniz!",
            imageSizeLimit: "Resminizin Boyutu En Fazla 5MB Olmalıdır!",
            image: "Görsel",
            size: "Boyut",
            width: "Genişlik",
            height: "Yükseklik",
            imageAlignment: "Görüntü Hizalama",
            wide: "Geniş",
            small: "Küçük",
            textAlignment: "Metin Hizalama",
            chooseHorizontalAlignment: "Bu başlığın yatay olarak nasıl hizalanacağını seçin.",
            headerSize: "Başlık Boyutu",
            addSmallTextBelowHeader: "Başlığın altına daha küçük bir metin ekle",
            subHeaderText: "Alt Başlık Metni",
            subLabel1: "Alt Etiket(1)",
            subLabel2: "Alt Etiket(2)",
            validPhoneNumber: "Lütfen geçerli bir telefon numarası girin",
            masked: "Maskelenmiş",
            copyField: "Alanı Kopyala",
            copyFieldDescription: "Bu alanın tüm kayıtlı ayarlarını koruyarak bir kopyasını oluşturun",
            enterQuestion: "Bir soru girin",
            notRequired: "Zorunlu Değil",
            addDescriptionBelowField: "Alanının altına kısa bir açıklama ekleyin",
            setDefault: "Varsayılan olarak ayarla",
            pleaseSelect: "Lütfen Seçim Yapınız",
            placeholder: "Yer tutucu",
            required: "Zorunlu",
            fieldEmptyError: "Bu alan boşsa formun gönderilmesine izin vermeyin",
            subLabels: "Alt Etiketler",
            addressLine1: "Adres Satırı 1",
            addressLine2: "Adres Satırı 2",
            postalCode: "Posta Kodu",
            stateProvince: "İl / Eyalet",
            chooseLabelAlignment: "Etiket metninin yatay olarak nasıl hizalanacağını seçin",
            right: "SAĞ",
            left: 'SOL',
            top: "ÜST",
            labelAlignment: "Etiket Hizalama",
            fieldLabel: "Alan Etiketi",
            read: "Okundu",
            itemsPerPage: "öğe/sayfa",
            downloadAllDataAsPDF: "Tüm Veriyi PDF Olarak İndir",
            downloadAllDataAsExcel: "Tüm Veriyi Excel Olarak İndir",
            downloadSelectedDataAsPDF: "Seçili Veriyi PDF Olarak İndir",
            downloadSelectedDataAsExcel: "Seçili Veriyi Excel Olarak İndir",
            selectItemToViewDetails: "Detayları görmek için bir öğe seçin.",
            deleteFormConfirm:
                "Bu formu sildiğiniz takdirde, forma ait tüm veriler kalıcı olarak silinecektir. Devam etmek istediğinizden emin misiniz?",
            redicetFormAnswer: "FORM CEVAPLARINI YÖNLENDİRİN",
            redicetFormAnswerDesc:
                "Form cevaplarını ticket sistemine yönlendirirken, form içerisinde kullanıcıdan telefon numarası veya e-posta adresi talep etmeye özen gösteriniz. Bu bilgiler, kullanıcı ile daha hızlı ve etkin iletişim kurabilmek için önemlidir.",
            redicetFormAnswerDesc2: "Form cevapları ticket olarak sisteme yönlendirilir",
            rediectAnswersToTicket: "Gelen Cevapları Ticket Yönlendir",
            errorTicketMode: "Bilet modu güncellenirken hata oluştu:",
            formView: "Formu Görüntüle",
            formEdit: "Formu Güncelle",
            totalResponse: "Toplam Yanıt",
            totalUnreadResponse: "Toplam Okunmamış Yanıt",
            totalReadResponse: "Toplam Okunmuş Yanıt",
            totalArchivedResponse: "Toplam Arşivlenmiş Yanıt",
            singleChoice: "Tek Seçenek",
            _delete: "Sil",
            inbox: "Gelen Kutusu",
            edit: "Düzenle",
            forms: "Formlar",
            formsDesc: "Formlarınızı buradan yönetebilirsiniz.",
            createaForm: "Form Oluştur",
            allForms: "Tüm Formlar",
            formPublish: {
                shareFast: "HIZLI PAYLAŞ",
                shareFastDesc: "Doğrudan form bağlantısı ve sosyal paylaşım",
                add: "EKLE",
                addDesc: "Çeşitli web sayfası yerleştirme seçenekleri",
                assignForm: "FORMU ATA",
                assignFormDesc: "Formlarınızı başkalarına atayın",
                emails: "E-POSTALAR",
                emailsDesc: "Hatırlatmalar ve anlık paylaşım",
                prefill: "PREFILL",
                prefillDesc: "Formlarınızı önceden doldurun",
                pdf: "PDF",
                pdfDesc: "Doldurulabilir PDF dosyasını indirin",
                platforms: "PLATFORMLAR",
                platformsDesc: "Üçüncü taraf yayınlama seçenekleri",
                linkToYour: "FORMUNUZUN BAĞLANTI ADRESİ",
                linkToYourDesc: "Formunuz güvenli bir şekilde yayınlandı ve bu adreste kullanıma hazır.",
                shareWithLink: "BAĞLANTI İLE PAYLAŞ",
                publicForm: "Herkese Açık Form",
                copyLink: "BAĞLANTIYI KOPYALA",
                openInNewTab: "YENİ SEKMEDE AÇ",
                linkCopied: "Link Kopyalandı",
                codeCopied: "Kod Kopyalandı",
                iframe: "İframe",
                iframeDesc: "Formunu sayfanıza iFrame ile ekleyin",
                openWindow: "AÇILIR PENCERE",
                openWindowDesc: "Bir açılır pencere formuna bağlantı verin",
                formAddDesc: "Bu pasajı kopyalayıp kodunuza yapıştırın ve formunuzu web sitenize yerleştirin.",
            },
            formSettings: {
                enterNameForm: "Bu form için bir isim girin",
                selectStatusForm: "Formunuzun durumunu seçin",
                disabled: "Devre Dışı",
                disableSpecifiedTime: "Belirtilen bir zamanda ya da yanıt limitine ulaşıldığında devre dışı bırak",
                disableFormResponse: "Form Yanıtı limitine ulaşıldığında devre dışı bırak",
                pageShownAfterForm: "Form gönderildikten sonra gösterilen sayfa",
                formNotFound: "Form bulunamadı.",
                errorLoadingform: "Form yüklenirken bir hata oluştu.",
                formUpdated: "Form başlığı başarıyla güncellendi.",
                formErrorUpdated: "Form başlığı güncellenirken bir hata oluştu",
                formSettings: "FORM AYARLARI",
                changeFormStateAndProperties: "Form durumu ve özelliklerini değiştirin",
                title: "Başlık",
                newFormSettings: "Yeni Form Ayarları",
                formStatus: "Form Durumu",
                activateOrDeactivate: "Formunuzu etkinleştirin, devre dışı bırakın veya koşullu olarak etkinleştirin",
                effective: "ETKİN",
                yourFromIsVisible: "Formunuz şu anda görünür durumda ve form yanıtı alabiliyor",
                emails: "E-POSTALAR",
                emailsDesc: "Otomatik yanıtlayıcı e-postalar ve bildirim e-postaları gönderin",
                conditions: "KOŞULLAR",
                conditionsDesc: "Form girişlerine göre eylemleri tetikleyen koşullu mantık bölüm",
                thankYouPage: "TEŞEKKÜR SAYFASI",
                thankYouPageDesc: "Form gönderildikten sonra gösterilen sayfa",
                integretions: "ENTEGRASYONLAR",
                integretionsDesc: "Formunuzu diğer uygulamalara bağlayın",
            },
            clickToDeleteYourLogo: "Logonuzu silmek için tıklayın",
            create: "Oluştur",
            settings: "Ayarlar",
            load: "Yayınla",
            insertFormField: "Yeni Alanı Ekle",
            addYourLogo: "Logonuzu Ekleyin",
            surveyElements: {
                surveyElements: "Anket Elemanları",
                dataTable: "Veri Tablosu",
                starRating: "Yıldız Değerlendirme",
                evaluationScale: "Değerlendirme Ölçeği",
            },
            pageElements: {
                pageElements: "Sayfa Elemanları",
                separationElement: "Ayırma Elemanı",
                partitionCollapse: "Bölüm Daraltma",
                pageBreak: "Sayfa Sonu",
            },
            basicElements: {
                basicElements: "Temel Elemanlar",
                shortText: "Kısa Metin",
                longText: "Uzun Metin",
                paragraph: "Paragraf",
                dropDownList: "Açılır Liste",
                singleChoice: "Tekli Seçim",
                multipleSelection: "Çoklu Seçim",
                number: "Numara",
                image: "Resim",
                fileUpload: "Dosya Yükle",
                hour: "Saat",
                spinner: "Değer Değiştirici",
                send: "Gönder",
            },
            formElements: {
                formElements: "Form Elemanları",
                title: "Başlık",
                fullName: "Tam Ad",
                email: "E-Posta",
                address: "Adres",
                phone: "Telefon",
                datePicker: "Tarih",
                appointment: "Randevu",
                signature: "İmza",
                productList: "Ürün Listesi",
            },
            startWithaBlankForm: "Boş bir formla başlayın",
            startFromScratch: "Sıfırdan Başla",
            createOrTransferaForm: "Veri toplamaya başlamak için bir form oluşturun veya aktarın",
            createForm: "Form Oluşturun",
        },
        automation: {
            calendarEventCreated: "Takvimde etkinlik oluşturulduğunda",
            calendarEventUpdated: "Takvimde etkinlik güncellendiğinde",
            calendarEventDeleted: "Takvimde etkinlik silindiğinde",
            reservationCreated: "Rezervasyon oluşturulduğunda",
            reservationDateChanged: "Rezervasyon tarihi değiştiğinde",
            reservationDeleted: "Rezervasyon silindiğinde",
            chatLost: "Chat kaybedildiğinde",
            webchatCompleted: "Webden gelen chat tamamlanınca",
            instagramCompleted: "Instagram kanalından gelen chat tamamlanınca",
            messengerCompleted: "Messenger kanalından gelen chat tamamlanınca",
            whatsappCompleted: "Whatsapp kanalından gelen chat tamamlanınca",
            telegramCompleted: "Telegram kanalından gelen chat tamamlanınca",
            chatAssignedToAgent: "Chat bir temsilciye atandığında",
            profileButtonClicked: "Profilden otomasyon butonuna tıklandığında",
            operatedTask: "Çalıştırılan Görev",
            tableSelection: "Tablo Seçimi",
            selectTable: "Tablo Seçin",
            whichTableAutomationAddRecords:
                "Automasyonu hangi tabloya kayıt eklendiğinde çalıştırmak istiyorsunuz? Lütfen seçim yapınız.",
            whichTableAutomationUpdateRecords:
                "Automasyonu hangi tablodaki bir kayıt güncellendiğinde çalıştırmak istiyorsunuz? Lütfen seçim yapınız.",
            whichTableAutomationDeletedRecords:
                "Automasyonu hangi tablodan bir kayıt silindiğinde çalıştırmak istiyorsunuz? Lütfen seçim yapınız.",
            whichTableAutomationClickRecords:
                "Automasyonu hangi tablodaki bir kayıt üzerindeki otomasyon düğmesine tıklandığında çalıştırmak istiyorsunuz? Lütfen seçim yapınız.",
            planStatus: "Plan Durumu",
            scheduled: "Planlanmış",
            completed: "Tamamlandı",
            cancelled: "İptal Edildi",
            startTest: "Teste Başla",
            unpublish: "Yayından Kaldır",
            whenMessagePicked: "Sohbet arayüzü üzerinden bir mesaj seçildiğinde",
            whenTaskCompleted: "Bir görev tamamlandığında",
            whenTaskDeleted: "Bir görev silindiğinde",
            whenTaskAssigneeChanged: "Bir görev atanan kişi değiştirildiğinde",
            whenTaskPriorityChanged: "Bir görev önceliği değiştirildiğinde",
            whenTaskDueDateChanged: "Bir görevin son tarihi değiştirildiğinde",
            whenTaskStatusChanged: "Bir görev durumu değiştirildiğinde",
            whenTaskArchived: "Bir görev arşivlendiğinde",
            whenTagAdded: "Göreve bir etiket eklendiğinde",
            whenTagRemovedTask: "Bir etiket görevden kaldırıldığında",
            whenTagChecklist: "Bir görev kontrol listesi tamamlandığında",
            whenReminderActivated: "Bir hatırlatıcı etkinleştirildiğinde",
            whenTicketCreated: "Ticket Oluşturulduğunda",
            whenTicketStageChanged: "Bir ticket aşaması değiştirildiğinde",
            whenTicketAssigneeChanged: "Bir ticket atayıcısı değiştirildiğinde",
            whenTicketClosed: "Bir ticket kapatıldığında",
            whenTicketUpdated: "Bir ticket güncellendiğinde",
            autoPlanAndTaskHistory: "Otomasyon Planı ve Görev Geçmişi",
            automation: "Otomasyon",
            botScenario: "Bot Senaryosu",
            nameSurname: "Ad Soyad",
            phone164: "*E164 formatında giriniz. Örneğin: 905396667744",
            whichWpChannels: "Hangi Whatsapp Kanallarına Eklensin?",
            findContact: "İletişim Bulun",
            findContacts: "İletişimleri Bulun",
            offsetDesc: "İlk N kişiyi atlayın. Varsayılan değer '0'. Kişiler arasında ilerlemek için bunu kullanın.",
            limitDesc:
                "Ofsetten sonra döndürülecek maksimum kişi sayısı. Varsayılan değer '10'. Sayfalandırmak için bunu kullanın",
            contact: "Kişi",
            selectAction: "Aksiyon Seç",
            addMethod: "Yöntem Ekleme",
            selectField: "Alan Seç",
            schedulerRunningPlanEx: "Zamanlayıcı Çalışma Planı Örneği",
            schedulerPlanner: "Zamanlayıcı Planlayıcı",
            taskCreated: "Görev Oluşturuldu mu?",
            taskStatus: "Görev Durumları",
            terminateReason: "Fesih Nedeni",
            taskDuration: "Görev Süresi",
            taskWakeUpCount: "Görev Uyandırma Sayısı",
            completedAt: "Tamamlandı",
            cancelledAt: "İptal Edildi",
            nextRunAt: "Bir Sonraki Çalıştırma",
            configSchedulerAuto: "Otomasyon için Zamanlayıcıyı Yapılandırma",
            saveChanges: "Değişiklikleri Kaydet",
            catchAllWebhooks: "Bu URL'den Tüm Webhook'ları Yakala",
            webhookDataExPreview: "Webhook Veri Örneği Önizlemesi (istek gönderdikten sonra gösterilecektir)",
            webhookUrlCopied: "Webhook URL'si panoya kopyalandı",
            selectAnBlock: "Bir Block Seçin",
            dataFormats: "Veri Formatları",
            whenRecordCreated: "Bir kayıt oluşturulduğunda",
            whenRecordUpdated: "Bir kayıt güncellendiğinde",
            whenRecordDelete: "Bir kayıt silindiğinde",
            whenRecordAutomation: "Bir kayıt otomasyonu düğmesine tıklandığında",
            whenWebhookTriggered: "Bir web kancası tetiklendiğinde",
            whenChatCreated: "Bir sohbet oluşturulduğunda",
            whenChatClosed: "Bir sohbet kapatıldığında",
            whenChatRated: "Bir sohbet derecelendirildiğinde",
            whenNewContactCreated: "Yeni bir kişi oluşturulduğunda",
            whenContactUpdate: "Bir kişi güncellendiğinde",
            whenContactPropUpdate: "Bir kişi özelliği güncellendiğinde",
            whenNewTagAdded: "Yeni bir etiket eklendiğinde",
            whenTagRemoved: "Bir etiket kaldırıldığında",
            whenNewEmailReceived: "Yeni bir e-posta alındığında",
            whenNewTaskCreated: "Yeni bir görev oluşturulduğunda",
            whenNewMetaleadCreated: "Yeni bir meta-lider oluşturulduğunda",
            whenNewAgentCreated: "Yeni bir müşteri temsilcisi oluşturulduğunda",
            whenNewInvoiceCreated: "Yeni bir fatura oluşturulduğunda",
            whenNewWpReceived: "Yeni bir WhatsApp mesajı alındığında",
            whenNewReservationCreated: "Yeni bir rezervasyon oluşturulduğunda",
            whenNewChatbotReceived: "Yeni bir chatbot mesajı alındığında",
            chatWebhookAutomation: "Bir Webhook Yakala ve Bir Otomasyon Çalıştır",
            createAnEventAutomation: "Bir Etkinlik Otomasyonu Oluşturun",
            automationName: "Otomasyon Adı",
            supsisObject: "Supsis Objesi",
            selectModule: "Model Seç",
            bodyType: "Gövde Türü",
            selectBodyType: "Gövde Türü Seç",
            selectMethod: "Method Seç",
            trigger: "Tetikleyici",
            published: "Yayınlandı",
            createdAt: "Oluşturuldu",
            action: "Eylem",
            type: "Tür",
            view: "Görüntüle",
            createTimerAutomation: "Zamanlayıcı Otomasyonu Oluştur",
            createEventBasedAutomation: "Olay Tabanlı Otomasyonu Oluştur",
            createWebhookAutomation: "Webhook Otomasyonu Oluştur",
            automationsDeletedSuccessfully: "Otomasyonlar Başarıyla Silindi",
            automationsCouldNotBeDeleted: "Otomasyonlar Silinemedi",
            timerAutomationCreatedSuccessfully: "Zamanlayıcı Otomasyonu Başarıyla Oluşturuldu",
            eventAutomationCreatedSuccessfully: "Olay Otomasyonu Başarıyla Oluşturuldu",
            webhookAutomationCreatedSuccessfully: "Webhook Otomasyonu Başarıyla Oluşturuldu",
            automationsCouldNotBeFetched: "Otomasyonlar Alınamadı",
            automationPublishedStateUpdatedSuccessfully: "Otomasyon Yayın Durumu Başarıyla Güncellendi",
            automationPublishedStateCouldNotBeUpdated: "Otomasyon Yayın Durumu Güncellenemedi",
            automations: "Otomasyonlar",
            allAutomations: "Tüm Otomasyonlar",
            scheduledAutomations: "Zamanlanmış Otomasyonlar",
            eventBasedAutomations: "Etkinlik Tabanlı Otomasyonlar",
            buttonAutomations: "Buton Otomasyonları",
            webhookAutomations: "Webhook Otomasyonları",
            blocks: {
                ADD_TO_SEGMENT: "SEGMENTE EKLE",
                REMOVE_FROM_SEGMENT: "SEGMENTTEN KALDIR",
                START_POINT: "BAŞLANGIÇ NOKTASI",
                AI_ASSISTANT: "YAPAY ZEKA ASISTAN",
                FEEDBACK_AI_ASSISTANT: "Asistana Bilgi Ver",
                BOT_RESPONSE: "BOT'UN YANITI",
                AI_BOT_RESPONSE: "YZ YANIT (GPT-4o)",
                AI_CLASSIFICATION: "YZ SINIFLANDIR",
                AI_MENU_FLOW: "Hazır Menü Flow",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
                PLATFORM_FLOW: "PLATFORM",
                DEFAULT_FALLBACK: "VARSAYILAN AKSİ DURUM",
                DEFAULT_TIMEOUT: "VARSAYILAN Zaman Aşımı",
                AI_FUNCTIONS: "YZ FONKSIYON",
                FILTER: "FİLTRE",
                FLOW: "AKIŞ",
                ATTACHMENT_INPUT: "DOSYA GİRİŞİ",
                USER_INPUT: "KULLANICI GİRİŞİ",
                GO_TO_STEP: "ADIM'A GİT",
                WEBHOOK: "WEB HOOK",
                SET_ATTRIBUTE: "ÖZELLİK AYARLA",
                QUESTION: "SORU",
                CLOSE_CHAT: "SOHBETİ KAPAT",
                CREATE_TICKET: "TICKET OLUŞTUR",
                TICKET_UPDATE: "TICKET GÜNCELLE",
                TRANSFER_CHAT: "SOHBETİ AKTAR",
                TRANSFER_TO_CHATBOT: "CHATBOTA YÖNLENDİR",
                TAG_CHAT: "ETIKET EKLE",
                REMOVE_TAG: "ETIKET SIL",
                SET_DEPARTMENT: "DEPARTMANA AYARLA",
                SEND_TRANSCRIPT: "TRANSKRİPT GÖNDER",
                SEND_SMS: "SMS GONDER",
                SEND_MAIL: "MAIL GONDER",
                CREATE_EVENT: "ETKİNLİK OLUŞTUR",
                CREATE_RESERVATION: "REZERVASYON OLUŞTUR",
                RESERVATION_OPEN_URL: "Rezervasyon Ekranı Görüntüle",
                RESERVATION_SELECT_DAY: "Rezervasyon günü seç",
                RESERVATION_EVENT_LIST: "Müşteri Rezervasyon Listesi",
                RESERVATION_SELECT_TIME: "Rezervasyon saati seç",
                CREATE_TASK: "GÖREV OLUŞTUR",
                UPDATE_TASK: "GÖREV GÜNCELLE",
                SHOPIFY_SHOW_PRODUCTS: "SHOPIFY ÜRÜNLERİ GÖSTER",
                SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY ÜRÜN VARLIĞI",
                SHOPIFY_ORDER_STATUS: "MAĞAZA SİPARİŞ DURUMU",

                AKINON_SHOW_PRODUCTS: "AKINON ÜRÜN GÖSTER",
                AKINON_FIND_PRODUCT: "AKINON ÜRÜN BUL",
                AKINON_ORDER_STATUS: "AKINON SİPARİŞ DURUMU",
                AKINON_SELECT_ORDER: "AKINON SİPARİŞ SEÇ",
                AKINON_SELECT_SIZE: "AKINON BEDEN SEÇ",
                AKINON_FIND_NEAREST_STOCK: "MAĞAZA STOK GÖSTER",
                AKINON_FIND_NEAREST_STORES: "YAKIN MAĞAZALARI GÖSTER",
                AKINON_SHOW_DISCOUNT_CODES: "İNDİRİM KODU GÖSTER",

                IDEASOFT_SELECT_ORDER: "SİPARİŞ SEÇ",
                IDEASOFT_ORDER_STATUS: "SİPARİŞ DURUMU ÇEK",
                IDEASOFT_GET_MEMBER_INFO: "ÜYE DETAY GETİR",

                GET_LOCATION: "KONUM AL",
                FALLBACK: "AKSİ DURUM",
                TIMEOUT: "ZAMAN AŞIMI",
                SUCCESS: "BAŞARILI",
                FAILURE: "BAŞARISIZ",

                PROBEL_SELECT_BRANCH: "Branş Seç",
                PROBEL_SELECT_CLINIC: "Poliklinik Seç",
                PROBEL_SELECT_DAY: "Randevu Günü Seç",
                PROBEL_SELECT_HOUR: "Randevu Saati Seç",
                PROBEL_MAKE_APPOINTMENT: "Randevu Oluştur",
                PROBEL_CANCEL_APPOINTMENT: "Randevu İptal",
                PROBEL_GET_PATIENT_TOKEN: "Hasta Token Al",
                PROBEL_FILL_INFO: "MERNIS Bilgi Getir",
                PROBEL_SELECT_APPOINTMENT: "Randevu Seç",
                SUPPRESSION_ADD: "Kullanıcı Engelle",
                SUPPRESSION_REMOVE: "Kullanıcı Engel Kaldır",
                SEND_WP_BUSINESS_MESSAGE: "WHATSAPP MESAJ GÖNDER",
                INSTAGRAM_COMMENT_REPLY: "Yorumu Yanıtla",
                INSTAGRAM_COMMENT_DELETE: "Yorumu Sil",
                INSTAGRAM_COMMENT_SHOW: "Yorumu Göster",
                INSTAGRAM_COMMENT_HIDE: "Yorumu Gizle",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "Yoruma DM Yanıt",

                ASSIGN_OWNER: "Sahiplik Atama",
                LOOP: "Döngü",
                LOOP_NEXT: "Sıradaki Veri",
                LOOP_BREAK: "Döngüyü Durdur",
                LOOP_CONTINUE: "Sıradakine Ge.",
                LOOP_FINISH: "Döngü Bitti",
                REPLY_TRENDYOL_QUESTION: "Trendyol Soru Cevapla",
                SLEEP: "Uyu ve Bekle",
                NOOP: "Hiçbirşey Yapma",
                CATCH_WEBHOOK: "Webhook Yakala",
                TERMINATE_AUTOMATION: "Otomasyon Sonlandı",
                CREATE_CONTACT: "Kişi Kartı Oluştur",
                UPDATE_CONTACT: "Kişi Güncelle",
                FIND_CONTACTS: "Kişileri Bul",
                FIND_CONTACT: "Kişi Bul",
                FIND_CHATS: "Görüşmeleri Bul",
                FIND_CHAT: "Görüşme Bul",
                WAIT_FOR: "Mesaj Bekle",
                STRING_FORMAT: "Yazıyı Formatla",
                NUMBER_FORMAT: "Sayıları Formatla",
                DATE_FORMAT: "Tarihleri Formatla",
                RECORDS_FROM_CSV: "CSV Kayıt Topla",
                MESSAGE_RECEIVED: "Mesaj Geldi",

                ASK_AI: "Yapay Zeka",

                TABLE_CREATE_RECORD: "Kayıt Oluştur",
                TABLE_DELETE_RECORD: "Kayıt Sil",
                TABLE_UPDATE_RECORD: "Kayıt Güncelle",
                TABLE_FIND_RECORD: "Kayıt Bul",
                TABLE_FIND_RECORDS: "Kayıt Listele",

                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho Kayıt Bul (Telefon ile)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Zoho Kayıta Dosya Ekle",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Zoho Özel Alana Resim Yükle",
                ZOHO_CREATE_RECORD: "Zoho Kayıt Oluştur",

                GET_SUPSIS_RECORD_BY_ID: "Supsis Kayıt Bul (ID ile)",
            },
        },
        tables: {
            today: "Bugün",
            month: "Ay",
            week: "Hafta",
            day: "Gün",
            table: "Tablo",
            kanban: "Kanban",
            calendar: "Takvim",
            colorBy: "Renk Alanı",
            startDateField: "Başlangıç Tarihi Alanı",
            endDateField: "Bitiş Tarihi Alanı (İsteğe Bağlı)",
            eventCardFields: "Etkinlik Kartı Alanları",
            selectColorField: "Renk Alanını Seç",
            selectStartDateField: "Başlangıç Tarihi Alanını Seç",
            cancel: "İptal",
            save: "Kaydet",
            kanbanNotAvailable: "Kanban Görünümü Kullanılamıyor",
            needDropdownField:
                "Kanban görünümünü kullanmak için tablonuzda en az bir statik açılır liste alanına ihtiyacınız var. Tablo ayarlarından yeni bir alan ekleyebilir veya mevcut bir alanı düzenleyebilirsiniz.",
            selectEndDateField: "Bitiş Tarihi Alanını Seç",
            notAvailable: "Takvim Görünümü Kullanılamıyor",
            needDateField:
                "Takvim görünümünü kullanmak için tablonuzda en az bir tarih alanına ihtiyacınız var. Tablo ayarlarından yeni bir alan ekleyebilir veya mevcut bir alanı düzenleyebilirsiniz.",
            switchToTable: "Tablo Görünümüne Geç",
            calendarSettings: "Takvim Ayarları",
            operator: "Operatör",
            conditionalColor: "Koşullu Renk",
            groupField: "Grup Alanı",
            selectDirection: "Yön Seç",
            showEmptyGroups: "Boş Grupları Göster",
            clearGrouping: "Grup Temizle",
            applyGrouping: "Grup Uygula",
            sortDirection: "Sıralama Yönü",
            downloadSelectedRecords: "Seçilmiş Kayıtları İndir",
            viewName: "Görünüm Adı",
            enterViewName: "Görünüm Adı Gir",
            enterDesc: "Açıklama Gir",
            viewNameRequired: "Görünüm Adı Zorunludur.",
            runWebhookAutomation: "Webhook Otomasyonunu Çalıştır",
            downloadAllRecords: "Tüm Kayıtları İndir",
            deleteRecords: "Kayıtları Sil",
            editRecords: "Kayıtları Güncelle",
            duplicateRecords: "Kayıtları Çoğalt",
            selected: "Seçilen",
            sureDeleteRecords: "kayıtları silmek istediğinizden emin misiniz?",
            selectedRecordSucs: "Seçilen kayıtlar başarıyla silindi.",
            errorDeletingRecords: "Kayıtlar silinirken bir hata oluştu.",
            sureCopyRecords: "kayıtları kopyalamak istediğinizden emin misiniz?",
            copyRecords: "Kayıtları Kopyala",
            recordsCopiedSucs: "Seçilen kayıtlar başarıyla kopyalandı.",
            recordsCopiedError: "Seçilen kayıtlar kopyalanırken bir hata oluştu.",
            viewSucsCreated: "Görünüm başarıyla oluşturuldu.",
            editMultipleRecords: "Birden Fazla Kaydı Düzenleme",
            importRecords: "Kayıtları içeri Aktar",
            importHasStarted:
                "İçeri aktarım başladı. Verilerinizin büyüklüğüne göre birkaç dakika sürebilir. Lütfen bekleyin...",
            anErrorImport: "İçeri aktarım sırasında bir hata oluştu.",
            recordCreated: "Kayıt Oluştur",
            recordUpdated: "Kayıt Güncelle",
            recordDeleted: "Kayıt Sil",
            noAutomationDefined: "Henüz otomasyon tanımlanmamış",
            nameTheAutomationAdd: "Bu tabloya kayıt eklendiğinde çalışacak otomasyona isim veriniz:",
            nameTheAutomationUpdate: "Bu tablodaki bir kayıt güncellendiğinde çalışacak otomasyona isim veriniz:",
            nameTheAutomationDelete: "Bu tablodan bir kayıt silindiğinde çalışacak otomasyona isim veriniz:",
            editField: "Alanı Düzenle",
            sort: "Sırala",
            ascending: "Yükselen",
            descending: "Alçalan",
            createField: "Alan Oluştur",
            insertBefore: "Önce Ekle",
            insertAfter: "Sonra Ekle",
            goToRelatedAuto: "İlgili Otomasyona Git",
            permission: "İzin",
            lockField: "Alanı Kilitle",
            hideField: "Alanı Gizle",
            deleteField: "Alanı Sil",
            createNewField: "Yeni Alan Oluştur",
            watchVideo: "Videoyu İzle",
            uploadError: "Yükleme Hatası",
            updateError: "Güncelleme Hatası",
            invalidValue: "Geçersiz değer. Lütfen doğru formatı kullanın.",
            errorUpdatingRecord: "Kayıt güncellenirken hata oluştu.",
            errorCreatingView: "Görünüm oluşturulurken bir hata oluştu.",
            datetimeOptions: "Tarih Saati Seçenekleri",
            numberOptions: "Numara Seçenekleri",
            currencyOptions: "Döviz Opsiyonları",
            dropdownOptions: "Açılır Seçenekler",
            automationButtonOptions: "Otomasyon Butonu Seçenekleri",
            defaultLabel: "Varsayılan Etiket",
            disableWhenClicked: "Tıklandığında Devre Dışı Bırak",
            fieldSucsCreate: "Alan Başarıyla Oluşturuldu",
            fieldCreatingFailed: "Alan oluşturulurken bir hata oluştu",
            fieldSucsUpdate: "Alan Başarıyla Güncellendi",
            fieldUpdatingFailed: "Alan Güncellenirken bir hata oluştu",
            showAll: "Tümümü Göster",
            hideAll: "Tümünü Gizle",
            searchFields: "Arama Alanı",
            firstRowHeader: "İlk Satır Başlık İçerir",
            seperatorCharacter: "Ayırıcı Karakter",
            comma: "Virgül",
            semicolan: "Noktalı Virgül",
            tableFieldOrFileColumns: "Tablo Alanı / Dosya Sütunları Eşleme",
            exampleResultPreview: "Örnek Sonuç Önizlemesi",
            newView: "Yeni Görünüm",
            createViewaFiltering:
                "Ana Tabloyu değiştirmeden filtreleme, sıralama ve alanları gizlemeye devam etmek için Görünümler oluşturun.",
            pleaseUpdateSelected: "Lütfen seçilen kayıtlar için güncellemek istediğiniz alanı seçin.",
            pleaseSelectedNewValue: "Lütfen seçilen alan için yeni değeri girin.",
            selectedMenuItem: "Seçilen menü öğesi:",
            deleteTable: "Tabloyu Sil",
            sureDeleteTable: "Bu tabloyu silmek istediğinizden emin misiniz?",
            deleteTableSucs: "Tablo başarıyla silindi.",
            deleteTableError: "Tablo silinirken hata oluştu:",
            editTable: "Tabloyu Düzenle",
            tables: "Tablolar",
            tableName: "Tablo Adı",
            description: "Açıklama",
            createTable: "Tablo Oluştur",
            createNewTable: "Yeni Tablo Oluştur",
            allTables: "Tüm Tablolar",
            myTables: "Benim Tablolarım",
            myFavorites: "Favorilerim",
            errorCreatingTable: "Tablo oluşturulurken hata oluştu:",
            customerTable: "Müşteri Tablosu",
            customerTableDesc: "Varsayılan müşteri tablosu",
            leadTracking: "Lead Takip",
            leadTrackingDesc: "Potansiyel müşteri izleme tablosu",
            todoList: "Yapılacaklar Listesi",
            todoListDesc: "Görevlerin takibi için liste",
            approvalReq: "Onay İsteği",
            approvalReqDesc: "Onay taleplerinin yönetimi",
            eventSchedule: "Etkinlik Takvimi",
            eventScheduleDesc: "Yaklaşan etkinlikleri planlama",
            inventoryList: "Envanter Listesi",
            inventoryListDesc: "Ürün stoklarını takip eder",
            bookingForm: "Rezervasyon Formu",
            bookingFormDesc: "Rezervasyonların takibi",
            bugTracker: "Hata Takipçisi",
            bugTrackerDesc: "Yazılım hatalarını izleme",
            employeeDirectory: "Çalışan Rehberi",
            employeeDirectoryDesc: "Çalışan bilgilerini içerir",
            errorPullTable: "Tablo verilerini çekerken hata oluştu.",
            newRecordSucs: "Yeni kayıt başarıyla oluşturuldu.",
            failedNewRecord: "Yeni kayıt oluşturulamadı:",
            newRecordCreateError: "Yeni kayıt oluşturulurken bir hata oluştu.",
            recordCount: "Kayıt Sayısı",
            increaseLimit: "Limit Artışı",
            newRecord: "Yeni Kayıt",
            imports: "İçe Aktar",
            exports: "Dışa Aktar",
            download: "İndir",
            automateYourData: "Verilerinizi Otomatikleştirin",
            recordUpdatedSucs: "Kayıt Başarıyla Güncellendi",
            failedToUpdateRecord: "Kayıt Güncellenemedi",
            recordUpdatingError: "Kayıt güncellenirken hata oluştu",
            mainTable: "Ana Tablo",
            filter: "Filtre",
            hideFields: "Alanları Gizle",
            saveAsView: "Görünüm Olarak Kaydet",
            search: "Ara",
            create: "Oluştur",
            left: "Sol",
            center: "Orta",
            right: "Sağ",
            selectTimezone: "Saat dilimini seçin",
            createFieldSucs: "Alan başarıyla oluşturuldu.",
            failedCreateField: "Alan Oluşturulamadı:",
            createFieldError: "Alan oluşturulurken bir hata oluştu.",
            addCondition: "Koşul Ekle",
            applyFilter: "Filtre Uygula",
            fieldType: "Alan Türü",
            alignment: "Hizalama",
            blankTable: "Boş Tablo",
            templates: "Şablonlar",
            timezone: "Zaman Dilimi",
            timeFormat: "Zaman Formatı",
            includeTime: "Zaman Dahil",
            decimalFormat: "Ondalık Biçim",
            currencySymbol: "Para Birimi Sembolü",
            mode: "Mod",
            statics: "Statik",
            dynamic: "Dinamik",
            multipleSelection: "Çoklu Seçim",
            addOption: "Seçenek Ekle",
            text: "Metin",
            longText: "Uzun Metin",
            number: "Numara",
            currency: "Para Birimi",
            datetime: "Tarih & Zaman",
            dropdown: "Açılır Liste",
            checkbox: "Onay Kutusu",
            email: "E-posta",
            phone: "Telefon",
            file: "Dosya",
            image: "Resim",
            video: "Video",
            audio: "Ses",
            color: "Renk",
            automationButton: "Otomasyon Butonu",
        },
        modules: {
            createFailed: "Modül oluşturma başarısız",
            createSuccess: "Modül başarıyla oluşturuldu",
            moduleDeletedSuccessfully: "Modül başarıyla silindi.",
            deleteModuleTitle: "Modülü Sil",
            deleteModuleContent: "Bu modülü silmek istediğinizden emin misiniz?",
            modules: "Modüller",
            modulesSettings: "Modül Ayarları",
            displayName: "Görünen İsim",
            description: "Açıklama",
            table: "Tablo",
            menuApiSettings: "Menü ve API Ayarları",
            icon: "İkon",
            save: "Kaydet",
            exampleIcon: "Örn: extension, home",
            newModule: "Yeni Modül Oluştur",
            moduleName: "Modül Adı",
            apiName: "API Adı",
            type: "Tür",
            apiAccess: "API Erişimi",
            actions: "Aksiyonlar",
            module: "Modül",
            relation: "İlişki",
            moduleRelationName: "Modül/İlişki Adı",
            moduleRelationTable: "Modül/İlişki Tablosu",
            settings: "Ayarlar",
            showInMainMenu: "Ana Menüde Göster",
            apiEnabled: "API Etkin",
            createModule: "Modül Oluştur",
            relationType: "İlişki Türü",
            standartModule: "Standart Modül",
            customTable: "Özel Tablo",
            localField: "İlişkilendirilecek Alan",
            showingRemoteFieldInList: "Listede Uzak Alanı Göster",
            relationSettings: "İlişki Ayarları",
            remoteField: "Uzak Alan",
            localFieldType: "Yerel Alan Türü",
            standart: "Standart",
            custom: "Özel",
            contact: "Kişi",
            viewRecord: "Kayıtı Görüntüle",
            recordDetail: "Kayıt Detayı",
            recordNotFound: "Kayıt veya tablo bilgisi bulunamadı",
            relatedLists: "İlgili Listeler",
            recordViewer: "Kayıt Görüntüleyici",
        },
        plans: {
            manageWithChatbot: "Chatbot ile Yönetim",
            manageInbox: "Gelen Kutusu Yönetin",
            commentManagement: "Yorumları Yönetin",
            privateReplyMessage: "Yorumlara Özel'den Yanıt",
            mentionTicket: "Etkileri Ticket'a Dönüştürün",
            week: "Hafta",
            readyContents: "Hazır İçerikler",
            webhookIntegration: "Webhook Entegrasyonu",
            businessChannel: "Whatsapp Business Kanalı",
            confirmationFeature: "Yetkilendirme Özelliği",
            specialReporting: "Özel Rapolama",
            aiAssistant: "Yapay Zeka Asistan",
            flexibleBilling: "Esnek Faturalandırma",
            automaticReservation: "Otomatik Rezervasyon",
            taskManagement: "Görev Yönetimi",
            calendarIntegration: "Takvim Entegrasyonu",
            activeChatbot: "Aktif Chatbot",
            smsIntegration: "SMS Entegrasyonu",
            mailIntegration: "Mail Entegrasyonu",
            startChatWithVisitor: "Ziyaretçi ile Chat Başlatma",
            whatsappManaging: "Whatsapp Yönetimi",
            automaticChatbotButton: "Otomatik Buton/Chatbot",
            personalizedBroadcasts: "Kişiselleştirilmiş Yayın Mesajları",
            chatWithNonContacts: "Kayıtlı Olmayan Numaralarla Mesajlaşma",
            broadcastMessaging: "Toplu Mesaj Gönderme",
            perBroadcast: "Toplu Mesaj Başına",
            extraPricePerMessage: "Mesaj Başına Ek Ücret",
            smartTrigger: "Akıllı Tetikleyici",
            telegramIntegration: "Telegram Entegrasyonu",
            instagramIntegration: "Instagram Entegrasyonu",
            ticketFeature: "Ticket Sistemi",
            storage: "Depolama",
            onePanelManagement: "Tek Panelden Yönetim",
            isolatedDatabaseConnection: "İzole Veritabanı Bağlantısı",
            removeLogo: "Supsis Logo Kaldırma",
            chatBaloonCustomization: "Chat balonu özelleştirme",
            chatAndNotifications: "Chat Ve Bildirimler",
            unlimited: "Sınırsız",
            specialCustomerSupport: "Özel Müşteri Desteği",
            softwareSupport: "Yazılım Desteği",
            standardSupport: "Standart Destek",
            teamChatIntegration: "Takım Konuşması Entegrasyonu",
            fileAndVoiceShare: "Dosya ve Ses Paylaşımı",
            instantVisitor: "Anlık Ziyaretçi Takibi",
            detailedReporting: "Detaylı Raporlama",
            normalreporting: "Normal Raporlama",
            noExtraCosts: "Ek Maliyet Gerektirmez",
            accessibleToAllAgents: "Tüm Temsilciler İçin Erişim",
            dataSecurity: "Veri Güvenliği",
            autoTranslate: "Otomatik Çeviri",
            chatbotVersionHistory: "Chatbot Sürüm Geçmişi",
            chatbotStory: "Chatbot Hikayesi",
            freeAgent: "Ücretsiz Temsilci",
            stableAgentCount: "Sabit Temsilci Sayısı",
            stableChannelCount: "Sabit Kanal Sayısı",
            chipPlans: "Uygun Fiyatlı Planlar",
            generalPlan: "Genel Plan",
            specialPlan: "Özel Plan",
            currentPlan: "Mevcut Plan",
            selected: "Seçildi",
            popular: "Popüler",
            trialPkg: "Deneme Paketi",
            support: "7/24 Destek",
            flexiblePricing: "Esnek Fiyatlandırma",
            rightToCancel: "İstenilen Gün Paket İptali",
            unlimitedCBScenario: "Sınırsız Chatbot Senaryosu",
            freeFirstScenario: "Ücretsiz İlk Senaryo",
            unlimitedLearn: "Sınırsız Chatbot Eğitimi",
            allPlatformIntegration: "Tüm Platformlarla Entegrasyon",
            detailedReports: "Detaylı Rapor",
            aiSupport: "Yapay Zeka Desteği",
            creativeAI: "Hızlı ve Gerçekçi AI Chat Asistanı",
            unlimitedSession: "Aynı Anda Sınırsız Oturum",
            assistantFromWebsite: "Web Siteden Asistan Oluşturma",
            assistantFromDoc: "Dökümandan Chatbot Oluşturma",
            mobileApp: "Mobil Uygulama",
        },
        messenger: {
            channel: "Messenger Kanalı",
            manageChannel: "Messenger Kanalını Yönet",
            channelDetail: "Messenger Detayı",
            integrationTitle: "Messenger Entegrasyonu",
            deleteDesc: "Messenger kanalını silmek istediğinizden emin misiniz?",
            channels: "Messenger Kanalları",
            connectMessenger: "Messenger'a Bağlan",
            detail: "Detay",
            visibility: "Görünürlük",
            settings_group: "Ayarlar",
            commentsettings: "Yorum Yönetimi",
            commentSettingsTitle: "Messenger Yorum Yönetimi",
            commentSettingsDesc: "Messenger yorumlarınızı yönetin",
        },
        instagram: {
            brand: "Marka",
            questions: "Sorular",
            channel: "Instagram Kanalı",
            detail: "Detay",
            visibility: "Görünürlük",
            settings_group: "Ayarlar",
            commentsettings: "Yorum Yönetimi",
            commentSettingsTitle: "Instagram Yorum Yönetimi",
            commentSettingsDesc: "Instagram yorumlarınızı yönetin",
            commentSettingsTicket: "Gelen yorumların sistemde ticket olarak kaydedilmesini sağlar.",
            commentSettingsChatbot: "Kanala gelen yorumların hangi chatbot senaryosuna yönlendirileceğini seçiniz.",
            leads: "Leads",
            forms: "Forms",
            showAllInstagramChannels: "Tüm Instagram Kanallarını Göster",
        },
        calendar: {
            calendars: "Takvimler",
            calendarsDesc: "Program çakışmalarını önleyin.",
            generalAvailability: "Genel Müsaitlik Durumu",
            generalAvailabilityDesc: "Randevular için düzenli olarak müsait olduğunuz zamanları belirtin.",
            appointDuration: "Randevu süresi",
            appointDurationDesc: "Her randevu ne kadar sürmelidir?",
            customDuration: "Özel Süre",
            description: "Açıklama",
            descriptionDesc:
                "Hizmetinizi açıklayan bir not ekleyin. Eklediğiniz not, rezervasyon sayfanızda ve onay e-postalarında görünecektir.",
            resForm: "Rezervasyon Formu",
            resFormDesc: "Kişilerin randevu almak için kullanacağı formu özelleştirin.",
            addField: "Alan Ekle",
            addAnItem: "Bir Öğe Ekleyin",
            saveItem: "Öğeyi Kaydet",
            planningTimeframe: "Planlama Zaman Aralığı",
            planningTimeframeDesc: "Randevu alınabilecek zaman aralığını sınırlayın.",
            availableAtMoment: "Şuanda Müsait",
            startAndEndDate: "Başlangıç ve bitiş tarihleri",
            maxNumberAppoint: "En fazla kaç gün sonrası randevu alınabileceği",
            howLongMinAppoint: "Randevunun başlangıcından minimum ne kadar süre önce randevu alınabileceği",
            planingIntervalStartEnd: "Planlama aralığı başlangıç ve bitiş tarihleri",
            startTime: "Başlangıç Zamanı",
            done: "Bitti",
            never: "Asla",
            receivedAppointInterval: "Alınmış Randevu Aralığı",
            receivedAppointIntervalDesc: "Takviminizde görünecek alınmış randevuları yönetin.",
            interimTime: "Ara zaman",
            interimTimeDesc: "Toplantı aralıklarının arasına zaman ekleyin",
            dayMaxRes: "Günlük maksimum rezervasyon sayısı",
            dayMaxResDesc: "Tek bir günde kabul edilebilecek, alınmış randevu sayısını sınırlandırın",
            customize: "Özel Ayarla",
            noAvatar: "Avatar Yok",
            organizationName: "Organizasyon Adı",
            enterFullAdress: "Tam adresi girin",
            noCoverPhoto: "Kapak fotoğraf yok",
            enterAboutInfo: "Hakkında bilgilerini girin",
            service: "Servis",
            deleteService: "Hizmeti Sil",
            enterGoogleMapsUrl: "Google Maps URL'sini girin",
            enterLatitude: "Enlem girin",
            enterLongitude: "Boylam girin",
            enterNumber: "Telefon numarasını girin",
            uploadAvatar: "Avatar Yükle",
            teamMemberDeleteError: "Ekip üyesi silinirken hata oluştu:",
            setupBookingWebsite: "Rezervasyon Website'sini Kur",
            bookingLandingPageBuilder: "Rezervasyon Açılış Sayfası Oluşturucu",
            coverPhoto: "Kapak Fotoğrafı",
            enterOrganizationName: "Organizasyon adını girin",
            about: "Hakkında",
            services: "Hizmetler",
            deleteServices: "Hizmeti Sil",
            selectReservationPlan: "Rezervasyon Planı Seç",
            addNewService: "Yeni Servis Ekle",
            addNewMember: "Yeni Üye Ekle",
            fullAddress: "Tam Adres",
            latitude: "Enlem",
            longitude: "Boylam",
            contactDetails: "İletişim Bilgileri",
            emailAddress: "E-posta Adresi",
            enterEmail: "E-posta adresini girin",
            websiteURL: "Websitesi URL",
            enterWebsiteURL: "Websitesi URL'sini girin",
            reservationPolicy: "Rezervasyon Politikası",
            enterResPolicy: "Rezervasyon politikasını girin",
            workingHours: "Çalışma Saatleri",
            selectEndHour: "Bitiş Saatini Seçin",
            addNewHour: "Yeni Saat Ekle",
            updateMemberInfo: "Üye Bilgilerini Güncelle",
            errorRecevingData: "Veri alınırken hata oluştu:",
            anonymService: "İsimsiz Hizmet",
            unknownPlan: "Bilinmeyen Plan",
            errorCreatingMockPage: "Mock sayfa oluşturulurken hata oluştu:",
            failedToCreateBookingPage: "Rezervasyon sayfası oluşturulamadı",
            fileSizeToolLarge: "Dosya boyutu çok büyük",
            errorLoadingTheLogo: "Logo yüklenirken hata oluştu:",
            failedToLoadLogo: "Logo yüklenemedi",
            errorUpdating: "Güncellenirken hata oluştu:",
            failedToUpdate: "Güncellenemedi",
            newMember: "Yeni Üye",
            errorLoadingAvatar: "Avatar yüklenirken hata oluştu:",
            avatarFailedToLoad: "Avatar yüklenemedi",
            teamMemberSuccessfullyDeleted: "Ekip üyesi başarıyla silindi",
            teamMemberNotDelete: "Ekip üyesi silinemedi",
            yesDelete: "Evet, Sil",
            sureResDelete: "Bu rezervasyonu silmek istediğinizden emin misiniz?",
            resDetails: "Rezervasyon Detayları",
            infoPersonMakingRes: "Rezervasyon Yapan Kişinin Bilgileri",
            appointmentProgram: "Randevu Programı",
            goToAppointSettings: "Randevu Programı Ayarlara Git",
            resPlanCreateSuccess: "Rezervasyon planı başarıyla oluşturuldu",
            pleaseEnterTitle: "Lütfen başlık giriniz",
            sureContinueSaving: "Kaydetmeden devam etmek istediğinize emin misiniz ?",
            appointProgram: "RADEVU PROGRAMI",
            everyMonth: "Her ayın",
            firstEveryMonth: "Her ayın ilk",
            dayOf: "Günü",
            notRepeat: "Tekrarlamaz",
            daily: "Hergün",
            weely: "Haftada bir",
            monthly: "Ayda bir",
            annualy: "Yılda bir",
            custom: "Özel",
            eventSaved: "Etkinlik Kaydediliyor",
            createAppoint: "Randevu Oluştur",
            calendarSetting: "Takvim Ayarları",
            notAuthezord: "Bu işlemi yapmaya yetkiniz yok",
            reservationWebPage: "Reservasyon Web Sayfası",
            reservationPrograms: "Rezervasyon Programları",
            addReservationProgram: "Rezervasyon Programı Ekle",
            resPlanError: "Rezervasyon planları alınırken hata oluştu:",
            resDeleteSure: "Bu rezervasyon programını silmek istediğinize emin misiniz?",
            resDeleteSuccess: "Rezervasyon programı başarıyla silindi.",
            resDeleteError: "Rezervasyon programı silinirken hata oluştu:",
            unkownUser: "Bilinmeyen Kullanıcı",
            eventNotFound: "Etkinlik Bulunamadı",
            reservations: "Rezervasyonlar",
            events: "Etkinlikler",
            upcoming: "Yaklaşan",
            past: "Geçmiş",
            setting: "Ayarlar",
            delete: "Sil",
            cancel: "Vazgeç",
            save: "Kaydet",
            close: "Kapat",
            deleteRepeatEvent: "Düzenli etkinliği silin",
            thisEvent: "Bu etkinlik",
            thisAndOtherEvent: "Bu ve takip eden etkinlikler",
            allEvent: "Tüm etkinlikler",
            ok: "Tamam",
            googleCalendarLink: "Google Takvime Ekle",
            yahooCalendarLink: "Yahoo Takvime Ekle",
            subject: "Konu",
            visitor: "Ziyaretçi",
            allDay: "All Day",
            title: "Başlık",
            deleteEvent: "Etkinliği Sil",
            deleteEvents: "Etkinlikleri Sil",
            deleteEventsSure: "Bu takvime ait etkinlikleri silmek istediğinize emin misiniz?",
            deleteEventConfirm: "Etkinliği silmek istediğinize emin misinz?",
            notEmptyTitle: "Başlık boş bırakılamaz!",
            tasks: "Görevler",
            googleConnect: "Google Entegrasyonu",
            googleDisconnect: "Google Entegrasyon Bağlantısını Kaldır",
            sure: "Emin misin?",
            disconnectGoogleSure: "Google bağlantısını kaldırmak istediğinden emin misin?",
            yes: "Evet",
            no: "Hayır",
            customRepeat: "Özel Yineleme",
            recurrenceFrequency: "Yineleme Sıklığı:",
            repeatDays: "Şu günlerde yinele:",
            thisDate: "Şu Tarihte:",
            recurrenceCount: "Yinelenme sayısı:",
            end: "Bitiş",
            event: "Etkinlik",
            newCalendar: "Yeni Takvim Oluştur",
            changeColor: "Renk Değiştir",
            addCalendar: "Takvim Ekle",
            nameCalendar: "Takvim Adı",
            change: "Değiştir",
            deleteCalendar: "Delete Calandar",
            deleteCalendarSure: "Takvimi silmek istediğinize emin misiniz?",
            notEmptyCalendarName: "Takvim adı boş olamaz",
            myEvents: "Etkinliklerim",
            everyoneEvents: "Tüm Etkinlikler",
            haveEvent: " temsilcisine ait etkinlikler",
            goCalendar: " Takvime Git",
            goReservation: " Rezervasyon Oluştur",
            agents: " Temsilciler",
            today: "Bugün",
            month: "Ay",
            week: "Hafta",
            day: "Gün",
            list: "Liste",
        },
        ticimax: {
            segment: "Segment",
            settings_group: "Ayar",
            waitDayFromLastSend: "Son Gönderilen Mesajdan İtibaren Bekleme Günü Sayısı",
            automationRuleName: "Otomasyon Kuralı Adı",
            time: "Saat",
            year: "Yıl",
            month: "Ay",
            dayOfMonth: "Ayın Günü",
            day: "Gün",
            bySecond: "Saniyeye Göre",
            byMinute: "Dakikaye Göre",
            byHour: "Saate Göre",
            byWeekNo: "Hafta Sayısı",
            byYearDay: "Yılın Günü",
            byMonthDay: "Ayın Günü",
            byMonth: "Aya Göre",
            december: "Aralık",
            november: "Kasım",
            october: "Ekim",
            september: "Eylül",
            august: "Ağustos",
            july: "Temmuz",
            june: "Haziran",
            may: "Mayıs",
            april: "Nisan",
            march: "Mart",
            february: "Şubat",
            january: "Ocak",
            byWeekDay: "Güne Göre",
            interval: "Aralık",
            seconds: "Saniyelik",
            minutes: "Dakikalık",
            hourly: "Saatlik",
            daily: "Günlük",
            weekly: "Haftalık",
            monthly: "Aylık",
            yearly: "Yıllık",
            frequency: "Sıklık",
            attributes: {
                vip: "VIP",
                segment: "Segment",
                province: "Şehir",
                country: "Ülke",
                phone: "Telefon",
                email: "E Posta",
                fullname: "Tam İsim",
                couponPercent: "Kupon %",
                lastOrderDate: "Son Sipariş",
                firstOrderDate: "İlk Sipariş",
                county: "ilçe",
                lastSource: "Son Kaynak",
                firstSource: "İlk Kaynak",
                lastPaymentType: "Son Ödeme Yöntemi",
                firstPaymentType: "İlk Ödeme Yöntemi",
                maxOrderAmount: "En Çok Sipariş Tutarı",
                minOrderAmount: "En Az Sipariş Tutarı",
                totalOrderAmount: "Toplam Sipariş Tutarı",
                totalOrderCount: "Toplam Sipariş Sayısı",
                usedCouponAmount: "Kupon Miktarı",
                usedCouponCount: "Kupon Sayısı",
                tookDayFromLastOrder: "Son Siparişten Geçen Gün",
                isCouponUser: "Kupon kullanıcısı?",
            },
            createAutomation: "Otomasyon Oluştur",
            previous: "Önceki",
            createAutomationDesc: "Mesaj otomasyonununuzu oluşturun ve yönetin",
            newTicimaxChannel: "Yeni Ticimax Kanalı",
            connextToTicimaxXml: "Ticimax XML Servisine Bağlan",
            connectTicimax: "Ticimax'a Bağlan",
            examplePreview: "Örnek Önizleme",
            completeAutomationRule: "Otomasyon Kuralını Tamamla",
            configureMessage: "Mesajı Yapılandır",
            automationTimer: "Otomasyon Zamanlayıcı",
            findTargetMembers: "Hedef Kişileri Bul",
            createAutomationRule: "Otomasyon Kuralı Oluştur",
            action: "Aksiyon",
            status: "Durum",
            triggeredUserCount: "Tetiklenmiş kullanıcı sayısı",
            nextScheduled: "Sonraki Tetikleme",
            timerRule: "Zamanlama Kuralı",
            automationRules: "Otomasyon Kuralları",
            apply: "Uygula",
            searchAMember: "Bir kişi ara",
            segmentedMembersDesc: "Segmente edilmiş kişilerinizi listeleyin ve otomatize edin",
            manageVisibilityDesc: "Kanalı kimlerin görebileceğini yönet",
            xmlOrderListURL: "XML sipariş listesi URL",
            manageIntegrationDesc: "Ticimax entegrasyonunuzu yönetin",
            detail: "Detay",
            ticimaxChannelsTitle: "Ticimax Kanalları",
            ticimaxDetail: "Ticimax Detay",
            settingsGroup: "Ayarlar",
            visibility: "Görünürlük",
            members: "Kişiler",
            automation: "Otomasyon",
            integrationChannel: "Entegrasyon Kanalı",
            channelUpdated: "Kanal Başarıyla Güncellendi",
            channelUpdateFailed: "Kanal Güncellemesi Başarısız",
        },
        notification: {
            contactOwner: "Chat Sahibi Değiştirme, Sahip Atama ve Sahip Kaldırma",
            mobileApp: "Mobil Uygulama",
            webPanel: "Web Paneli",
            notifications: "Bildirimler",
            whatsappActions: "Whatsapp Aksiyonları",
            chatbotActions: "Chatbot Aksiyonları",
            companyActions: "Şirket Aksiyonları",
            crmActions: "SUPSIS CRM ACTIONS",
            basicActions: "Temel Aksiyonlar",
            notificationSettingsDesc:
                "Hangi bildirimleri almak istediğinizi ve bunları nerede almak istediğinizi seçin.",
            noNotificationDesc2:
                "Burada takip ettiğiniz işler, adaylar ve yetenek havuzlarıyla ilgili tüm bildirimler görüntülenecektir. Bildirimleri ayarları düzenleyerek ayarlayabilirsiniz.",
            noNotificationTitle2: "Henüz bildirim yok.",
            noNotificationTitle1: "Bildirim yok. Sessizliğin tadını çıkarın.",
            adjustSettings: "Ayarları düzenle",
            showAll: "Tümünü göster",
            showOnlyUnread: "Sadece okunmayanları göster",
            mailWasSent: "Mail Gönderildi.",
            mailAdressRemoved: "Mail adresi kaldırıldı.",
            chatbotPublished: "Chatbotun <b>{version}</b> versiyonu <b>{user}</b> tarafından yayınlandı.",
            chatbotDeleted: "<b>{chatbot}</b> isimli chatbot <b>{user}</b> tarafından silindi.",
            settingsUpdatedWoDetail: "Ayarlar <b>{user}</b> tarafından güncellendi.",
            noActivityDesc: "Şu anda sistemde herhangi bir hareket bulunmuyor. Birkaç olayın gerçekleşmesi gerekiyor",
            noActivityTitle: "Henüz hareket yok",
            actionType: "Hareket Tipi",
            dateBetween: "Zaman aralığı",
            selectActor: "Kullanıcı Seçimi",
            activities: "Hareketler",
            chatbotCreated: "<b>{chatbot}</b> isimli chatbot <b>{user}</b> tarafından oluşturuldu.",
            taskStageChanged:
                "<b>{task}</b> görevinin <b>{oldStage}</b> olan durumu <b>{user}</b> tarafından <b>{newStage}</b> olarak değiştirildi.",
            taskCreated: "<b>{task}</b> görevi <b>{user}</b> tarafından oluşturuldu.",
            contactPropRemoved: "<b>{prop}</b> ziyaretçi bilgisi <b>{user}</b> tarafından kaldırıldı.",
            contactPropAdded: "<b>{prop}</b> ziyaretçi bilgisi <b>{user}</b> tarafından oluşturuldu.",
            userRemoved: "<b>{oldUser}</b> kullanıcısı <b>{user}</b> tarafından silindi",
            loginFormUpdated: "Ziyaretçi giriş formu <b>{user}</b> tarafından güncellendi.",
            loginFormDeactivated: "Ziyaretçi giriş formu <b>{user}</b> tarafından devre dışı bırakıldı.",
            loginFormActivated: "Ziyaretçi giriş formu <b>{user}</b> tarafından aktif edildi.",
            invoiceRefunded: "İade işlemi <b>{user}</b> tarafından yapıldı.",
            paymentMethodAdded: "Yeni bir ödeme yöntemi <b>{user}</b> tarafından eklendi.",
            invoicePaymentFailed: "Fatura ödeme işlemi <b>{user}</b> tarafından kabul edilmedi.",
            invoicePaymentReceived: "Fatura ödeme işlemi <b>{user}</b> tarafından kabul edildi.",
            planStarted: "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>({altTitle})</b> aboneliğini başlattı.",
            planStartedAgent:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({details} Temsilci)</b> aboneliğini başlattı.",
            planStartedChatbot:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({chatbot} Session)</b> aboneliğini başlattı.",
            planStartedWhatsapp:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({whatsapp} Whatsapp Channels)</b> aboneliğini başlattı.",
            planStartedWhatsappApi:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({whatsappApi} Whatsapp Business Channels)</b> aboneliğini başlattı.",
            PlanCanceled: "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>({altTitle})</b> aboneliğini iptal etti.",
            planCanceledAgent:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({details} Temsilci)</b> aboneliğini iptal etti.",
            planCanceledChatbot:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({chatbot} Session)</b> aboneliğini iptal etti.",
            planCanceledWhatsapp:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({whatsapp} Whatsapp Channels)</b> aboneliğini iptal etti.",
            planCanceledWhatsappApi:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({whatsappApi} Whatsapp Business Channels)</b>  aboneliğini iptal etti.",
            invoiceCreated: "Fatura <b>{user}</b> tarafından oluşturuldu.",
            billingAddressUpdated: "Adres bilgileri <b>{user}</b> tarafından güncellendi",
            taskWorkflowDeleted: "<b>{workflow}</b> iş akışı <b>{user}</b> tarafından silindi.",
            whatsappBroadcastFailed: "<b>{title}</b> başlıklı toplu mesaj gönderimi başarısız oldu.",
            whatsappBroadcastCancelled: "<b>{title}</b> başlıklı toplu mesajın gönderimi iptal edildi.",
            whatsappBroadcastCompleted:
                "<b>{title}</b> başlıklı toplu mesaj <b>{numbers}</b> kişiye başarıyla gönderildi.",
            whatsappBroadcastCreated:
                "<b>{title}</b> başlıklı toplu mesaj <b>{user}</b> tarafından <b>{numbers}</b> kişiye gönderildi.",
            ticketAssigned: "<b>{user2}</b> kisisine <b>{user1}</b> tarafından ticket atandı.",
            userLoggenIn: "<b>{user}</b> SUPSIS'e giriş yaptı.",
            chatJoined: "<b>{visitor}</b> ile olan görüşmeye <b>{agent}</b> katıldı.",
            chatForwarded:
                "<b>{visitor}</b> ile olan görüşme <b>{user}</b> tarafından <b>{agent}</b> temsilcisine aktarıldı. ",
            chatAssigned:
                "<b>{visitor}</b> ile olan görüşme sistem tarafından <b>{agent}</b> temsilcisine yönlendirildi.",
            customerGroupUpdated: "<b>{group}</b> isimli grup <b>{user}</b> tarafından güncellendi.",
            customerGroupRemoved: "<b>{group}</b> isimli grup <b>{user}</b> tarafından silindi.",
            customerGroupAdded: "<b>{group}</b> isimli grup <b>{user}</b> tarafından oluşturuldu.",
            contentRemoved: "<b>{content}</b> hazır içeriği <b>{user}</b> tarafından kaldırıldı.",
            contentAdded: "<b>{content}</b> hazır içeriği <b>{user}</b> tarafından eklendi.",
            channelVisibilityChanged:
                "<b>{channel}</b> entegrasyon kanalının görünürlüğü <b>{user}</b> tarafından değiştirildi.",
            taskDeleted: "<b>{task}</b> görevi <b>{user}</b> tarafından silindi.",
            userRemovedToDepartment:
                "<b>{user2}</b> kullanıcısı <b>{user1}</b> tarafından <b>{department}</b> departmanından çıkarıldı.",
            userAddedToDepartment:
                "<b>{user2}</b> kullanıcısı <b>{user1}</b> tarafından <b>{department}</b> departmanına eklendi.",
            mailAddressAdded: "<b>{email}</b> mail adresi <b>{user}</b> tarafından eklendi",
            settingUpdate: "<b>{user}</b> tarafından güncellendi:",
            taskWFlowCreated: "<b>{Wflow}</b> iş akışı <b>{user}</b> tarafından oluşturuldu.",
            bannedWordRemoved: "<b>{bWord}</b> yasaklı kelimesi <b>{user}</b> tarafından silindi.",
            bannedWordCreated: "<b>{bWord}</b> yasaklı kelimesi <b>{user}</b> tarafından eklendi.",
            welcomeMessageRemoved: "<b>{welcome}</b> karşılama mesajı <b>{user}</b> tarafından silindi.",
            welcomeMessageAdded: "<b>{welcome}</b> karşılama mesajı <b>{user}</b> tarafından oluşturuldu.",
            tagRemoved: "<b>{tag}</b> etiketi <b>{user}</b> tarafından kaldırıldı.",
            tagAdded: "<b>{tag}</b> etiketi <b>{user}</b> tarafından eklendi.",
            roleRemoved: "<b>{role}</b> rolü <b>{user}</b> tarafından kaldırıldı.",
            roleAdded: "<b>{role}</b> rolü <b>{user}</b> tarafından eklendi.",
            departmentRemoved: "<b>{department}</b> departmanı <b>{user}</b> tarafından silindi.",
            departmentAdded: "<b>{department}</b> departmanı <b>{user}</b> tarafından eklendi.",
            triggerUpdated: "Bir tetikleyici <b>{user}</b> tarafından güncellendi.",
            triggerRemoved: "Bir tetikleyici <b>{user}</b> tarafından kaldırıldı.",
            triggerAdded: "Yeni bir tetikleyici <b>{user}</b> tarafından oluşturuldu.",
            webhookRemoved: "<b>{user1}</b> ait webhook, <b>{user2}</b> tarafından kaldırıldı.",
            webhookAdded: "<b>{user1}</b> tarafından eklenen webhook, <b>{user2}</b> tarafından eklendi.",
            chatClosed: "<b>{visitor}</b> ile olan konuşma <b>{agent}</b> tarafından sonlandırıldı.",
            chatOwnerUpdated:
                "<b>{agent}</b> temsilcisi <b>{visitor}</b> ziyaretcisini <b>{oldOwner}</b> temsilcisinden <b>{newOwner}</b> temsilcisine sahip olarak atadı.",
            customerOwnershipRemoved:
                "<b>{actor}</b>, <b>{visitor}</b> isimli müşteriyi sahipliğini <b>{oldOwner}</b> iken sahipsiz yaptı.",
            customerOwnershipAssigned:
                "<b>{actor}</b>, <b>{visitor}</b> isimli müşterinin sahiplik durumunu sahipsizden <b>{newOwner}</b> olarak atadı.",
            customerOwnershipReassigned:
                "<b>{actor}</b>, <b>{visitor}</b> isimli müşterisinin sahiplik durumunu <b>{oldOwner}</b> sahipken <b>{newOwner}</b> olarak atadı.",
            chatOpenedByAgent:
                "<b>{visitor}</b> ile bir <b>{platform}</b> konuşması <b>{agent}</b> tarafından başlatıldı.",
            chatOpenedByVisitor: "Bir <b>{platform}</b> konuşması <b>{visitor}</b> tarafından başlatıldı.",
            channelRemoved: "<b>{channel}</b> kanalı <b>{agent}</b> tarafından silindi.",
            userAdded: "<b>{newAgent}</b> isimli temsilci <b>{agent}</b> tarafından oluşturuldu.",
            visitorUnblocked: "<b>{visitor}</b> isimli ziyaretçinin engeli <b>{agent}</b> tarafından kaldırıldı.",
            visitorBlocked: "<b>{visitor}</b> isimli ziyaretçi <b>{agent}</b> tarafından engellendi.",
            userStatusChanged:
                "<b>{name}</b> isimli temsilci <b>{oldStatus}</b> olan durumunu <b>{newStatus}</b> olarak değiştirdi.",
            channelCreated: "<b>{channel}</b> isimli kanal <b>{name}</b> tarafından oluşturuldu.",
            reservationCreatedPlan:
                "<b>{name}</b> Kullanıcıs, <b>{title}</b> adlı randevuyu <b>{date}</b> tarihine planladı.",
            reservationUpdatedPlan: "<b>{name}</b> Kullanıcısı, <b>{title}</b> randevusunu güncelledi.",
            reservationDeletedPlan: "<b>{name}</b> Kullanıcısı, <b>{title}</b> adlı randevuyu sildi.",
            reservationCreated:
                "<b>{name}</b> Kullanıcısı ve <b>{visitor}</b> ziyaretçisi ile <b>{date}</b> tarihine randevu oluşturuldu.",
            reservationDeleted:
                "<b>{name}</b> Kullanıcısı ve <b>{visitor}</b> ziyaretçisi arasında planlanan <b>{date}</b> tarihli randevu iptal edilmiştir.",
            chatAssignedMe: "Bir sohbet bana atanınca",
            ticketAssignedMe: "Bir ticket bana atanınca",
            taskAssignedMe: "Bir görev bana atanınca",
            myChatClosed: "Sahip olduğum bir sohbet kapatıldığında",
            tagActionsToVisitor: "Bir ziyaretçiye etiket eklendi veya kaldırıldı",
            ticketCreated:
                "Ziyaretçi veya sohbet botu bir bilet oluşturdu. Ayrıca, sohbet widget'ından çevrimdışı ileti gönderildiğinde",
            notesActions: "Bir müşteriye not eklendi ya da kaldırıldı.",
            visitorProfileUpdated: "Ziyaretçi profili güncellendi",
            chatStartedByAnyPlatform: "Herhangi bir platformda ziyaretçi veya temsilci tarafından sohbet başlatıldı",
            userActions: "Kullanıcı oluşturuldu, güncellendi veya silindi",
            departmentActions: "Departman oluşturuldu, güncellendi veya silindi",
            settingsActions: "Ayarlar oluşturuldu, güncellendi veya silindi",
            integrationsActions: "Entegrasyon kanalı oluşturuldu, güncellendi veya silindi",
            loginFormActions: "Giriş formu güncellendi veya etkinleştirildi veya devre dışı bırakıldı",
            bannedWordActions: "Yasaklanan kelime oluşturuldu, güncellendi veya silindi",
            emailActions: "E-posta hesabı oluşturuldu veya silindi",
            preparedContentActions: "Hazırlanan içerik oluşturuldu veya silindi",
            roleActions: "Rol oluşturuldu, güncellendi veya silindi",
            tagActions: "Etiket oluşturuldu, güncellendi veya silindi",
            welcomeMessageActions: "Hoş geldiniz mesajı oluşturuldu, güncellendi veya silindi",
            webhookActions: "Web kancası oluşturuldu, güncellendi veya silindi",
            billingEvents: "Fatura Olayları",
            workflowCreated: "İş akışı oluşturulduğunda",
            workflowDeleted: "İş Akışı Silindiğinde",
            taskStatusChanged: "Görev durumu değiştiğinde",
            deletedTask: "Görev Silindiğinde",
            taskCrud: "Görev oluşturuldu, güncellendi veya silindi",
            systemStatus: "Sistem çevrimiçi veya çevrimdışı durum değişiklikleri",
            chatbotStoryCrud: "Chatbot hikayesi oluşturuldu, güncellendi veya silindi",
            chatbotForwardAgent: "Chatbot, bir sohbeti bir ajana yönlendirir",
            userSegmentCrud: "Kullanıcı segmenti oluşturuldu, güncellendi veya silindi",
            chatbotCreditLow: "Chatbot kredisi düşük olduğunda",
            wpCreditLow: "Whatsapp kredisi düşük olduğunda",
            wpCustomerGroupCrud: "Whatsapp müşteri grubu oluşturulduğunda, güncellendiğinde veya silindiğinde",
            wpBroadcastMessageStatus: "Whatsapp yayın mesajı gönderildiğinde, tamamlandığında veya iptal edildiğinde",
            wpTemplateMesssageCrud: "Whatsapp şablon mesajı oluşturulduğunda, güncellendiğinde veya silindiğinde",
            reservationMessageCrud: "Rezervasyon Oluşturuldu, Güncellendi, İptal Edildi",
        },
        search: {
            prefix: {
                jump: "Git",
                new: "Yeni",
                visitor: "Kişi",
                dm: "DM",
                chatbot: "Chatbot",
                automation: "Otomasyon",
                table: "Tablo",
                module: "Modül",
                message: "Mesaj",
            },
            calendar: "Takvim",
            soundSettings: "Sesli Bildirimler",
            allNotificationSettings: "Bildirim Ayarları",
            allAuditLogs: "Denetim Logları",
            allNotifications: "Tüm Bildirimler",
            allActivities: "Tüm Aktiviteler",
            workFlow: "İş akışı",
            editTask: "Görev düzenle",
            tasks: "Görevler",
            todo: "Yapılacaklar",
            tapTo: "'{prefix}' işlemleri için ⇥ basın",
            newUsers: "Yeni ⇥ Kullanıcı",
            newTags: "Yeni ⇥ Etiket",
            newRole: "Yeni ⇥ Rol",
            newTrigger: "Yeni ⇥ Tetikleyici",
            newDepartment: "Yeni ⇥ Departman",
            newTicket: "Yeni ⇥ Etiketleri",
            jumpSettings: "Git ⇥ Ayarlar",
            jumpIntegrations: "Git ⇥ Entegrasyonlar",
            jumpTeam: "Git ⇥ Takım",
            jumpUsers: "Git ⇥ Kullanıcılar",
            jumpReport: "Git ⇥ Rapor",
            timingSettings: "Zamanlama ayarları",
            exampleVisitorMail: "Ziyaretçi@mail.com",
            languageAndRegion: "Dil ve Bölge",
            theme: "Tema",
            appearance: "Görünüş - Görünüm",
            color: "Renk",
            background: "Arkaplan",
            smart: "Akıllı",
            teamChat: "Takım Konuşması",
            chatbot: "ChatBot",
            chatbotTraining: "Chatbot Eğitimi",
            chatbotUserSegments: "Chatbot Kullanıcı Segmentleri",
            chatbotIntegration: "Chatbot Entegrasyon",
            chatbotEntities: "Chatbot Varlıklar",
            chatbotIntegrationWebHook: "Chatbot WebHook Entegrasyon",
            chatbotArchive: "Chatbot Arşiv",
            chatbotTemplatesAI: "Chatbot Yapay Zeka Şablonları",
            chatbotTemplates: "Chatbot Şablonları",
            chatbotReportsOverall: "Chatbot Genel Raporlar",
            chatbotReportsAllChats: "Chatbot Tüm Sohbetleri Raporlar",
            chatbotReportsRatingDistribution: "Chatbot Raporlarının Derecelendirme Dağılımı",
            chatbotReportsPaidChats: "Chatbot Reports Paid Chats",
            chatbotReportsBusiestPeriod: "Chatbot En Yoğun Dönemi",
            chatbotTemplatesAllMessages: "Chatbot Şablonları Tüm Mesajlar",
            chatbotTemplatesAvarage: "Chatbot Şablonları Ortalaması",
            chatbotTemplatesPopularity: "Chatbot Şablonlarının Popülerliği",
            chatbotTemplatesAllUser: "Chatbot Şablonları Tüm Kullanıcı",

            ticket: "Destek Talepleri",
            archives: "Arşiv",
            tags: "Etiketler",
            offlineSupportRequests: "Offline Support Requests",
            roles: "Roller",
            users: "Kullanıcılar",
            subjects: "Departmanlar",
            contents: "Hazır İçerikler",
            welcomeMessages: "Sistem Mesajları",
            catalog: "Katalog",
            bannedWords: "Yasaklı Kelimeler",
            bannedVisitors: "Yasaklı Ziyaretciler",
            application: "Uygulama",
            mails: "Mailer",
            visitors: "Ziyaretciler",
            integrationsWebhook: "Webhook Entegrasyonu",
            billing: "Fatura",
            reportNew: "Yeni Rapor",
            integrations: "Entegrasyonlar",
            chatbotStory: "Chatbot Hikayaler",
            searchPlaceHolder: "Ara, Git yada Ekle...",
            searchAreaTitle: "Supsis'te Ara",
            searchAreaDesc1: "Herşeyi arayabilirsin. Sadece",
            searchAreaDesc2: "ya da",
            searchAreaDesc3: "yaz veya herhangi bir şey ara.",
            navigateBtn: "Gezin",
            selectBtn: "Seç",
            cancelBtn: "İptal",
            integration: {
                shouldByInstaPack:
                    "Instagram kanalı oluşturmak için Instagram paketi satın almalısınız. Uygun fiyatları paketlere hemen ulaşabilirsiniz.",
                createInstaLimitMax: "Instagram kanal oluşturma limitine ulaştınız. Maximun",
                createInstaContinue:
                    "Instagram Kanalı oluşturabilirsiniz. Devam etmek için paketinizi yükseltin yada Instagram kanalarınızdan bir kaçını siliniz.",
                privatePolicy: "Özel Politika",
                termsAndCondition: "Şartlar ve Koşullar",
                readAndAgree: "Okudum ve kabul ediyorum",
                shouldByMessengerPack:
                    "Messenger kanalı oluşturmak için Messenger paketi satın almalısınız. Uygun fiyatları paketlere hemen ulaşabilirsiniz.",
                createMessengerLimitMax: "Messenger kanal oluşturma limitine ulaştınız. Maximun",
                createMessengerContinue:
                    "Messenger Kanalı oluşturabilirsiniz. Devam etmek için paketinizi yükseltin yada Messenger kanalarınızdan bir kaçını siliniz.",
                selectMessengerAccount: "Messenger Hesabını Seçin",
                forwardLiveAgents: "👉 İleri Canlı Temsilciler",
                allDepartments: "Tüm Depertmanlar",
                deleteAll: "Hepsini Sil",
                wpBusinessAPI: "Integrations - Whatsapp Business API Kanalları",
                wpV1: "Integrations - Multi Whatsapp Kanalları",
                instagram: "Integrations - Instagram",
                instagramContactList: "Integrations - Instagram Kişi Listesi",
                mail: "Integrations - Mail",
                whatsapp: "Integrations - Whatsapp",
                whatsappContactList: "Integrations - Whatsapp Kişi Listesi",
                wpBCRequests: "Integrations - Whatsapp Toplu Mesaj İstekleri",
                wpBCCustomerGroups: "Integrations - Whatsapp Toplu Müşteri Grupları",
                wpBCTemplates: "Integrations - Whatsapp Toplu Message Şablonları",
                chatbot: "Integrations - ChatBot",
            },
            settings: {
                settings: "Ayarlar",
                features: "Ayarlar - Özellikler",
                languageAndRegion: "Ayarlar - Dil ve Bölge",
                bubbleSettings: "Ayarlar - Balon Ayarları",
                bubbleActions: "Ayarlar - Balon Eylemleri",
                themeSettings: "Ayarlar - Tema Ayarları",
                talkSettings: "Ayarlar - Konuşma Ayarları",
                visitorLoginForm: "Ayarlar - Ziyaretci Giriş Formu",
                visitorAttribute: "Ayarlar - Ziyaretci Özellikleri",
                autoAssign: "Ayarlar - Otomatik Atama",
                chatTimingSettings: "Ayarlar - Chat Zaman Ayarları",
                availability: "Ayarlar - Kullanılabilirlik",
                websiteIntegration: "Ayarlar - Website Entergasyon",
                developer: "Ayarlar - Geliştirici",
            },
        },
        mail: {
            broadcastCreatedSuccess: "Yayın başarıyla oluşturuldu",
            confirmArchive: "Bu yayını arşivlemek istediğinize emin misiniz?",
            archive: "Arşivle",
            cancel: "İptal",
            archiveSuccess: "Yayın başarıyla arşivlendi",
            archiveError: "Yayını arşivlerken hata oluştu",
            empty: "Boş",
            summerDiscounts: "Yaz İndirimleri",
            opportunities: "Fırsatlar",
            newMailTemplateCreated: "Yeni E-posta Şablonu Oluştur.",
            dateRange: "Tarih Aralığı",
            templateName: "Şablon Adı",
            category: "Kategori",
            templateUpdateSucs: "Şablon başarıyla güncellendi.",
            templateUpdateError: "Şablon güncellenirken bir hata oluştu.",
            marketing: "Pazarlama",
            operational: "Operasyonel",
            custom: "Özel",
            pleaseEnterTemplateName: "Lütfen şablon adını girin",
            pleaseEnterTemplateSubject: "Lütfen şablon konusunu girin",
            pleaseSelectTemplateCategories: "Lütfen şablon kategorisini seçin",
            representMails: "Temsilci Mailleri",
            otherRepresentMails: "Diğer temsilcilerin mail adresine gelen ve giden e-postaları takip edebilirsiniz.",
            signatureAutoAdd: "İmza otomatik ekleme durumu başarıyla değiştirildi",
            autoAdd: "Otomatik Ekleme",
            forwardEmailAddSucs: "Forward eposta adresi başarıyla eklendi.",
            errorAddingForwardEmail: "Forward eposta adresi eklenirken bir hata oluştu.",
            mailAddForward: "Manuel Ekleme (ileri tamamlandı)",
            mailAddForwarding: "Manuel Ekleme (Yönlendirmeyi tamamladım)",
            broadcast: "Toplu e-mail",
            templates: "Şablonlar",
            inbox: "Gelen Kutusu",
            newMailArrived: "Yeni mail geldi.",
            mailSentSucs: "Mail başarıyla gönderildi.",
            representativeMails: "Temsilci Mailleri",

            composeNewEmail: "Yeni e-posta oluşturma",
            couldNotUserMail: "Kullanıcı maili olmadığı için mail gönderilemedi",
            mailAddressReq: "Mail Adresi Gereklidir.",
            emailAddressInvalid: "Mail adresi geçersiz.",
            departmentIsNotValid: "Departman geçerli değil",
            mailSendNotValid: "Posta adresinden gelen geçerli değil",

            routingSteps: "Yönlendirme Adımları",
            owner: "Sahibi",
            whereHeDirected: "Nereye Yönlendirdi",
            forwardingEmailAddress: "Yönlendirecek Eposta Adresi",
            deleteMailDesc: "Bu işlem geri alınamaz.",
            deleteMailTitle: "Bu mail adresini silmek istediğinize emin misiniz?",
            gmailForwardMail: "Gmail Mail İletme",
            senderMailAddressDesc: "Lütfen Gönderici Mail Adresi Girin",
            verified: "Doğrulandı",
            notForwarded: "Yönlendirilmedi",
            notVerified: "Doğrulanmadı",
            default: "Varsayılan",
            isVerified: "Doğrulanma",
            forwarding: "Yönlendirme",
            mailAdress: "Mail Adresi",
            addSenderAddress: "Gönderen Maili Ekle",
            outlookForward: "Microsoft (Outlook/Exchange) Yönlendirme",
            gmailForward: "Google(Gmail) Yönlendirme",
            senderMail: "Gönderen Mail",
            mailDetail: "Mail Detayı",
            mailNotFound: "Mail Bulunmuyor",
            mailSelecting: "Mail Seçimi",
            newMail: "Yeni E-Posta",
            myMails: "E-Postalarım",
            sent: "Gönderilen",
            departmentMails: "Departman E-Postaları",
            newTemplate: "Yeni Şablon",
            unread: "Okunmamış",
            unreply: "Yanıtlanmamış",
            reply: "Yanıtla",
            attachments: "Mail Ekleri",
            To: "Kime",
            From: "Kimden",
            FromName: "Gönderen Kişinin İsmi",
            placeHolders: "Yer Tutucular",
            attacheFiles: "Dosya Ekle",
            replyAll: "Tümünü Yanıtla",
            forward: "İlet",
            deleteThread: "Konuşmayı sil",
            markAsRead: "Okundu Olarak İşaretle",
            markAsAllRead: "Tümünü Okundu Olarak İşaretle",
            emailEditor: "E-Posta Düzenleyici",
            integrateYourMail: "E-Postanı Entegre Et",
            connect: "Bağlan",
            departmentMail: "Departman E-Posta",
            createMailAddress: "Mail Adresi Oluştur",
            createNewMail: "Yeni Mail Oluştur",
        },
        visitor: {
            downloadAll: "Tümünü İndir",
            saveAsCustomerGroup: "Müşteri Grubu Olarak Kaydet",
            filterResultMax5000: "Filtre sonucu maksimum 5000 kişi ile sınırlıdır",
            onlyContactsPhoneNumber: "Sadece telefon numarası olan kişiler gruba aktarılacaktır",
            enterGroupName: "Grup adını girin",
            showInColumns: "Sütünlarda Göster",
            sendMailSucs: "Mail Başarıyla Gönderildi",
            equal: "Eşit",
            notEqual: "Eşit değil",
            contains: "İçerir",
            notContains: "İçermez",
            startsWith: "İle Başlar",
            endWith: "İle Biter",
            saveSearchFavorite: "Aramayı favori olarak kaydet",
            mail: "Mail",
            visitorDetail: "Ziyaretçi Detayları",
            selectedUser: "{totalUsers} kullanıcıdan {selectedUser} tanesi seçildi",
            uncheck: "Tüm işaretleri kaldır",
            checkAll: "Tümünü işaretle",
            matchedUsers: "{chechkedCount} adet kullanıcı eşleşti",
            more: "Daha fazla",
            exportUsers: "Seçilen kullanıcıları dışa aktar",
            exportAllUsers: "Tüm kullanıcıları dışa aktar",
            addSegment: "Segment Ekle",
            deletedCheckedUser: "Seçilen kullanıcıları sil",
            deleteAllUser: "Tüm kullanıcıları sil",
            matchedFilter: "Tüm filtreleri eşleştir",
            visitor: "Ziyatretçisi",
            deleteUser: "Kullanıcıyı sil",
            userData: "Kullanıcı bilgileri",
            lastSession: "Kullanıcı Haraketleri",
            notUserData: "Kullanıcı haraketleri bulunamadı",
            segments: "Segmentler",
            tags: "Etiketler",
            addTag: "Etiket ekle",
            userChats: "Kullanıcı Konuşmaları",
            userMails: "Kullanıcı Mailleri",
            seeAll: "Hepsini gör",
            confirm: "Onayla",
            manageSegments: "Segment yönetimi",
            search: "Aramaya Başla",
            manageTags: "Tag yönetimi",
            allAttributes: "Tüm özellikleri gör",
            noData: "Veri yok",
            noEmail: "Mail yok",
            noIpAddress: "IP adresi bulunamadı.",
            noWpNumber: "Numara bulunamadı.",
            filterName: "Filtre ismi...",
            matchedContacts: "{chechkedCount} adet bağlantı eşleşti",
        },
        chatbotv2: {
            typeStoryTitle: "Senaryo Başlığını Yazın",
            setUpYourChatbot: "Chatbot'unuzu Kurun",
            setUpYourChatbotDesc:
                "Chatbotunuzu verilerle eğitin, kullanıma hazır şablonlarımızı kullanın veya sıfırdan başlayın.",
            blankBot: "Boş Bot",
            blankBotDesc: "Daha sonra eğitebileceğiniz ve özelleştirebileceğiniz boş bir sohbet robotu oluşturun.",
            websiteDesc: "Popüler kullanıcı sorularına yanıt almak için web sitenizin içeriğini tarayın.",
            yourNeedEnterYourOpenAi:
                "Web sitenizi tarayarak otomatik bir sohbet botu oluşturmak için OpenAI API anahtarınızı girmeniz gerekiyor.",
            createOpenAiKey: "Api Key Oluştur",
            aiKnowledge: "Yapay Zeka Bilgisi",
            modalUsage: "Modal Kullanımı",
            usedContentSources: "Kullanılan İçerik Kaynakları",
            websites: "Websiteler",
            articles: "Makaleler",
            faq: "SSS",
            files: "Dosyalar",
            functions: "Fonksiyonlar",
            settings: "Ayarlar",
            disableAi: "AI'yı Devre Dışı Bırak",
            enableAi: "Yapay Zekayı Etkinleştir",
            lastEdited: "Son Düzenlenen",
            state: "Durum",
            frequentlyAskedQuestions: "Sıkça Sorulan Sorular (SSS)",
            faqIsCreated: "SSS Oluşturuldu",
            selectKnowEnabled: "Seçilen bilgi tabanları etkinleştiriliyor...",
            selectKnowDisabled: "Seçilen bilgi tabanları devre dışı bırakılıyor...",
            selectKnowNotEnabled: "Seçilen bilgi tabanları etkinleştirilmemiştir.",
            selectKnowNotDisabled: "Seçilen bilgi tabanları devre dışı bırakılmaz.",
            answered: "Cevaplandı",
            answer: "Cevap",
            addFile: "Dosya Ekle",
            fileDeleted: "Dosyalar silindi",
            fileDeletedFailed: "Dosyalar silinirken bir sorun oluştu",
            noFileAdded: "Dosya eklenmemiş",
            aiFunctions: "YZ Fonksiyonları",
            addFunction: "Foksiyon Ekle",
            parameterCount: "Parametre Sayısı",
            auto: "Otomatik",
            Zoho_Actions: "Zoho Aksiyonları",
            File_Actions: "Dosya Aksiyonları",
            Data_Formatters: "Veri Formatlayıcıları",
            Loop_Actions: "Döngü Aksiyonları",
            usedByAI: "AI Kullanıyor",
            usedByAi: "AI tarafından kullanılan",
            notUsed: "Kullanılmıyor",
            saveAndClose: "Kaydet ve Kapat",
            contentPreview: "İçerik Önizleme",
            addContent: "İçerik Ekle",
            populerUserQuestion: "Popüler kullanıcı sorularına yanıt almak için web sitenizin içeriğini tarayın.",
            enterUrlAddress: "Bir URL adresi girin",
            sharingYourUrl:
                "URL'nizi paylaşarak, içeriğini paylaşmak için gerekli haklara sahip olduğunuzu onaylamış olursunuz.",
            pageSelected: "Seçilen Sayfalar",
            trainChatbot: "Sohbet robotunu eğitin",
            thereAreOnePages: "İçinde 1 sayfa var",
            categoryDesc: "kategori. Yapay zeka modelinizi eğitmek için hangisinin kullanılacağını seçin.",
            scarpOrAddContent:
                "AI Assist'in müşterilerinizin sorularına yanıt vermek için kullanabileceği içerikleri kazıyın veya ekleyin",
            noContentAdded: "İçerik Eklenmedi",
            howItWorks: "Nasıl Çalışır",
            editEntries: "Girdileri Düzenle",
            newEntries: "Yeni Girdiler",
            chatbotManagement: "Chatbot Yönetimi",
            chatbotScenarioList: "Chatbot Seneryo Listesi",
            exportDiagramToClipboard: "Diyagramı Panoya Aktar",
            selectedStory: "{count} Senaryo Seçildi",
            B2Cargo_Actions: "B2Cargo Aksiyonları",
            Holiday_Plus_Actions: "Holiday+ Aksiyonları",
            Instagram_Actions: "Instagram Aksiyonları",
            HOLIDAY_PLUS_GET_ROOMS: "ODALARI LISTELE",
            HOLIDAY_PLUS_GET_HOTELS: "OTELLERI LISTELE",
            ZOHO_CREATE_RECORD: "Zoho Kayıt Oluştur",
            B2CARGO_LOGIN_USER: "Kullanıcı Girişi",
            B2CARGO_PRODUCT_STATUS: "Ürün Durumu",
            didntSuppression: "Herhangi bir kısıtlama yapmadınız.",
            suppressionRemoved: "Kısıtlama Kaldırıldı",
            suppressionAdded: "Kısıtlama Eklendi",
            whatsappIntegrationTitle: "Whatsapp V1 ve Whatsapp V2 Entegrasyonu",
            whatsappApiIntegrationTitle: "Whatsapp Business API Entegrasyonu",
            ReadyTemplateBadge: "Hazır Şablon",
            readyTemplates: "Hazır Şablonlar",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "Chatbot Resmi",
            chatbotName: "ChatBot Adı",
            ChatbotScenarioList: "Chatbot Senaryo Listesi",
            Scenario: "Senaryolar",
            allSecnario: "Tüm Chatbot Senaryoları",
            filters: {
                equal: "eşittir",
                not_equal: "eşit değildir",
                contain: "içerir",
                not_contain: "içermez",
                starts_with: "ile başlar",
                ends_with: "ile biter",
                empty: "boş ise",
                non_empty: "boş değil ise",
                longer_than: "daha uzunsa",
                shorter_than: "daha kısaysa",
                less_than: "küçükse",
                less_or_equal: "küçük veya eşit ise",
                greater_than: "büyükse",
                greater_or_equal: "büyük veya eşit ise",
            },
            planRequired: "{integratable} Plan Gerekmektedir.",
            noDefaultStoryTitle: "Varsayılan Hikaye",
            noDefaultStory: "Varsayılan hikayeniz bulunmamaktadır.\n Bu hikayeyi varsayılan yapmak ister misiniz?",
            noMessage: "Mesaj Yok",

            loading: "Yükleniyor",
            loadMore: "Daha fazla",
            hostname: "Host adı",
            allTemplates: "Tüm Şablonlar",
            allAITemplates: "Tüm Yapay Zeka Şablonları",
            templatesFromTheIndustry: "Sektörden Şablonlar",
            basicTemplate: "Temel Şablon",
            proTemplate: "Gelişmiş Şablon",
            goToStory: "hikayeye git",
            noResultFound: "Hiç bir sonuç bulunamadı",
            checkYourFilterCombination: "Filtre kombinasyonunu kontrol et",
            clearYourSearch: "aramayı temizle",
            andTryAgain: "ve yeniden dene",
            withBot: "& Bot",
            userWithBot: "Kullanıcı & Bot",
            chatDetail: "Sohbet Detayları",
            allUserDetail: "Tüm kullanıcı detaylarını görün",
            sessionData: "Oturum verileri",
            supsisChatWidget: "Supsis Sohbet Aracı",
            integratedWith: "Şunlarla entegredir : ",
            integration: "Entegrasyon",
            Users: "Kullanıcılar",
            user_id: "Kullanıcı ID",
            botStory: "Bot hikayesi",
            categories: "Kategoriler",
            worksWith: "İle çalışır",
            importBot: "Botu kullan",
            keyFeatures: "Ana Özellikler",
            importing: "ekleniyor",
            comingSoon: "Yakında Hizmetinizde",
            pickStory: "Hikaye seçin",
            conversationId: "Konuşma ID",
            integrateStoryWithSupsisWidget: "Supsis Widget'ını Chatbot Story ile Entegre Edin",
            integrateStoryWithWhatsapp: "Whatsapp'ı Chatbot Story ile Entegre Edin",
            integrateStoryWithInstagram: "Instagram'ı Chatbot Story ile Entegre Edin",
            selectIntegratingStory: "Entegre edilecek hikayeyi seçin",
            install: "Yükle",
            attr: {
                owner: "Sahip",

                trendyol_question: "Ürün Sorusu",
                trendyol_question_id: "Ürün Soru ID",
                trendyol_product_id: "Ürün ID",
                trendyol_product: "Ürün Bilgileri",

                weekday: "Haftanın Günü",
                email: "E-posta",
                phone: "Telefon",
                language: "Dil",
                timezone: "Saat Dilimi",
                gender: "Cinsiyet",
                country: "Ülke",
                referrer: "Referrer",
                url: "Ziyaret Adresi",
                id: "ID",
                conversationId: "Konuşma ID",
                channelId: "Kanal ID",
                ip: "IP",
                last_seen: "Son Görülme",
                name: "İsim",
                user_id: "Kullanıcı numarası",
                department: "Departman",
                message: "Mesaj",
                akinon_brand: "Marka",
                akinon_order_id: "Sipariş Numarası",
                akinon_product_id: "Ürün Numarası",
                akinon_user_id: "Kullanıcı ID'si",
                akinon_user_name: "Kullanıcı Adı",
                akinon_user_email: "Kullanıcı E-Postası",
                akinon_invoice_url: "Fatura URL",
                akinon_order_status: "Sipariş Durumu",
                akinon_order_price: "Sipariş Fiyatı",
                akinon_shipper_name: "Kargo Firması Adı",
                akinon_product_size: "Ürün Bedeni",
                akinon_sku: "SKU",
                akinon_product_url: "Ürün URL",
                akinon_product_title: "Ürün Başlığı",
                akinon_product_image: "Ürün Resmi",
                akinon_product_stock: "Ürün Stoğu",
                akinon_order_date: "Sipariş Tarihi",
                akinon_track_number: "Kargo Takip Numarası",
                akinon_track_url: "Kargo Takip URL",
                akinon_latitude: "Enlem (Konum)",
                akinon_longitude: "Boylam (Konum)",

                ideasoft_user_id: "Üye Id",
                ideasoft_invoice_url: "Fatura Linki",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Sipariş Durumu",
                ideasoft_order_price: "Sipariş Tutarı",
                ideasoft_shipper_name: "Kargo Firması",
                ideasoft_product_size: "Ürün Bedeni",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Ürün Linki",
                ideasoft_product_title: "Ürün Başlığı",
                ideasoft_product_image: "Ürün Resmi",
                ideasoft_product_stock: "Ürün Stok",
                ideasoft_order_date: "Sipariş Tarihi",
                ideasoft_track_number: "Kargo Takip Numarası",
                ideasoft_track_url: "Kargo Takip URL",

                offline_mode: "Çevrimdışı Mod",
                available_agents: "Uygun Temsilciler",
                platform: "Platform",
                probel_sube_kodu: "Şube Kodu",
                probel_brans_adi: "Branş Adı",
                probel_brans_kodu: "Branş Kodu",
                probel_doktor_adi: "Doktor Adı",
                probel_doktor_kodu: "Doktor Kodu",
                probel_poliklinik_adi: "Poliklinik Adı",
                probel_poliklinik_kodu: "Poliklinik Kodu",
                probel_randevu_tarihi: "Randevu Tarihi",
                probel_date: "Randevu Tarihi",
                probel_randevu_saati: "Randevu Saati",
                probel_randevu_id: "Randevu ID",
                probel_hasta_token: "Hasta Token",
                probel_kimlik_tipi: "Kimlik Tipi",
                probel_kimlik_no: "Kimlik No",
                probel_hasta_adi: "Hasta Adı",
                probel_hasta_soyadi: "Hasta Soyadı",
                probel_hasta_cinsiyet: "Cinsiyet",
                probel_hasta_dogum_tarihi: "Doğum Tarihi",
                probel_hasta_telefon: "Telefon",
                hour: "Saat",
                segments: "Segments",
                ticket: "Etiket",
                tags: "Etiket",
                metaReferrals: "Meta Referrals",
                idleUserTime: "Kullanıcı Son Aksiyon (Saniye)",
                ai_class_result: "YZ Sınıf Sonuç",
                meta_comment_id: "Meta Yorum ID",
                meta_comment: "Meta Yorum",
                meta_post_id: "Meta Post ID",
                visitor_trigger_type: "Müşteri Tetiklenme Türü",
                visitor_trigger_name: "Müşteri Tetikleyici Adı",
                b2cargo_companyCode: "Firma Kodu",
                b2cargo_takipNo: "Ürün Takip No",
                b2cargo_takipseri: "Ürün Takip Seri",
                b2cargo_evrakdurum: "Ürün Durumu",
                b2cargo_teslimtar: "Teslim Tarihi",
                b2cargo_gonderen: "Gönderen Firma",
                b2cargo_aliciAdi: "Alıcı Firma",
                b2cargo_cikisIl: "Çıkış İl",
                b2cargo_varisIl: "Varış İl",
                b2cargo_teslim: "Teslim Durumu",
                b2cargo_urun: "Ürün Tipi",
                b2cargo_atfTarih: "ATF Tarih",
                b2cargo_palet: "Palet",
                b2cargo_koli: "Koli",
                b2cargo_kg: "Ürün Ağırlığı",
                b2cargo_desi: "Ürün Boyutu",
                b2cargo_zimmetno: "Zimmet No",
                b2cargo_varissube: "Varış Şube",
                b2cargo_atfDurum: "ATF Durum",
                holiday_plus_room_id: "Oda ID",
                holiday_plus_room_title: "Oda Adı",
                holiday_plus_room_description: "Oda Açıklaması",
                holiday_plus_room_size: "Oda Boyutu",
                holiday_plus_room_price: "Oda Fiyatı",
                holiday_plus_room_price_offer: "Oda İndirimi",
                holiday_plus_room_discount_price: "Oda İndirimli Fiyatı",
                holiday_plus_selected_hotel_id: "Seçilen Otel ID",
                holiday_plus_checkin: "Giriş Tarihi",
                holiday_plus_checkout: "Çıkış Tarihi",
                holiday_plus_child_count: "Çocuk Sayısı",
                holiday_plus_adult_count: "Yetişkin Sayısı",
                holiday_plus_child_dates: "Çocukların Yaşları",
                reservation_time: "Rezervasyon Saati",
                reservation_day: "Rezervasyon Günü",
            },
            storyList: "Hikaye Listesi",
            douYouWannaDeleteItem: "Bu öğeyi silmek istiyor musunuz?",
            douYouWannaDeleteWithChildren: "Bu öğeyi alt öğeleriyle birlikte silmek istiyor musunuz?",
            stories: "Hikayeler",
            templates: "Şablonlar",
            aitemplates: "Yapay Zeka Şablonlar",
            integrations: "Entegrasyonlar",
            all: "Tümü",
            installed: "Yüklenmiş Olanlar",
            installationOK: "Yüklü",
            uninstall: "Kaldır",
            remainingMessageDesc: "Kalan ücretsiz mesaj : ",
            openAISiteRoutingDescStart: "Bir Apikey almak için",
            openAISiteRoutingDescEnd: " bağlantısına tıklayabilirsiniz.",
            integrationOK: "Entegre edildi",
            chatWidget: "Supsis Sohbet Balonu",
            artificialIntelligence: "Yapay Zeka",
            integratePlatform: "Chatbot {integretable} ile entegre edilebilir.",
            integrateOpenAIWithChatbot: "Chat GPT-4o'ü Chatbot ile Entegre Edin",
            integrateChatBotWithChatGPT3: "ChatBot'un Chat GPT-4o ile Entegrasyonu",
            integrateStoryWithTelegram: "Telegram Chatbot ile Entegrasyonu",
            webhooks: "Web Kancaları",
            archive: "Arşiv",
            reports: "Raporlar",
            uncheckAll: "Tümünü bırak",
            userSegments: "Kullanıcı Segmentleri",
            plans: "Planlar",
            chatBotPlans: "Chat Bot Planlar",
            addSegment: "Segment Ekle",
            addToSegment: "Segmente Ekle",
            removeFromSegment: "Segmentten Çıkar",
            plansVTippyContent:
                "Bu paket için ücretlendirme her ay başı yapılacaktır, iptal etmek istediğiniz süreçte kullanımınız ay başına kadar ücretlendirilecektir ve paketiniz bitecektir.<br><br>Paket değişiklikleri ertesi gün faturaya yansımaktadır. <br><br>Paket fiyatı KDV harici fiyatıdır.",
            segmentName: "Segment Adı",
            sameSegment: "Aynı isimde bir segment mevcut",
            usersInSegment: "Segmentteki Kullanıcılar",
            noUsersAdded: "Kullanıcı eklenmedi",
            updateSegment: "Segmenti Güncelle",
            newSegment: "Yeni Segment",
            selectAll: "Tümünü seç",
            queriesSelected: "sorguları seçildi",
            noBlocksFound: "Blok bulunamadı!",
            userQuery: "Kullanıcı Sorgusu",
            date: "Tarih",
            unmatched: "Eşleşmeyen",
            goToChat: "Sohbete Git",
            selectStory: "Hikaye Seç",
            selectBlock: "Blok Seç",
            training: "Bot Eğitimi",
            trainingAlert:
                "Bot eğitimi sayfasında yaptığınız değişikliklerin uygulanması için değişiklik yaptığınız senaryonun yeni versiyonunu yayınlamanız gerekmektedir.",
            unmatchedPhrases: "Eşleşmeyen İfadeler",
            ignored: "Önemsiz",
            story: "Hikaye",
            timePeriod: "Zaman Dilimi",
            wholeTimeSpan: "Tüm zamanlar",
            selectAStory: "Bir hikaye seçin",
            searchUserQuery: "Kullanıcı sorgusu ara",
            time: {
                today: "Bugün",
                yesterday: "Dün",
                last7: "Son 7 Gün",
                last30: "Son 30 Gün",
                "this-month": "Bu Ay",
                "last-month": "Geçen Ay",
                "last-3-month": "Son 3 Ay",
                "this-year": "Bu Yıl",
                "last-year": "Geçen Yıl",
                custom: "Farklı Bir Tarih Seç",
            },
            emailProvider: "E-mail sağlayıcı",
            triggerFromAnywhere: "Her yerden tetiklenebilir",
            editWebhook: "Webhook düzenle",
            newWebhook: "Yeni Webhook",
            webhookTitle: "Webhook Başlığı",
            webhookUrl: "Webhook URL'si",
            webhookToken: "WebHook Token",
            webhookUsername: "WebHook Kullanıcı adı",
            webhookPassword: "WebHook Parolası",
            allIntegrations: "Tüm Entegrasyonlar",
            integrateYourCBwithChatWidget: "Chatbotu Chat Widget ile entegre edin.",
            integrateYourCBwithChatGpt3: "Chatbot, GPT-4o ile entegre edilebilir. GPT-4o api key gerekli.",
            integrateYourCBwithWebHook: "ChatBot ve web hizmetleriniz arasında sohbet bilgilerini kolaylıkla iletin.",
            integrateYourCBwithIntegratable: "ChatBot ve {integratable} arasında sohbet bilgilerini kolaylıkla iletin.",
            addWebhook: "Webhook Ekle",
            editBlock: "Düzenle",
            moveBlock: "Taşı",
            copyBlock: "Kopyala",
            chatbot: "Chatbot",
            addFilter: "Filtre Ekle",
            addFilterGroup: "Filtre Grubu Ekle",
            clearFilter: "Filtreyi Temizle",
            in: "içinde",
            and: "ve",
            or: "veya",
            allStories: "Tüm Hikayeler",
            addBot: "Bot Oluştur",
            testBot: "Botu Test Et",
            publish: "Yayınla",
            editName: "Adı Düzenle",
            search: "Hikayenizde arayın…",
            typeMoreThan3Char: "En az 3 karakter girin ",
            expand: "Genişlet",
            expandAll: "Tümünü Genişlet",
            noMatchingItem: "Eşleşen öğe yok",
            hint: "İpucu",
            select: "Seç",
            navigate: "Gezin",
            dismiss: "Vazgeç",
            choseAttribute: "Filtre türünü seçin",
            selectReply: "Yanıt türünü seçin",
            preview: "Önizleme",
            draft: "Taslak",
            lastUpdate: "Son Güncelleme",
            published: "Yayınlandı",
            newStory: "Yeni Hikaye",
            updateStory: "Hikayeyi Güncelle",
            storyDescription: "Hikaye Açıklaması",
            storyTitle: "Hikaye Başlığı",
            deleteSingleBlock: "Tek Bloğu Sil",
            deleteWithChildren: "İç Dallanmalarla Birlikte Sil",
            startTestFromHere: "Testi Buradan Başlat",
            copyBlockId: "Blok ID'sini Kopyala",
            gotoLiveLink: "Buradan Canlı Link Oluştur",
            copyBlockIdSuccessfull: "Blok ID'sini Kopyalandı",

            collapse: "Daralt",
            collapseAll: "Tümünü Daralt",
            snDelay: "{delay} sn gecikme",
            blockUpdated: "Blok Güncellendi",
            addPayload: "Cevap Ekle",
            previewModeCaution:
                "Şuanda hikayenizin versiyonlarından birinin önizlemesini yapıyorsunuz. Önizleme modunda değişiklikleri kaydedemezsiniz!",
            enterText: "Buraya yazın...",
            trackpad: "Trackpad",
            navigation: "Navigasyon",
            navigationDesc:
                "Lütfen navigasyon modunuzu seçin. İzleme dörtgeni veya fare seçeneklerinden dilediğinizi seçebilirsiniz..",
            botSetting: "Bot Ayarı",
            botSettingDesc:
                "Lütfen güven seviyesini belirleyin. Bu, kullanıcı girişleriyle ilgili chatbot yorumlarının doğruluğunu tanımlayan 0 ile 100 arasında bir yüzdedir. ",
            languageSettingsDesc: "Lütfen Bot'un yanıt verdiği dilin tercih ettiğiniz dil olduğundan emin olun.",
            mouse: "Mouse",
            Interactions: "Etkileşimler",
            Actions: "Aksiyonlar",
            Supsis_Actions: "Supsis Aksiyonları",
            Table_Actions: "Tablo Aksiyonları",
            Shopify_Actions: "Shopify Aksiyonları",
            Akinon_Actions: "Akinon Aksiyonları",
            IdeaSoft_Actions: "Ideasoft Aksiyonları",
            START_POINT: "BAŞLANGIÇ NOKTASI",
            AI_ASSISTANT: "YAPAY ZEKA ASISTAN",
            FEEDBACK_AI_ASSISTANT: "ASISTANA BİLGİ VER",
            API_REQUEST: "API İSTEK",
            BOT_RESPONSE: "BOT'UN YANITI",
            AI_BOT_RESPONSE: "YZ YANIT (GPT-4o)",
            AI_CLASSIFICATION: "YZ SINIFLANDIR",
            Templates: "Şablon Bloklar",
            AI_MENU_FLOW: "Hazır Menü Flow",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "VARSAYILAN AKSİ DURUM",
            DEFAULT_TIMEOUT: "VARSAYILAN Zaman Aşımı",
            AI_FUNCTIONS: "YZ FONKSIYON",
            FILTER: "FİLTRE",
            addNewFilter: "Yeni filtre ekle",
            FLOW: "AKIŞ",
            ATTACHMENT_INPUT: "DOSYA GİRİŞİ",
            USER_INPUT: "KULLANICI GİRİŞİ",
            GO_TO_STEP: "ADIM'A GİT",
            WEBHOOK: "WEB HOOK",
            SET_ATTRIBUTE: "ÖZELLİK AYARLA",
            ASSIGN_OWNER: "Sahip Ata",
            QUESTION: "SORU",
            CLOSE_CHAT: "SOHBETİ KAPAT",
            CREATE_TICKET: "TICKET OLUŞTUR",
            TRANSFER_CHAT: "SOHBETİ AKTAR",
            TRANSFER_TO_CHATBOT: "CHATBOTA YÖNLENDİR",
            TAG_CHAT: "ETIKET EKLE",
            REMOVE_TAG: "ETIKET SIL",
            SET_DEPARTMENT: "DEPARTMANA AYARLA",
            SEND_TRANSCRIPT: "TRANSKRİPT GÖNDER",
            SEND_SMS: "SMS GONDER",
            SEND_MAIL: "MAIL GONDER",
            CREATE_EVENT: "ETKİNLİK OLUŞTUR",
            CREATE_RESERVATION: "REZERVASYON OLUŞTUR",
            RESERVATION_OPEN_URL: "Rezervasyon Ekranı Görüntüle",
            RESERVATION_SELECT_DAY: "Rezervasyon günü seç",
            RESERVATION_EVENT_LIST: "Müşteri Rezervasyon Listesi",
            RESERVATION_SELECT_TIME: "Rezervasyon saati seç",
            CREATE_TASK: "GÖREV OLUŞTUR",
            SHOPIFY_SHOW_PRODUCTS: "SHOPIFY ÜRÜNLERİ GÖSTER",
            SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY ÜRÜN VARLIĞI",
            SHOPIFY_ORDER_STATUS: "MAĞAZA SİPARİŞ DURUMU",

            AKINON_SHOW_PRODUCTS: "AKINON ÜRÜN GÖSTER",
            AKINON_FIND_PRODUCT: "AKINON ÜRÜN BUL",
            AKINON_ORDER_STATUS: "AKINON SİPARİŞ DURUMU",
            AKINON_SELECT_ORDER: "AKINON SİPARİŞ SEÇ",
            AKINON_SELECT_SIZE: "AKINON BEDEN SEÇ",
            AKINON_FIND_NEAREST_STOCK: "MAĞAZA STOK GÖSTER",
            AKINON_FIND_NEAREST_STORES: "YAKIN MAĞAZALARI GÖSTER",
            AKINON_SHOW_DISCOUNT_CODES: "İNDİRİM KODU GÖSTER",

            IDEASOFT_SELECT_ORDER: "SİPARİŞ SEÇ",
            IDEASOFT_ORDER_STATUS: "SİPARİŞ DURUMU ÇEK",
            IDEASOFT_GET_MEMBER_INFO: "ÜYE DETAY GETİR",

            followingAttributesFilled: "Aşağıdaki niteliklerler dolu olarak gelecektir.",
            GET_LOCATION: "KONUM AL",
            FALLBACK: "AKSİ DURUM",
            TIMEOUT: "ZAMAN AŞIMI",
            SUCCESS: "BAŞARILI",
            FAILURE: "BAŞARISIZ",

            Probel_Actions: "Probel Aksiyonları",
            PROBEL_SELECT_BRANCH: "Branş Seç",
            PROBEL_SELECT_CLINIC: "Poliklinik Seç",
            PROBEL_SELECT_DAY: "Randevu Günü Seç",
            PROBEL_SELECT_HOUR: "Randevu Saati Seç",
            PROBEL_MAKE_APPOINTMENT: "Randevu Oluştur",
            PROBEL_CANCEL_APPOINTMENT: "Randevu İptal",
            PROBEL_GET_PATIENT_TOKEN: "Hasta Token Al",
            PROBEL_FILL_INFO: "MERNIS Bilgi Getir",
            PROBEL_SELECT_APPOINTMENT: "Randevu Seç",
            SUPPRESSION_ADD: "Kullanıcı Engelle",
            SUPPRESSION_REMOVE: "Kullanıcı Engel Kaldır",
            SEND_WP_BUSINESS_MESSAGE: "WHATSAPP MESAJ GÖNDER",
            INSTAGRAM_COMMENT_REPLY: "Yorumu Yanıtla",
            INSTAGRAM_COMMENT_DELETE: "Yorumu Sil",
            INSTAGRAM_COMMENT_SHOW: "Yorumu Göster",
            INSTAGRAM_COMMENT_HIDE: "Yorumu Gizle",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "Yoruma DM Yanıt",

            TABLE_CREATE_RECORD: "Kayıt Oluştur",
            TABLE_DELETE_RECORD: "Kayıt Sil",
            TABLE_UPDATE_RECORD: "Kayıt Güncelle",
            TABLE_FIND_RECORD: "Kayıt Bul",
            TABLE_FIND_RECORDS: "Kayıt Listele",

            message: "Mesaj",
            condition: "Şart",
            score: "Skor",
            equal: "eşit",
            not_equal: "eşit değil",
            contain: "içerir",
            not_contain: "içermez",
            starts_with: "ile başlar",
            ends_with: "ile biter",
            empty: "boş",
            longer_than: "daha uzun",
            shorter_than: "daha kısa",
            less_than: "daha az",
            less_than_equal: "küçük eşittir",
            greater_than: "büyüktür",
            greater_than_equal: "büyük eşittir",
            value: "Değer",
            failures: "Başarısız",
            email: "E-posta",
            name: "İsim",
            username: "Kullanıcı adı",
            source: "Kaynak",
            language: "Dil",
            timezone: "Saat Dilimi",
            region: "Bölge",
            country: "Ülke",
            referrer: "Yönlendiren",
            url: "URL",
            ip: "IP",
            city: "Şehir",
            lastSeen: "Son Görülen",
            userId: "Kullanıcı ID",
            selectStep: "Adım'ı Seçin",
            keywords: "Anahtar Kelime",

            userSays: "Kullanıcının Söyledikleri",
            addKeyword: "Anahtar Kelime Ekle",
            addUserMessage: "Kullanıcı Mesajı Ekle",
            set: "Özellik",
            to: "ile",
            gender: "Cinsiyet",

            go_to_failure: "Başarısız Yanıt adımına git",
            go_to_success: "Başarılı Yanıt adımına git",
            untilFilled: "sürekli",
            time1: "Bir kere",
            time2: "2 kere",
            time3: "3 kere",
            time4: "4 kere",
            time5: "5 kere",
            any: "Herhangi birşey",
            anytext: "Herhangi bir yazı (harfler veya boşluklar)",
            anytextDescription: "Boş olmayan harfler ve boşluklarla eşleşir",
            alphanumeric: "Harfler Ve Sayılar",
            integer: "Tam Sayı",
            no: "Hayır",
            number: "Sayı",
            phone: "Telefon",
            yes: "Evet",
            yesNo: "Evet - Hayır",
            anyDescription: "Boş olmayan herhangi bir şeyle eşleşir.",
            alphanumericDescription: "Hem harflerle hem de sayılarla eşleşir.",
            integerDescription: "Herhangi bir tamsayı ile eşleşir.",
            noDescription: "Hayır ile eş anlamlı sözcüklerle eşleşir.",
            numberDescription: "Sıralı temel sayıylarla eşleşir.",
            phoneDescription: "Telefon numarasıyla eşleşir.",
            yesDescription: "Evet kelimesinin eş anlamlılarıyla eşleşir.",
            yesNoDescription: "Evet ve hayır kelimelerinin eşanlamlılarıyla eşleşir.",
            emailDescription: "E-postayla eşleşir.",
            urlDescription: "URL ile eşleşir.",
            temperature: "Sıcaklık",
            askWhenInvalid: "geçersiz olursa sor",
            applyFilter: "Filtre Ekle",
            notificationMessageStartSuccess: "Blok ",
            notificationMessageEndSuccess: " Eklendi",
            notificationMessageStartError: "Bir hata oluştu, blok ",
            notificationMessageEndError: " eklenemedi",
            blockChangedWannaUpdate: "Güncellemeyi Kaydetmek İstiyormusunuz ?",
            TEXT: "Yazı",
            IMAGE: "Resim",
            GALLERY: "Galeri",
            BUTTON: "Buton",
            RANDOM_TEXT: "Rastgele Yazı",
            AI_RANDOM_TEXT: "Yapay Zeka Rastgele Yazı",
            AI_IMAGE: "Yapay Zeka Resim",
            QUICK_REPLY: "Hızlı Cevap",
            FILE: "Dosya",
            responses: "Tepkiler",
            flow: "Akış",
            active: "Aktif",
            passive: "Pasif",

            chooseAttributeType: "Özellik Türünü Seçin",
            imageAttachment: "Resim Ekleme",
            audioAttachment: "Ses Ekleme",
            videoAttachment: "Video Ekleme",
            documentAttachment: "Belge Ekleme",
            anyAttachment: "Herhangi bir Ek",
            typeAttributeValue: "Özellik Değerini Gir",
            typeSearchValue: "Arama Değeri yazın",
            male: "Erkek",
            addAttribute: "Özellik Ekle",
            addAttributeDescription:
                "Özniteliğin adı yalnızca A-Z harfleri, 0-9 sayıları, tire veya alt çizgi olan alfasayısal karakterler içerebilir.",
            USER_DATA: "Kullanıcı Bilgisi",
            CUSTOM_ATTRIBUTES: "ÖZEL ÖZNİTELİKLER",
            enterBotResponseHere: "Buraya Bot'un soracağı soruyu yazın...",

            addCard: "Kart Ekle",
            addButton: "Buton Ekle",
            typeCardTitle: "Kart Başlığı",
            typeCardDescription: "Kart Açıklaması",
            dragAndDropBrowse: "Resim Yükle",
            dragAndDropBrowseFile: "Upload File",
            button: "Buton",
            enterYourMessage: "Mesajınızı Girin",
            imageView: "Resim görünümü",
            imageUploading: "Resim Yükleniyor...",
            fileUploading: "File Uploading...",
            clickToChooseNewImage: "Yeni Resim Seçmek İçin Tıklayın",
            clickToChooseNewFile: "Click To Choose New File",
            removeTheExistingOne: "Mevcut Olanı Kaldır",
            validateResponseWithEntity: "Yanıtı Doğrula",
            actionOnFailureInput: "Hatalı Yazım Durumunda Ne Yapılsın?",
            askNextQuestion: "Bir sonraki soruyu sor",
            goToSuccessBlock: "Başarılı Bloğuna Git",
            goToFailureBlock: "Başarısız Bloğuna Git",
            saveResposeToAttribute: "Yanıtı Kaydet",
            selectReplyType: "Yanıt Türü'nü seçin",
            questionVariants: "Soru Çeşitleri",
            systemEntities: "Tanımlı Doğrulama İfadeleri",
            delay: "Gecikme",
            retrySectionTextPart: " sor.",
            retrySectionText: "Kulanıcının yanıtı geçersiz ise ",
            addNextQuestion: "Sonraki Soruyu Ekle",
            typeBlockTitle: "Blok başlığı",
            versionHistory: "Sürüm Geçmişi",
            restore: "Güncelle",
            versionName: "Versiyon Adı",
            restoreModalText:
                "Bu eylem, seçilen sürümü geri yükleyecektir. Bu sürümü geri yüklemek istediğinizden emin misiniz?",
            restoreVersion: "Versiyon Güncelle",
            newVersion: "Yeni Versiyon",
            synonymMustBeUnique: "Aynı Eşanlamlı Kelimeleden Birden Fazla Olamaz ",
            save: "Kaydet",
            entries: "Girdiler",
            youHaveNoEntries: "Girdi Bulunamadı",
            inputsCantBeEmpty: "Alanlar Boş Bırakılamaz",
            entryNamesMustBeUnique: "Anahtar Kelime Aynı Olamaz!",
            entityNameCantBeEmpty: "Varlık Adı Boş Bırakılamaz",
            entityNameMustBeUnique: "Varlık Adı Aynı Olamaz",
            synonyms: "Eş Anlamlılar",
            title: "Anahtar Kelime",
            entryName: "Girdi Adı",
            entities: "Varlıklar",
            entityhasbeenUpdatedSuccessfully: "Varlık Başarıyla Kaydedildi",
            emptyError: "Gerekli Alanlar Boş Bırakılamaz",

            allChats: "Tüm Sohbetler",
            paidChats: "Ücretli Sohbetler",
            busiestPeriod: "En Yoğun Dönem",
            ratingDistribution: "Puanlama Dağılımı",
            allMessages: "Tüm mesajlar",
            avarageMessages: "Ortalama Mesajlar",
            popularity: "Popülerlik",
            allUsers: "Tüm kullanıcılar",
            interactionName: "Etkileşim Adı",
            numberOfMessage: "Mesaj Sayısı",
            ofAllUsersMessage: "% Tüm Kullanıcıların Mesajı",

            totalData: "Toplam Veri",
            avgData: "Ortalama Veri",
            exportToCsv: "Csv'ye Aktar",
            exportToExcel: "Excel'e Aktar",
            inMaintenance: "Yapım Aşamasında",
            ADD_TO_SEGMENT: "Segment Ekle",
            REMOVE_FROM_SEGMENT: "Segmentten Çıkar",
            users: "Kullanıcılar",
            webhookName: "Webhook Adı",
            webHookUrl: "Webhook url",
            webHookToken: "Webhook Token",
            delete: "Sil",
            basicAuth: "Basic Auth",
            requiredFieldsCannotBeLeftBlank: "Zorunlu Alanlar Boş Bırakılamaz ",

            yourVerificationToken: "Token",
            yourWebHookName: "Webhook Adınız",
            yourWebHookUrl: "Webhook URL'niz",
            enterKey: "Key",
            password: "Şifre",
            headerValue: "Value",
            saveSuccessfully: "İşleminiz Başarıyla Kaydedildi.",
            urlTypeError: "Lütfen Alanı Doğru Şekilde Doldurunuz (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "OpenAI Chat GPT-4o İçin Api Anahtarı Gerekli.",
                apiKeyDesc:
                    "Chatbot + Chat GPT-4o entegrasyonu için Api Key gereklidir. Lütfen api anahtarınızı alın veya deneme için aşağıdaki api anahtarını kullanın. Deneme amaçlı sadece 20 mesaj kullanabilirsiniz.",
                getApiKey: "Bir Open AI Api Anahtarını Alın",
                typeApiKey: "Api anahtarını yazın",
                ownApiKey: "OpenAI Api Anahtarına Sahip Olun",
                trialApiKey: "Deneme Api Anahtarı (20 Mesaj Olarak Sınırlıdır)",
                useOurTrial: "Ücretsiz Deneme Sürümümüzü Kullanın",
                twentyMessages: "20 Mesajı ücretsiz olarak kullanıp deneyebilirsiniz.",
                enableChatGpt3: "Chat GPT-4o Aktifleştirin",
            },
        },
        coupon: {
            code: "Kod",
            discount: "İndirim",
            endDate: "Bitiş Tarihi",
            name: "İsim",
            email: "E-posta",
            phone: "Telefon",
            add: "Kupon Ekle",
            coupons: "Kuponlar",
            couponDeleted: "Kupon Silindi",
            limit: "Limit",
            visitorBan: "Visitör engellenmiştir.",
            visitorUnBlock: "Engeli Kaldırılmıştır.",
        },
        instagramTitle: "Instagram Özelliklerini etkinleştirmek için aşağıdaki butona tıklayın.",
        instegramFunctionActive: "Instagram Özelliğini Etkinleştir",
        ChatBOT: "Chat Bot",
        WhatsappContacts: "Whatsapp Kişileri",
        InstagramContacts: "Instagram Kişileri",
        MessengerContacts: "Messenger Kişileri",
        volumeUp: "Sesi Aç",
        minimize: "Küçült",
        maximize: "Büyüt",
        auditLogs: {
            auditLogsTitle: "Denetim Logları",
            auditLogsSub:
                "Denetim günlükleri, son 30 gün içinde şirketinizde gerçekleşen olayları takip etmenizi sağlar.",
        },
        task: {
            priority_lowest: "En Düşük",
            priority_low: "Düşük",
            priority_medium: "Orta",
            priority_high: "Yüksek",
            priority_highest: "En Yüksek",
            workflowActions: "İş Akışı Eylemleri",
            workflowTitle: "İş Akışı Başlığı",
            deleteTask: "Görevi Sil",
            archivingDate: "Arşivleme Tarihi",
            selectOption: "Bir Seçenek Seçin",
            notAuthorizedCreateTask: "Görev Oluşturma Yetkiniz  Yok",
            notAuthorizedCreateTaskDesc: "Bu işlemi yapmak için yetkiniz bulunmamaktadır.",
            goToMessage: "Mesaja git",
            goToChat: "Sohbete git",
            showVisitor: "Ziyaretçiyi Göster",
            closeTheTask: "Görevi Kapat",
            sureAddCompletedList: "Görevi Tamamlandı Listesine Eklemek İstediğinize Emin Misiniz?",
            success: "Başarılı",
            successDesc: "Başarılı bir şekilde yeni alan eklendi.",
            moveAndDeleteTask: "Taskları Taşı ve Sil",
            justDelete: "Sadece Sil",
            selectColumnMoveTask: "Taskları taşımak istediğiniz sütunu seçiniz",
            todo: "Yapılacaklar",
            inProgress: "Devam Ediyor",
            approval: "Onaylandı",
            completed: "Tamamlandı",
            addAComment: "Yorum ekleyin...",
            deleteComment: "Yorumu silmek istediğinize emin misiniz?",
            edited: "Düzenlendi",
            comments: "Yorumlar",
            addComment: "Yorum Ekle",
            workflow: "İş Akışı",
            workflowDetail: "İş Akışı Detay",
            workflowPerm: "İş Akışı Yetkileri",
            perm: "Yetkiler",
            detail: "Detaylar",
            userPerm: "Kullanıcı Yetkileri:",
            deleteCard: "Kart Silme",
            createCard: "Kart Oluşturma",
            editCard: "Kart Düzenleme",
            dragCard: "Kart Taşıma",
            allWorkflow: "Tüm İş Akışları",
            createworkflow: "İş Akışı Oluştur",
            deleteWorkflow: "Bu İş Akışını Silmek İstediğinize Emin Misiniz?",
            permEditTask: "Bu Taskı Düzenleme Yetkiniz Yok",
            permEditTaskDes: "Düzenleme Yetkisi İçin Yöneticinizle İletişime Geçiniz.",
            createTaskError: "Görev Oluşturma Yetkiniz Yok",
            createTaskErrorDesc: "Görev Oluşturma Yetkisi İçin Yöneticinizle İletişime Geçiniz",
            moveTaskError: "Görev Durumu Değiştirme Yetkiniz Yok",
            moveTaskErrorDesc: "Görev Durumu Değiştirme Yetkisi İçin Yöneticiniz ile İletişime Geçiniz",
            deleteTaskError: "Görev Silme Yetkiniz Yok",
            deleteTaskErrorDesc: "Görev Silme Yetkisi İçin yöneticinizle İletişime Geçiniz",
            permissionError: "Görev Oluşturma Yetkiniz Yok",
            permissionErrorDesc: "Görev Oluşturma Yetkisi İçin Yöneticinizle İletişime Geçiniz",
            whatsappContactProfileTitle: "{name} / {number} Profili",
            createTaskVisitor: "Görev Oluştur (Ziyaretçi)",
            editWorkflow: "Workflow'u Düzenle",
            visitor: "Ziyaretçi Profili",
            createTaskMessage: "Görev Oluştur (Mesaj)",
            createStage: "Aşama Oluştur",
            stagesAndStatuses: "Aşamalar ve Durumlar",
            workflowCreateDesc: "Workflow Açıklaması",
            subTasks: "Alt Görevler",
            followers: "Takipçiler",
            collaborators: "Üzerinde çalışanlar",
            addRelations: "İlişki ekle",
            relations: "İlişkili",
            main: "Ana Sekme",
            name: "Adı",
            completedOfCheck: "{total} görevden {completed} tamamlandı",
            workflowUpdateMs: "Workflow Başarıyla Güncellendi",
            taskUpdateMs: "Görev Başarıyla Güncellendi",
            workflowCreatedMs: "İş Akışı Başarıyla Oluşturuldu",
            workflowCreateError: "İş Akışı Oluşturulamadı",
            taskCreatedMs: "Görev Başarıyla Oluşturuldu",
            settingsDesc4:
                "Bu şekilde, her bir görevinizi detaylı bir şekilde izleyebilir, ekip üyelerine görev atamaları yapabilir ve genel olarak iş süreçlerinizi daha etkili bir şekilde yönetebilirsiniz. Supsis görev modülü, iş yönetimi ve takım koordinasyonu konusunda size kapsamlı bir çözüm sunar.",
            settingsDesc3:
                "Ayrıca, Supsis görev modülü, özelleştirilebilir bir iş akışıyla kendi çalışma düzeninizi oluşturmanıza olanak tanır. Otomatizasyonlarla görevleri daha etkili bir şekilde yönetebilir ve ekip içindeki işbirliğini artırabilirsiniz.",
            settingsDesc2:
                "Supsis görev modülü, hiçbir görevin gözden kaçmasına izin vermez. Görevleri herhangi bir parametreye göre filtreleyebilir, her iş akışı aşamasının iş yükünü takip edebilir ve takviminizi düzenleyebilirsiniz, böylece zamanlamalarınıza uyum sağlayabilirsiniz.",
            settingsDesc1:
                "Görevler modülü, işbirliği içindeki çalışmaları düzenlemenize, görevleri devretmenize ve takımınızın ilerlemesini izlemenize olanak tanır. İhtiyaçlarınıza göre görevlerinizi herhangi bir görünümü seçerek düzenleyebilir ve otomasyonlarla kendi özel iş akışınızı oluşturabilirsiniz.",
            taskModuleSettingsTitle: "Görev Modülü Ayarları",
            high: "Yüksek",
            medium: "Orta",
            low: "Düşük",
            priority: "Öncelik",
            addExistsSubtask: "Varolan Alt Görevi Ekle",
            addSubtask: "Alt Görev Ekle",
            add: "Ekle",
            newCheckList: "Yeni Kontrol listesi",
            subtaskTitle: "Alt Görev Başlığı",
            view: "Görüntüle",
            attachFiles: "Dosya ekle",
            createTaskDesc: "Görev açıklaması",
            title: "Başlık",
            createWorkflow: "İş Akışı Oluştur",
            editTask: "Görevi Düzenle",
            createTask: "Görev Oluştur",
            deleteColumnCont: "Bu kolonu silmek istediğinizden emin misiniz ?",
            changeStage: "Durum Değiştir",
            assignees: "Atananlar",
            owner: "Sahip",
            stage: "Durum",
            writeSomething: "Bir şey yazın",
            selectAssginee: "Atanacak Kişi",
            assignee: "Atanan",
            enterNewTaskDesc: "Yeni Görev Açıklaması",
            enterNewTaskTitle: "Yeni Görev Başlığı",
            task: "Görev",
            deleteTaskCont: "Bu görevleri silmek istediğinizden emin misiniz ?",
            deleteWorkFlowCont: "Bu Workflow'u silmek istediğinizden emin misiniz?",
            kanbanBoard: "Kanban Panosu",
            listView: "Liste Görünümü",
        },
        permissionErrors: {
            userCreate: "Kullanıcı Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            userRead: "Kullanıcıları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            userUpdate: "Kullanıcıları Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            userDelete: "Kullanıcıları Silmek için yetkiniz yok. Yöneticinizle görüşün",
            visitorBlock: "Ziyaretçileri Engellemek için yetkiniz yok. Yöneticinizle görüşün",
            visitorUnblock: "Ziyaretçileri Engelini Açmak için yetkiniz yok. Yöneticinizle görüşün",
            visitorDetailRead: "Ziyaretçi Detayı Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            visitorListRead: "Ziyaretçi Listesini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            visitorDelete: "Ziyaretçi Silmek için yetkiniz yok. Yöneticinizle görüşün",
            visitorExcel: "Excel Çıktısı Almak için yetkiniz yok. Yöneticinizle görüşün",
            visitorUpdate: "Ziyaretçi Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            bannedVisitorRead: "Yasaklı Ziyaretçi Listesini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            bannedWordCreate: "Yasaklı Kelime Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            bannedWordRead: "Yasaklı Kelimeleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            bannedWordDelete: "Yasaklı Kelimele Silmek için yetkiniz yok. Yöneticinizle görüşün",
            chatRead: "Konuşmaları Görmek için yetkiniz yok. Yöneticinizle görüşün",
            chatUpdate: "Konuşmaları Düzenlemek için yetkiniz yok. Yöneticinizle görüşün",
            archiveRead: "Arşivi Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            roleCreate: "Rol Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            roleRead: "Rolleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            roleUpdate: "Rolleri Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            roleDelete: "Rol Silmek için yetkiniz yok. Yöneticinizle görüşün",
            departmentCreate: "Departman Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            departmentRead: "Departmanları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            departmentUpdate: "Departman Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            departmentDelete: "Departman Silmek için yetkiniz yok. Yöneticinizle görüşün",
            preparedContentCreate: "Hazır İçerik Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            preparedContentRead: "Hazır İçerik Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            preparedContentUpdate: "Hazır İçerik Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            preparedContentDelete: "Hazır İçerik Silmek için yetkiniz yok. Yöneticinizle görüşün",
            welcomeCreate: "Karşılama Mesajı Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            welcomeRead: "Karşılama Mesajlarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            welcomeUpdate: "Karşılama Mesajı Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            welcomeDelete: "Karşılama Mesajı Silmek için yetkiniz yok. Yöneticinizle görüşün",
            settingCreate: "Ayar Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            settingRead: "Ayarları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            settingUpdate: "Ayarları Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            settingDelete: "Ayar Silmek için yetkiniz yok. Yöneticinizle görüşün",
            reportCreate: "Rapor Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            reportRead: "Raporları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            reportUpdate: "Raporları Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            reportDelete: "Rapor Silmek için yetkiniz yok. Yöneticinizle görüşün",
            offlineSupportRequestCreate: "Ticket Oluşturmak için yetkiniz yok. Yöneticinizle görüşün ",
            offlineSupportRequestRead: "Ticketleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            offlineSupportRequestUpdate: "Ticketlere Cevap Vermek için yetkiniz yok. Yöneticinizle görüşün",
            offlineSupportRequestDelete: "Ticketleri Silmek için yetkiniz yok. Yöneticinizle görüşün",
            catalogCreate: "Katalog Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            catalogRead: "Katalogu Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            catalogUpdate: "Katalog Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            catalogDelete: "Katalog Silmek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotStoryCreate: "Chatbot Hikayesi Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            chatbotStoryRead: "Chatbot Hikayelerini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotStoryUpdate: "Chatbot Hikayelerini Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotStoryDelete: "Chatbot Hikayelerini Silmek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotTemplateRead: "Chatbot Şablonlarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotTemplateAiRead: "Yapay Zeka Chatbot Şablonlarını Görmek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotIntegrationsRead: "Chatbot Entegrasyonlarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotArchiveRead: "Chatbot Arşivi Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotEntitiesRead: "Chatbot Varlıklarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotEntitiesCreate: "Chatbot Varlığı Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            chatbotEntitiesUpdate: "Chatbot Varlıklarını Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotEntitiesDelete: "Chatbot Varlıkları Silmek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotReportRead: "Chatbot Raporlarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotTrainRead: "Chatbot Eğitimini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotSegmentCreate: "Chatbot Kullanıcı Segmenti Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            chatbotSegmentRead: "Chatbot Kullanıcı Segmentlerini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotSegmentUpdate:
                "Chatbot Kullanıcı Segmentlerini Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotSegmentDelete: "Chatbot Kullanıcı Segmentlerini Silmek için yetkiniz yok. Yöneticinizle görüşün",
            integrationsRead: "Entegrasyonlar Sayfasını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            whatsappIntegrationRead:
                "Whatsapp Entegrasyon Sayfasını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            instagramIntegrationRead:
                "Instagram Entegrasyon Sayfasını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            telegramIntegrationRead:
                "Telegram Entegrasyon Sayfasını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            integrationCreate: "Entegrasyon Etkinleştirmek için yetkiniz yok. Yöneticinizle görüşün",
            triggerCreate: "Tetikleyici Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            triggerRead: "Tetikleyicileri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            triggerUpdate: "Tetikleyicileri Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            triggerDelete: "Tetikleyici Silmek için yetkiniz yok. Yöneticinizle görüşün",
            billingRead: "Faturaları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            taskCreate: "Görev Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            taskRead: "Görevleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            taskUpdate: "Görevleri Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            taskDelete: "Görev Silmek için yetkiniz yok. Yöneticinizle görüşün",
            calendarCreate: "Takvim/Rezervasyon Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            calendarRead: "Takvim/Rezervasyon Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            calendarUpdate: "Takvim/Rezervasyon Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            calendarDelete: "Takvim/Rezervasyon Silmek için yetkiniz yok. Yöneticinizle görüşün",
            mailCreate: "Mail Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            mailRead: "Mailleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            mailUpdate: "Mailleri Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            mailDelete: "Mail Silmek için yetkiniz yok. Yöneticinizle görüşün",
        },
        message: {
            createDepartment: "Departman Oluştur",
            goToLink: "Linke Git",
            emailAddressYouProvide: "Belirttiğiniz e-posta adresiyle zaten bir kullanıcı hesabı oluşturulmuş.",
            channelPrivacyPolicyNotMet: "Kanal gizlilik politikasına uymuyor",
            userIsNotInDepartment: "Kullanıcı bu departman içinde bulunmuyor",
            currentDepartment:"Mevcut Departman",
            validDepartment:"Geçerli Departman",
            youCanForwardToThisDepartment:"Bu departmana yönlendirme yapabilirsiniz",
            goToSettings:"Ayarlara Git",
            changeDepartmentAndForward:"Departmanı Değiştir ve Yönlendir",
            selectDepartmentToForwardAgent:"Lütfen konuşmayı {selectAgentName} adlı temsilci için hangi departman üzerinden yönlendirmek istediğinizi seçiniz.",
            selectDepartmentToForward: "Yönlendirmek için Departman Seçin",
            packageConfirmationMessage: "Paket satın almak istediğinize emin misiniz? Aldığınız paket anlık ücrete tabidir. İptal ettiğinizde 1 yıl boyunca kullanmaya devam edebilirsiniz. Bu ürünün fiyatı %20 KDV harici fiyatıdır.",
            packagePurchaseConfirmation: "Paket satın almak istediğinize emin misiniz? Aylık alınan paketler, her ay başı ücretlendirilecektir. İptal ettiğiniz günden sonra paket kullanımı bitmektedir. Bu ürünün fiyatı %20 KDV harici fiyatıdır.",
            annualPurchaseDiscount: "Yıllık Satın Alımlarda %30 İndirim Fırsatını Yakala",
            customerTables: "Müşteri Tabloları",
            formIntegration: "Form Entegrasyonu",
            automationIntegration: "Otomasyon Entegrasyonu",
            remainingAutomationTask: "Kalan Otomasyon Görevi",
            createUserError: "Kullanıcı oluşturulurken bir hata oluştu",
            sendTemplateMessage: "Şablon Mesaj Gönder",
            startChatWithDifferentChannel: "Farklı Kanal ile Sohbet Başlat",
            whatsappChatStarter: "Whatsapp Chat Başlatıcı",
            pressEnterToJoin: "Enter tuşuna basarak sohbete katılabilirsiniz",
            pressEnterToStartChat: "Enter tuşuna basarak sohbet başlatabilirsin",
            cannotSendMessage: "Bu Kişiye Mesaj Gönderemezsiniz",
            cannotSendSessionMessage: "Bu kişiye oturum mesajı gönderemezsiniz",
            conversationNotInYourDepartments: "Bu konuşma dahil olduğunuz departmanlardan birine ait değil",
            customizeImage: "Görseli Özelleştirmek İstiyorsanız",
            clickToUpload: "Resim yüklemek için buraya tıklayın",
            uploadNote: "Yükleme için kabul edilen dosya formatları ve boyutları aşağıdaki gibidir",
            imageSize: "Resim 2 MB'dan büyük olduğu için yüklenemedi",
            videoSize: "Video 20 MB'dan büyük olduğu için yüklenemedi",
            documentSize: "Belge 2 MB'dan büyük olduğu için yüklenemedi",
            uploading: "Resim yükleniyor, lütfen bekleyin...",
            uploadSuccess: "Resim başarılı bir şekilde yüklendi",
            note: "Not",
            gridView: "Kutu Görünümü",
            completedTasks: "Tamamlanmış Görevler",
            system: "Sistem",
            destroyedBy: "Sohbeti Kapatan",
            channelCreatedSuccess: "Kanal başarıyla oluşturuldu",
            channelCreatedError: "Kanal oluşturma başarısız oldu",
            plans: {
                types: {
                    supsis: "Temsilci Paketleri",
                    chatbot: "Chatbot",
                    automation: "Otomasyon",
                    customer_tables: "Müşteri Tablosu",
                    mail: "E-Posta",
                    tasks: "Görevler",
                    form: "Form",
                    whatsapp: "Whatsapp",
                    whatsapp_business: "Whatsapp Business",
                    instagram: "Instagram",
                    messenger: "Messenger",
                    meta_lead: "Meta Lead",
                    trendyol: "Trendyol",
                    "artificial_intelligence": "Yapay Zeka",
                    "webhook": "Webhook",
                },
            },
            vipCustomerDescription:
                "Bu kişiyi VIP müşteri olarak işaretlemek, bekleme sırasında en üst sıraya taşır ve öncelikli hizmet almasını sağlar",
            switchOn: "Açık",
            switchOff: "Kapalı",
            ownerDescription:
                "Bu özellik, bir kişinin sahibini belirtir. Kişi sahibinin durumu (çevrimiçi ya da çevrimdışı) fark etmeksizin, açılan sohbetler her zaman sahibine atanır. Sahipli kişiler yalnızca ilgili sahip tarafından görüntülenebilir.",
            permissionError: "Bu işlemi yapmaya yetkiniz yok!",
            copySuccess: "İçerik başarıyla kopyalandı!",
            unowned: "Sahipsiz",
            jsonPreview: "JSON ÖNİZLEME",
            enterNewValue: "Yeni değer girin",
            updatePreferredLanguage: "Tercih Edilen Dili Güncelle",
            updateTags: "Etiketleri Güncelle",
            updateEmail: "E-posta Güncelle",
            enterNewEmail: "Yeni e-posta girin",
            deleteConfirmation: "Silme Onayı",
            confirmDelete: "Bu özelliği silmek istediğinizden emin misiniz?",
            yesDelete: "Evet, Sil",
            vipCustomer: "★ VIP Müşteri",
            takeControlFromChatbot: "Chatbot'tan Kontrolü Al",
            enterJoin: "Enter tuşuna basarak sohbete katılabilirsiniz",
            watchChat: "Konuşmayı İzle",
            untitledAutomation: "👉 İsimsiz Profil Tıklama Otomasyonu",
            event: "Etkinlik",
            chatbotSettings: "Chatbot Yönlendirme Ayarları",
            chatbotScenarioNotFound: "Chatbot Senaryosu Bulunamadı",
            noChatbotScenario: "Sistem üzerinde bir chatbot senaryosu bulunamadı.",
            scenarioNotFound: "Senaryo bulunamadı",
            descNotAvailable: "Açıklama Bulunmuyor",
            lastRegulation: "Son Düzenleme",
            taskCreator: "Görevi Oluşturan",
            noPermissionDescription: "Bu işlemi yapmak için yetkiniz bulunmamaktadır.",
            notAppointed: "Atanmadı",
            changeStage: "Aşama Değiştir",
            selectedCandidates: "1 seçilen aday(lar)",
            coverPhotoRemove: "Kapak Fotoğrafını Kaldır",
            coverPhotoSet: "Kapak Fotoğrafı Olarak Ayarla",
            autoTransfer: "Kişilerinizi Otomatik Zohoya Aktar",
            autoTransferDescription:
                "Bu kanala gelen kişiler Zoho CRM Contact Modülüne otomatik aktarılır. Zohoya aktarılan kişilerde Zoho widget'larını aktif eder.",
            zohoChannelRequiredTitle: "Zoho CRM Kanalı Gerekli",
            zohoChannelRequiredContent: "Zoho CRM kanalınız bulunmamaktadır. Hemen eklemek için tıklayınız.",
            okText: "Zoho CRM Kanalı Ekle",
            cancelText: "İptal",
            forceQueueForNoOwnerContacts: "Sahipsiz Kişileri Kuyrukta Beklemeye Zorla",
            autoForwardToOwnerForce: "Sahipli Kişileri Otomatik Sahibine Aktar (Chatbot Açıkken bile)",
            autoForwardToOwnerForceDescription:
                "Her durumda sahipli kişiler otomatik olarak sahibine aktarılır. Ne kuyrukta bekletilir nede chatbot chatbot'a aktarılır. Bu ayar kapalı bile olsa eğer sistemde chatbot aktif değilse yine sahibine aktarılır.",
            forceQueueDescription:
                "Sadece sahipli kişiler otomatik atanırken, sahipsiz kişileri kuyrukta bekletmeye zorlar.",
            showNoOwnerContactsToAdmins: "Sahipsiz Kişileri Sadece Adminlere Göster",
            showNoOwnerContactsDescription: "Sahipsiz kişiler sadece adminlere gözükür",
            autoAssignOwner: "Otomatik Kişi Sahiplendirme",
            autoAssignOwnerDescription: "Chat otomatik bir temsilciye atanırken aynı zamanda sahibi olarak da atanır.",
            creator: "Oluşturan",
            hideShow: "Gizle / Göster",
            url: "URL",
            dropdown: "Seçilebilir",
            selectRepresentativeChatbot: "Temsilci/Chatbot Seç",
            selectDomain: "Domain Seç",
            selectColumns: "Tabloda Görmek İstediğiniz Sütunları Seçiniz",
            cannedMessages: "Hazır Mesajlar",
            templateMessages: "Şablon Mesajlar",
            chatbots: "Chatbotlar",
            noCannedMessages: "Hazır Mesaj Bulunamadı",
            filterToFindMore: "Filtrelerinizi değiştirerek daha fazla hazır mesaj bulabilirsiniz.",
            runPrompt: "Prompt Çalıştır",
            noLeadsFound: "Bu kişi için lead bulunamadı",
            deals: "Anlaşmalar",
            noDealsFound: "Bu kişi için anlaşma bulunamadı",
            loadingDeals: "Anlaşmalar yükleniyor",
            zohoCRM: "Zoho CRM",
            viewContact: "İletişimi Görüntüle",
            noNotesAdded: "Henüz not eklenmemiş",
            attachments: "Ekler",
            addNewNote: "Yeni Not Ekle",
            savingg: "Kaydediliyor...",
            warningFillFields: "Lütfen başlık ve içerik alanlarını doldurun.",
            successNoteAdded: "Not başarıyla eklendi.",
            errorAddingNote: "Not eklenirken bir hata oluştu.",
            noteTitle: "Not Başlığı",
            noteContent: "Not İçeriği",
            selectPreferredAgent: "Ziyaretçiye atamak istediğiniz tercih edilen temsilciyi seçin.",
            postOperations: "Post Operasyonlar",
            loadingPostOperations: "Post operasyonlar yükleniyor",
            noPostOperations: "Bu kişi için post operasyon bulunamadı",
            postOperationDetails: "Post Operasyon Detayları",
            noMediaDocuments: "Bu kişiye ait medya ve belge mevcut değildir.",
            selectionLimitError: "En fazla 30 tane seçebilirsiniz.",
            showNote: "Notu Herkese Göster",
            hideNote: "Notu Gizle",
            updateNote: "Notu Güncelle",
            addUserNote: "Kullanıcı hakkında not ekle",
            privateNote: "Özel Not",
            metaReferrals: "Meta Referrals",
            noMetaReferrals: "Meta reklam etkileşimi bulunmamaktadır.",
            searchPrompt: "Bir Şeyler Arayınız.",
            noRecentResults: "Yakın zamanlarda bir sonuç bulunmadı.",
            contactInfo: "Kişi Bilgileri",
            noPropertiesAdded: "Henüz özellik eklenmemiş.",
            propertyAddedUpdated: "Özellik başarıyla eklendi/güncellendi.",
            propertyError: "Özellik eklenirken/güncellenirken bir hata oluştu.",
            propertyDeleted: "Özellik başarıyla silindi.",
            propertyDeleteError: "Özellik silinirken bir hata oluştu.",
            zohoSynchronization: "Zoho Senkronizasyonu",
            zohoSyncConfirmation: "Kişi değişiklik işlemlerini Zoho'da da yapmak istiyor musunuz?",
            hideOtherInfo: "Diğer Bilgileri Gizle",
            showOtherInfo: "Diğer Bilgileri Göster",
            whatsappChatStart: "WhatsApp Chat Başlat",
            ownership: "Müşteri Sahipliği",
            countryAndLanguage: "Ülke, Dil",
            calendarEvent: "Takvim Etkinliği",
            reservation: "Rezervasyon",
            contact: "İletişim",
            user: "Kullanıcı",
            customerOwnership: "Müşteri Sahipliği",
            ownerless: "Sahipsiz",
            preferredDepartment: "Tercih Edilen Departman",
            flowluTransfer: "Flowlu'ya Aktar",
            mergeSuccess: "Birleştirme işlemi başarıyla gerçekleştirildi.",
            visitorOwnershipWarning: "Bu ziyaretçi başka bir kullanıcının sahipliğinde.",
            newAutomation: "Yeni Otomasyon",
            automations: "Otomasyonlar",
            createProfileAutomation: "Profil Otomasyonu Oluştur",
            profileButtonClicked: "Profil butonuna tıklandı",
            profileButtonDescription: "Bu otomasyon, bir profil butonuna tıklandığında tetiklenecektir.",
            automationName: "Otomasyon adı",
            create: "Oluştur",
            dayRange: "Gün Aralığı",
            hourRange: "Saat Aralığı",
            last24Hours: "Son 24 Saat",
            today: "Bugün",
            yesterday: "Dün",
            thisWeek: "Bu hafta",
            lastWeek: "Geçen hafta",
            last7Days: "Son 7 gün",
            last30Days: "Son 30 gün",
            thisMonth: "Bu ay",
            lastMonth: "Geçen ay",
            startDateTime: "Başlangıç Tarih Saati",
            endDateTime: "Bitiş Tarih Saati",
            complaint: "Şikayet",
            opens: "Açılışlar",
            clicks: "Tıklamalar",
            mockData: "(Sahte Veri)",
            noGrouping: "Gruplama Yok",
            forwardToDepartment: "Departmana İlet",
            toMobileAgents: "Mobil Temsilciler",
            noMediaAndDocuments: "Bu kişiye ait medya ve belge mevcut değildir",
            reportBug: "Hata Raporla",
            waitingForReply: "Cevap Bekliyor",
            memorySize: "Bellek Boyutu",
            usedMemory: "Kullanılan Depolama",
            availableMemory: "Kullanılabilir Depolama",
            memoryLimit: "Aşım Miktarı",
            memoryLimitPrice: "Aşım Ücreti",
            telegramBotIsReachable: "Telegram Bot Servisine Ulaşılıyor",
            telegramBotIsHealthy: "Telegram Bot Servisine Sağlıklı",
            telegramBotIsUnhealthy: "Telegram Bot Servisinde Sorun Var",
            pieView: "Pasta Görünümü",
            chartView: "Grafik Görünümü",
            tableView: "Tablo Görünümü",
            lastUpdate: "Son Güncelleme",
            workflow: "İş Akışı",
            task: "Görev",
            filterBy: "Filtreye Göre",
            watchAllLive: "Tümünü Canlı İzle",
            sessionsUnique: "Oturumlar (Tekil Kullanıcılar)",
            sessionsAll: "Oturumlar (Tüm Kullanıcılar)",
            moreFeaturesDesc:
                "Daha fazla özellik, daha fazla entegrasyon, daha fazla temsilci! Ekibinizi daha iyi yönetmek ve işletmenizi maksimum potansiyeline ulaştırmak için şimdi harekete geçin!",
            metaLeadForms: "Meta Lead Formlar",
            metaLeadsConnectedSucs: "Meta Leads başarıyla bağlandı",
            failedToConnectMetaLeads: "Meta Potansiyel Müşterilere bağlanılamadı",
            forbiddenChannel: "Yasaklı Kanal",
            forbiddenChannelDesc: "Bu kanalı görmenize izin verilmiyor",
            firstContact: "İlk İletişim",
            needsAnalysis: "İhtiyaç Analizi",
            offerSent: "Teklif Gönderildi",
            offerReview: "Teklif İncelemesi",
            decisionPhase: "Karar Aşaması",
            personDeleted: "Kişi Silindi",
            metaLeadsIntegration: "Meta Leads Entegrasyonu",
            phoneNumberIsInvalid: "Telefon numarası geçersiz.",
            owner: "Sahip",
            addAnItem: "Bir öğe ekleyin",
            saveItem: "Öğeyi Kaydet",
            customItem: "Özel Öğe",
            backgroundPhoto: "Arka Plan Resmi",
            whenYouActivateFeature: "Bu özelliği aktif ettiğiniz zaman rezervasyon sayfasında gözükmez",
            logo: "Logo",
            noLogo: "Logo Yok",
            addTeamMember: "Ekip Üyesi Ekle",
            timezone: "Zaman Dilimi",
            selectDayys: "Gün(ler) Seçin",
            selectStartHour: "Başlangıç Saatini Seçin",
            selectEndHour: "Bitiş Saatini Seçin",
            moveLeft: "Sağa Taşı",
            moveRight: "Sola Taşı",
            reply: "Cevap",
            replyToAll: "Herkese Cevapver",
            deleteThreadMessage: "Konu Mesajını Sil",
            totalEmailsBounced: "Geri Dönen Toplam E-posta",
            totalEmailsComplained: "Şikayet edilen toplam e-posta",
            untilNowTotalEmailOpens: "Şimdiye kadar toplam e-posta açılışı",
            untilNowTotalEmailLinkClicks: "Şimdiye kadar toplam e-posta bağlantısı tıklamaları",
            uniqueClicks: "Benzersiz Tıklamalar",
            untilNowTotalUniqueEmail: "Şimdiye kadar toplam benzersiz e-posta bağlantısı tıklamaları (alıcı başına)",
            emailCampaignTimeline: "E-posta Kampanyası Zaman Çizelgesi",
            receivedBroadcasts: "Alınan Yayınlar",
            groupDeletedSuccessfully: "Grup başarıyla silindi",
            verify: "Doğrula",
            done: "Bitti",
            pleaseSelectAnEmailAddress: "Lütfen bir mail adresi seçiniz.",
            goBack: "Geri Dön",
            show: "Göster",
            vueEmailEditor: "Vue E-posta Editörü (Demo)",
            saveDesign: "Tasarım Kaydet",
            exportHTML: "HTML dışa aktar",
            saveAsEmailCustomerGroup: "E-posta Müşteri Grubu Olarak Kaydet",
            saveAsWhatsappCustomerGroup: "Whatsapp Müşteri Grubu Olarak Kaydet",
            deleteModalFormDesc:
                "Bu formu sildiğiniz takdirde, forma ait tüm veriler kalıcı olarak silinecektir. Devam etmek istediğinizden emin misiniz?",
            todo: "Yapılacaklar",
            inProgress: "Devam Ediyor",
            approval: "Onay",
            completed: "Tamamlanmış",
            transactionType: "İşlem Tipi",
            previousBalance: "Önceki Bakiye",
            nextBalance: "Sonraki Bakiye",
            amount: "Tutar",
            wpIntegrationChannelRequired: "Whatsapp Web Entegrasyon Kanalı Gerekli.",
            wpIntegrationChannelRequiredDesc:
                "Chatbot + Whatsapp Web entegrasyonu Whatsapp Web Kanalı gerektirir. Lütfen yeni bir kanal oluşturun.",
            wabaIntegrationChannelRequired: "Whatsapp Business Entegrasyon Kanalı Gerekli.",
            wabaIntegrationChannelRequiredDesc:
                "Chatbot + Whatsapp Business API entegrasyonu Whatsapp Web Kanalı gerektirir. Lütfen yeni bir kanal oluşturun.",
            instaIntegrationChannelRequired: "Instagram Entegrasyon Kanalı Gerekli.",
            instaIntegrationChannelRequiredDesc:
                "Chatbot + Instagram entegrasyonu Instagram Kanalı gerektirir. Lütfen yeni bir kanal oluşturun.",
            createWpChannel: "Whatsapp Web Kanalı Oluştur",
            createWabaChannel: "Whatsapp Business API Kanalı Oluştur",
            createInstaChannel: "Instagram Kanalı Oluştur",
            failedToDeleteGroup: "Grup silinemedi",
            failedToDeleteGroups: "Gruplar silinemedi",
            failedToFetchGroupContacts: "Grup kişileri getirilemedi",
            mailAddressDeletedSuccessfully: "Posta Adresi Başarıyla Silindi",
            defaultMailAddressChangedSuccessfully: "Varsayılan posta adresi başarıyla değiştirildi",
            mailAddressAlreadyRegistered: "Mail adresi zaten kayıtlı veya boş olamaz.",
            pleaseVerifyByClicking: "Mail adresinize gönderilen linke tıklayarak doğrulama yapınız.",
            signSucsRegistered: "İmza başarıyla kaydedildi",
            myContacts: "Kişilerim",
            unanswered: "Cevapsız",
            emailBroadcasts: "Toplu e-mail gönderimleri",
            monthlyLimit: "Aylık Limit",
            totalShipments: "Toplam Gönderim",
            shippingStatus: "Gönderim Durumu",
            lastAction: "Son İşlem",
            receiver: "Alıcı",
            delivered: "Teslim Edildi",
            opened: "Açıldı",
            clicked: "Tıklandı",
            bounced: "Geri Döndü",
            clickedLinks: "Tıklanan Linkler",
            reason: "Sebep",
            timer: "Zamanlayıcı",
            implemented: "Uygulandı mı?",
            module: "Modül",
            excelDownload: "Excel İndir",
            serviceFeatures: "Hizmet Özellikleri",
            mailAddressDeletedSucs: "Mail adresi başarıyla silindi",
            inputSearchText: "Arama metni girin",
            createRecord: "Kayıt Oluştur",
            separatorCharacter: "Ayırıcı Karakter",
            exampleResultPreview: "Örnek Sonuç Önizlemesi",
            importRecords: "Kayıtları İçe Aktar",
            equals: "Eşit",
            notEquals: "Eşit Değil",
            startsWith: "İle Başlar",
            endsWith: "İle Biter",
            greaterThan: "Daha Fazla",
            lessThan: "Daha Az",
            before: "Önce",
            after: "Sonra",
            is: "O",
            isNot: "Değil",
            empty: "Boş",
            notEmpty: "Boş Değil",
            isOneOff: "Tek Seferlik",
            field: "Alan",
            records: "Kayıt",
            addIntegration: "Entegrasyon Ekle",
            chatbotScenarioReleased: "Chatbot Senaryosu yayınlandı",
            chatbotScenarioHasBeenCanceled: "Chatbot Senaryosu yayından kaldırıldı",
            titleAndDesc: "Başlık & Açıklama",
            templateAndMailSelection: "Template & Mail Seçimi",
            peopleToSend: "Gönderilicek Kişiler",
            submissionPlans: "Gönderim Planı",
            summary: "Özet",
            broadcastTitle: "Yayın Başlığı",
            sentByEmail: "Gönderilen Email",
            emailTemplate: "Email Taslağı",
            onlyPeopleWithEmail: "Sadece Mail adresi olan kişiler gönderim için geçerlidir.",
            sendNow: "Şimdi Gönder",
            plan: "Planla",
            senderEmail: "Gönderen E-Posta",
            totalBuyer: "Toplam Alıcı",
            estimatedDuration: "Tahmini Süre",
            person: "Kişi",
            shippingIsNowComplete: "Gönderim işlemi tamamlandı!",
            back: "Geri",
            customerName: "Müşterinin İsmi",
            customerEmail: "Müşterinin Emaili",
            customValue: "Özel Değer",
            selectMailTemplate: "Mail şablonu seçmelisiniz.",
            youMustSelectSendingMailAddress: "Gönderen mail adresi seçmelisiniz.",
            youMustSelectCustomerGroupSend: "Gönderilecek müşteri grubunu seçmelisiniz.",
            createBroadcast: "Toplu Gönderim Oluştur",
            broadcastDetails: "Toplu Gönderim Detayları",
            youCanCheckYourEmailStatus:
                "Paketinizi yükselterek e-posta durumunuzu kontrol edebilirsiniz. Planınızı yükselterek e-posta durumunuzu kontrol edebilirsiniz.",
            sentDetails: "Gönderilen detaylar",
            failed: "Başarısız oldu",
            total: "Toplam",
            totalEmailsProcessed: "İşlenen toplam e-posta",
            totalEmailsDelivered: "Gönderilen toplam e-posta",
            toAvailableAgents: "Mevcut Temsilciler için",
            toAvailableDepartments: "Mevcut Departmanlar için",
            toWithAgentAndDepartment: "Temsilci ve Departman ile",
            toMobilAgents: "Mobil Temsilcilere",
            toPreferredAgents: "Tercih Edilen Temsilcilere",
            searchAgent: "Temsilci Ara",
            searchDepartment: "Departman Ara",
            searchMobileAgent: "Mobil Temsilci Ara",
            searchAgentOrDepartment: "Temsilci veya departman arayın",
            searchPreferredAgent: "Tercih edilen Temsilciyi arayın",
            noAgentsAvailableToForward: "İletmek için uygun temsilci yok",
            noDepartmentsAvailableToForward: "İletmek için uygun Departman yok",
            noMobileAgentsAvailableToForward: "İletmek için Uygun Mobil Temsilci yok",
            noPreferredAgentsAvailableToForward: "İletmek için tercih edilen Temsilci yok",
            ifYouSendThisConversationToTheQueue:
                "Bu görüşmeyi kuyruğa gönderirseniz, sizi sohbetten çıkaracak ve görüşmeyi kuyruğa yerleştirecektir. Otomatik sohbet ataması etkinleştirilmişse, görüşme uygun bir temsilciye atanacak ve size geri aktarılabilir.",
            ifAutomaticChatAssignmentIsDisabled:
                "Otomatik sohbet ataması devre dışı bırakılmışsa, görüşme kuyrukta kalacaktır. Yetkili personel, görüşmeyi kuyruktan alabilir.",
            sendQueue: "Kuyruğa Gönder",
            agentName: "Temsilci Adı",
            departmentName: "Departman Adı",
            toQueue: "Kuyruğa",
            selectTimezone: "Saat dilimini seçin",
            userFilter: "Kullanıcı Filtre",
            confidenceScore: "Güven Puanı",
            chatbotLanguage: "Chatbot Dili",
            botScenerio: "Bot Seneryosu",
            selectTemplate: "Template Seçiniz",
            importFromReadyTemplates: "Hazır Şablonlardan İçe Aktar",
            classification: "Sınıflandırma",
            addClassification: "Sınıflandırma Ekle",
            expressionClassified: "Sınıflandırılacak Ifade",
            zohoModuleName: "Zoho Modül Adı",
            selectModule: "Modül Seç",
            standardFields: "Standart Alanlar",
            selectStandardField: "Standart Alan Seç",
            customFields: "Özel Alanlar",
            selectCustomFields: "Özel Alan Seç",
            aiFunction: "Yapay Zeka Fonksiyonu",
            aiFunctionDesc: "Kullanıcı girdilerine dayalı eylemler gerçekleştirmek için yapay zeka işlevini yönetin.",
            functionName: "Fonksiyon Adı",
            functionDesc: "Fonksiyon Açıklaması",
            addParameter: "Parametre Ekle",
            chooseAiStory: "Bir yapay zeka hikayesi seçin",
            chatbotAiPromptDesc:
                " Yapay zeka, 'prompt' özelliğini kullanarak belirli bir görev veya sorun hakkında talimatlar verilerek öğrenir ve nasıl davranması gerektiğini belirler.",
            enterPrompt: "Prompt girin.",
            aiParameterTunings: "AI Parametre Ayarları",

            aiParameterTuningsDesc:
                "Yapay zekayı daha duyarlı ve doğru hale getirmek için yapay zeka parametrelerini ayarlayabilirsiniz. Bu parametreler YZ'nin davranışını ve kullanıcı girdilerine nasıl yanıt verdiğini kontrol etmek için kullanılır.",
            temperature: "Sıcaklık",
            temperatureDesc:
                "Hangi örnekleme sıcaklığının kullanılacağı, 0 ile 2 arasında. 0,8 gibi daha yüksek değerler çıktıyı daha rastgele hale getirirken, 0,2 gibi daha düşük değerler daha odaklı ve deterministik hale getirecektir.",
            topDesc:
                "Çekirdek örnekleme olarak adlandırılan sıcaklıkla örneklemeye alternatif olarak model, en üst_p olasılık kütlesine sahip belirteçlerin sonuçlarını dikkate alır. Yani 0.1, yalnızca en üst %10 olasılık kütlesini içeren belirteçlerin dikkate alındığı anlamına gelir. Genellikle bunu veya sıcaklığı değiştirmenizi öneririz, ancak ikisini birden değil.",
            toolChoices: "Araç Seçenekleri",
            noneDesc:
                "Yok, modelin herhangi bir aracı çağırmayacağı ve bunun yerine bir mesaj oluşturacağı anlamına gelir",
            autoDesc:
                "Otomatik mod varsayılan değerdir ve modelin bir mesaj oluşturma veya bir ya da daha fazla aracı çağırma arasında seçim yapabileceği anlamına gelir.",
            requiredDesc:
                "Gerekli mod, modelin kullanıcıya yanıt vermeden önce bir veya daha fazla aracı çağırması gerektiğidir",
            createArticles: "Makale Oluştur",

            createArticlesDesc: "Kullanıcılarınızın sorularına yanıt bulmalarına yardımcı olacak makaleler oluşturun.",
            articlesTitle: "Makale Başlığı",
            articlesContent: "Makale İçeriği",
            createFaq: "Sıkça Sorulan Sorular (SSS) oluşturun",
            createFaqDesc:
                "Sohbet botunuz için yeni bir SSS oluşturun. Bu, sohbet robotunuzun kullanıcının sorularını yanıtlamasına yardımcı olacaktır.",
            question: "Soru",
            saveAndClose: "Kaydet ve Kapat",
            contentPreview: "İçerik önizleme",

            updateChannelDesc6: "Whatsapp business api kanalını güncelleyin",
            newWabaChannel: "Yeni Whatsapp Business Kanalı",
            newWabaChannelDesc: "Whatsapp business api için yeni bir kanal oluşturun",
            upgradePackageTitle: "Paketinizi Yükseltip Limitlerden Kurtulun",
            upgradePackageDescription:
                "Daha fazla özellik, daha fazla entegrasyon, daha fazla temsilci! Ekibinizi daha iyi yönetmek ve işletmenizi maksimum potansiyeline ulaştırmak için şimdi harekete geçin!",
            upgradePackage: "Yükselt",
            deleteFiles: "Dosyaları Sil",
            sureDeleteMultipleFiles: "Seçili dosyaları silmek istediğinize emin misiniz?",
            selectAll: "Hepsini Seç",
            cancelSelection: "Seçimi iptal et",
            deleteSelected: "Seçili dosyaları sil",
            newFolder: "Yeni Klasör",
            newFile: "Yeni Dosya",
            noFilesFound: "Bu klasörde dosya bulunamamıştır",
            uploadFile: "Dosya Yükle",
            enterFolderName: "Lütfen Klasör Adını Giriniz",
            folderName: "Klasör Adı",
            dropFileHere: "Dosyaları buraya bırakın",
            createFolder: "Klasör Oluştur",
            fileUploadingError: "Dosya yüklenirken bir hata oluştu",
            fileUploadingSucs: "Klasör başarıyla oluşturuldu",
            folderNameNotEmpty: "Klasör adı boş olamaz",
            deleteFolder: "Klasörü Sil",
            sureDeleteFolder: "Bu klasörü ve içindeki tüm dosyaları silmek istediğinize emin misiniz?",
            deletionSucs: "Silme işlemi başarılı",
            deleteFile: "Dosyayı Sil",
            sureDeleteFile: "Bu dosyayı silmek istediğinize emin misiniz?",
            deletionError: "Silme işlemi sırasında bir hata oluştu",
            selectFile: "Dosya Seç",
            moreThanOneSelect: "Birden fazla dosya seçebilirsiniz",
            selectAnFile: "Bir dosya seçin",
            bulkSms: "Toplu SMS",
            sendBulkSmsCustomers: "Müşterilerinize toplu SMS gönderin",
            writeYourMessage: "Mesajınızı Buraya Yazın.",
            sendSms: "SMS Gönder",
            sendSmsYourCustomers: "Müşterilerinize sms gönderin",
            manageChannelDetail: "Kanal bilgilerini yönetin",
            details: "Detaylar",
            teamGramChannels: "TeamGram Kanalları",
            newTeamGramIntegration: "Yeni TeamGram Entegasyonu",
            teamGramIntegration: "TeamGram Entegrasyonu",
            notMoreThanOneTeamGramChannels: "Birden fazla TeamGram Kanalı oluşturamazsınız",
            teamGramDetail: "TeamGram Detayı",
            manageYourTeamGramIntegration: "TeamGram Entegrasyonunuzu Yönetin",
            trendyolChannels: "Trendyol Kanalları",
            trendyolStoreIntegration: "Trendyol Mağaza Entegrasyonu",
            trenyolStoreConnection: "Trendyol mağazınızı bağlayın.",
            deleteTrendyolIntegration: "Trendyol Entegrasyonu sil",
            sureDeleteTrendyolIntegration:
                "Trendyol entegrasyonunu silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
            trendyolStoreChannel: "Trendyol Mağaza Kanalı",
            deleteTrendyolChannel: "Trendyol Kanalını sil",
            channelUpdatedSucs: "Kanal Başarıyla Güncellendi.",
            failedUpdateChannel: "Kanal Güncellenemedi.",
            trendyolStoreIntegrationDetail: "Trendyol Mağaza Entegrasyon Detayı",
            configureTrendyolStoreIntegrationDetail: "Trendyol Mağaza Entegrasyonuzu Yapılandırın",
            trenyolStoreProductQuestManage: "Trendyol Mağaza - Ürün Soruları Yönetimi",
            trendyolStoreDesc:
                "Trendyol mağaza ürünlerine gelen soruları yönetmek için aşağıdaki ayarları kullanabilirsiniz.",
            zohoCrmChannels: "Zoho CRM Kanalları",
            zohoPersonalChannel: "Zoho Kişisel Kanallar",
            connectZoho: "Zoho CRM'e bağlan",
            updateChannelDesc5: "Zoho CRM Kanalını Güncelleme",
            zohoCrmIntegration: "Zoho CRM Entegrasyonu",
            sureDeleteZohoChannel: "Zoho CRM kanalını silmek istediğinizden emin misiniz?",
            createNotMoreThanOneZohoChannels: "Birden fazla Zoho Kanalı oluşturamazsınız",
            removeZohoLink: "Zoho Bağlantısını Kaldır",
            connectToZoho: "Zohoya Bağlan",
            chatClosed: "Chat kapandı",
            scoreChat: "Chat puanlandı",
            createdTicket: "Ticket oluşturuldu",
            updatedTicket: "Ticket güncellendi",
            newUserCreated: "Yen kullanıcı oluşturuldu",
            updateUser: "Kullancı güncellendi",
            deleteUsers: "Kullancı silindi",
            changeStatusRepresent: "Temsilci durumu değişti",
            incomingMessage: "Gelen Mesaj",
            outgoingMessage: "Giden Mesaj",
            createdNewTicket: "Yeni Ticket Oluştu",
            bitrix24Channels: "Bitrix24 Kanalları",
            sureDeleteBitrixChannel: "Bitrix24 kanalını silmek istediğinizden emin misiniz?",
            bitrix24Integrations: "Bitrix24 Entegrasyonu",
            notCreateMoreThenOneChannel: "Birden fazla Ideasoft kanalı oluşturamazsınız",
            connectToBitrix24: "Bitrix24'e Bağlanın",
            connectToBitrix24Api: "Bitrix24 Api'e Bağlanın",
            updateChannel: "Kanalı Güncelle",
            updateChannelDesc: "Bitrix24 Api kanalını güncelle",
            yourBitrix24Domain: "Bitrix24 Alan Adınız",
            bitrix24ConnectedSucs: "Bitrix24 başarıyla bağlandı",
            failedToConnectBitrix24: "Bitrix24'e bağlanılamadı",
            channelCreatedSuccessfully: "Kanal başarıyla oluşturuldu",
            failedToCreateChannel: "Kanal oluşturulamadı",
            holidayPlusChannels: "Holiday+ Kanalları",
            newHolidayPlusIntegration: "Yeni Holiday+ Entegrasyonu",
            holidayPlusIntegrations: "Holiday+ Entegrasyonu",
            notCreateMoreThanOneHolidayChannel: "Birden fazla Holiday+ Kanalı oluşturamazsınız",
            holidayPlusDetail: "Holiday+ Detay",
            manageHolidayPlusIntegration: "Holiday+ Entegrasyonunuzu Yönetin",
            ideasoftChannels: "Ideasoft Kanalları",
            connectToIdeasoft: "Ideasoft'a Bağlanın",
            connectToIdeasoftApi: "Ideasoft api'ye bağlanın",
            updateChannelDesc2: "Whatsapp business api kanalını güncelleyin",
            ideasoftIntegration: "Ideasoft Entegrasyonu",
            sureDeleteIdeasoftChannel: "Ideasoft kanalını silmek istediğinizden emin misiniz?",
            moreThanOneChannelError: "Birden fazla Ideasoft Kanalı oluşturamazsınız",
            websiteAddress: "Website Adresi",
            ideasoftConnectedSucs: "Ideasoft başarıyla bağlandı",
            failedToConnectIdeasoft: "Ideasoft'a bağlanılamadı",
            redirectURLcopiedToClipboard: "Panoya kopyalanan URL'yi yeniden yönlendirme",
            openAIChannels: "OpenAI Kanalları",
            newOpenAiChannel: "Yeni OpenAI kanalı",
            createNewChannelOpenAi: "OpenAI için yeni bir kanal oluşturun",
            updateChannelDesc3: "Whatsapp business api kanalını güncelleyin",
            openAiIntegration: "OpenAI Entegrasyonu",
            sureDeleteOpenAiChannel: "OpenAI kanalını silmek istediğinizden emin misiniz?",
            createMoreThenOneOpenAiChannel: "Birden fazla OpenAI Kanalı oluşturamazsınız",
            postaCellChannels: "PostaCell Kanalları",
            newPostaCellChannel: "Yeni PostaCell Kanallar",
            createNewPostaCellChannel: "PostaCell sms sağlayıcısı için yeni bir kanal oluşturun",
            updateChannelDesc4: "Whatsapp business api kanalını güncelleyin",
            accessControl: "Erişim Kontrolü",
            leads: "Leadler",
            ensureFacebookAccount: "Facebook hesabı ve sayfası olduğundan emin olun",
            ensureAdAccount: "Reklam hesabına sahip olduğundan emin olun",
            page: "Sayfa",
            questions: "Sorular",
            leadCount: "Lead Sayısı",
            showLeads: "Lead'leri Göster",
            syncLeeds: "Leedleri senkronize et",
            wpStartChat: "Whatsapp Chat Başlatıcı",
            archivedIn: "Arşivlenmiş mi?",
            makeSelect: "Seçim Yap",
            newLead: "Yeni Leed",
            initalContact: "İlk İletişim",
            needsAssessnment: "İhtiyaç Analizi",
            proposalSent: "Teklif Gönderildi",
            proposalReview: "Teklif İncelemesi",
            negotiation: "Pazarlık",
            decisionStage: "Karar Aşaması",
            closure: "Kanapnış",
            followUp: "Takip",
            campagin: "Kampanya",
            adSet: "Reklam Seti",
            ad: "Reklam",
            inArchived: "Arşivlendi",
            deletedSelectedPerson: "Seçili Kişileri sil",
            sureDelSelectedPerson: "Seçili Kişileri silmek istediğinizden emin misiniz?",
            deletePerson: "Kişiyi Sil",
            sureDeletePerson: "Kişiyi silmek istediğinizden emin misiniz?",
            phoneNumberNotAvailable: "Telefon numarası mevcut değil",
            statusSucsUpdated: "Durum başarıyla güncellendi",
            statusUpdatedFailed: "Durum güncellenirken bir hata oluştu",
            archivedContact: "Kişiyi arşivle",
            sureWantArchivePerson: "Bu kişiyi arşivlemek istediğinizden emin misiniz?",
            personArchived: "Kişi Arşivlendi",
            personArchivedHead: "Arşivleme işlemi başarısız oldu",
            metaLeadChannels: "Meta Lead Kanalları",
            wpStartSpeech: "Whatsapp Konuşma Başlatıcı",
            pleaseSelectStartChat: "Lütfen sohbeti başlatmak istediğiniz kanalı seçin:",
            phoneNumber: "Telefon Numarası",
            phoneNumberDesc: "Ülke kodu ile birlikte boşluk girmeden sadece rakamlar ile",
            channelDesc: "Hangi kanal üzerinden chat başlatmak istiyorsunuz",
            pleaseSelectStartChatOn: "Lütfen sohbeti başlatmak istediğiniz kanalı seçin",
            notAuthorizedChannel: "Bu kanala erişim yetkiniz yok.",
            phoneNumberError: "Telefon Numarası Hatalı",
            chatStartError: "Sohbet başlatılırken bir hata oluştu. Lütfen tekrar deneyin.",
            noRecordFailed: "Kayıt bulunamadı",
            metaLeadsChannel: "Meta Leads Kanalı",
            mlChannelDetails: "Meta Leads Kanal Detayları",
            manageMlChannel: "Meta Leed'lerinizi Yönetin",
            deleteMetaLeadsChannelInfo: "Meta Leads kanalını silmek istediğinizden emin misiniz?",
            contactPage: "İletişim Sayfası",
            addRouted: "Yönlendirilmiş Ekle",
            otherEmailProviders: "Diğer E-posta Sağlayıcıları",
            visitorScreenNaming: "Visitor Ekranı İsimlendirme",
            enterCatalogTitle: "Katolog Başlığı giriniz...",
            passwordUpdate: "Şifre Güncelle",
            showCenterScreen: "Ekranın Ortasında Göster",
            skipNow: "Hemen Atla",
            confirm: "Onaylayın",
            newTable: "Yeni Tablo",
            actions: "İşlemler",
            integrationsTrendyol:
                "Trendyol mağazanızı bağlayın ve müşterilerinizin sorularını otomatik olarak yanıtlayın.",
            integrationsHoliday: "Chatbot üzerinden otel ve oda sağlamak için Holiday+ entegrasyonunu yapın!",
            integrationsTeamgram:
                "Müşteri yönetiminizi kolaylaştırmak için müşterilerinizi Supsis'ten Teamgram'a aktarın!",
            integrationsTicimax: "Segmentlere ayrılmış Ticimax üyelerine otomatik mesaj gönderin.",
            integrationsBitrix24:
                "Müşterilerinize gelişmiş bir chatbot deneyimi sunmak için Bitrix24 API'yi aktifleştirin.",
            integrationsIdeasoft:
                "Müşterilerinize gelişmiş bir chatbot deneyimi sunmak için Ideasoft API'yi aktifleştirin.",
            integrationsOpenAI:
                "OpenAI Hizmetlerini Aktifleştir, Chatbot AI Yanıtı, AI Asistanı CoPilot, Chatbot AI Bilgi Tabanı.",
            integrationsSMSPostacell: "PostaCELL SMS Sağlayıcısı ile SMS gönderme özelliğini etkinleştirin.",
            integrationsMetaLeads:
                "Meta Müşterilerinizi Supsis ile etkili bir şekilde yönetin. Müşterilerinizi Ticket, Chatbot veya Canlı Destek ile entegre edin.",
            integrationsZoho: "Zoho CRM'deki iş süreçlerinizi Supsis ile entegre edin.",
            forward: "İleri",
            trendyol: "Trendyol",
            packUpRequired: "Paket Yükseltimi Gerekli",
            upgradePack: "Paket Yükselt",
            supsisMobilApp: "SUPSIS MOBİL APP",
            supsisMobilAppDesc: "IOS ve Android Uygulaması Marketlerde!",
            sendEmail: "Email Gönder",
            jumpToMessage: "Mesaja gitmek için tıklayınız",
            doesntMatter: "Farketmez",
            designer: "Tasarım",
            targetContacts: "Hedef Kişiler",
            scheduler: "Zamanlayıcı",
            planAndTask: "Plan & Görev",
            insights: "Öngörüler",
            createRole: "Rol Oluştur",
            createSubject: "Konu Oluştur",
            createUser: "Kullanıcı Oluştur",
            blockManuel: "Manuel Blok",
            showHide: "Göster/Gizle",
            contactSearch: "İletişim Ara",
            favorites: "Favoriler",
            downloadAllData: "Tüm Verileri İndir",
            downloadThePage: "Sayfayı İndir",
            choosePoints: "Puan Seç",
            channel: "Kanal",
            createdAt: "Oluşturulan",
            action: "Aksiyon",
            searchChannel: "Kanal Ara",
            activeChannels: "Aktif Kanallar",
            deleteChannels: "Silinen Kanallar",
            selectChannel: "Kanal Seç",
            channelFilter: "Kanal Filtresi",
            noConversationDesc: "Burada aktif sohbetleri ve size atanmış sohbetleri görebilirsiniz.",
            forMe: "Bana Özel",
            unAssigned: "Atanmamış",
            agentDetails: "Temsilci Detayları",
            contactProperties: "Kullanıcı Değerleri",
            goToProfile: "Profile Git",
            addNote: "Not Ekle",
            noPreferredAgent: "Henüz Tercih Edilen Bir Temsilci Yok",
            toPrefer: "Tercih Et",
            inChat: "Sohbette",
            watching: "İzliyor",
            chatsTitle: "Sohbetler",
            dealyTimeMaxValueError: "Gecikme süresi en fazla 15 olabilir",
            dealyTimeTypeError: "Gecikme süresi sayı olmalı",
            passedTimeHm: "{hour} Saat {min} Dakika",
            passedTimeMs: "{min} Dakika {sec} saniye",
            passedTimeSc: "{Sec} Saniye",
            translateMessage: "Mesajınız yapay zeka tarafından çevrilmiştir.",
            toneChanged: "Mesaj tonu {tone} olarak değiştirildi",
            aiResponseAdded: "Yapay Zeka Yanıtı Mesaja Eklendi",
            messageLonger: "Mesaj Daha Uzun Hale Getirildi",
            grammarFixed: "Yazım Düzeltildi",
            aiTranslate: "Çeviri",
            other: "Diğer",
            yourLanguage: "Sizin diliniz",
            contactLanguage: "Müşteri Dili",
            myLanguage: "Benim dilim",
            forwardToChatbot: "Chatbota İlet",
            friendly: "Dostça",
            confident: "Kararlı",
            straightForward: "Basit",
            casual: "Gündelik",
            professional: "Profesyonel",
            longSentence: "Uzun Cümle",
            changeTone: "Tonu Değiştir",
            fixGrammar: "Yazım Düzelt",
            aiResponse: "Yapay Zeka Yanıtı",
            templateButtonNote:
                "Kişiyi yasaklamak için, büyük veya küçük harf fark etmeksizin yasaklama düğmesinde aşağıdaki metinleri kullanmaya dikkat edin. ",
            templateButtonTags: "#Mesaj Gönderme# | #Abonelikten Çıkar# | #Yasakla# | #Engelle#",
            dashboard: "Kontrol Paneli",
            adminReports: "Admin Raporları",
            calendarModule: "Takvim Modülü",
            taskModule: "Görev Yönetim Modülü",
            maxUrlButtonMessage: "En fazla 2 adet url buton ekleyebilirsiniz.",
            noPreferredDepartment: "Tercih Edilen Departman Yok",
            searchForDepartment: "Departman Ara",
            departmentAssignedToTheVisitor: "Ziyaretçiye atamak istediğiniz departmanı seçin.",
            assignPreferredDepartment: "Tercih Edilen Departmana Ata",
            smsChannel: "Sms Kanalı: ",
            whatsappv2Channel: "Whatsapp V2 Kanalı: ",
            whatsappv1Channel: "Whatsapp V1 Kanalı: ",
            wBChannel: "Whatsapp Business Kanalı: ",
            messengerChannel: "Messenger Kanalı: ",
            instagramChannel: "İnstagram Kanalı: ",
            allPlatforms: "Tüm Platformlar",
            cbStartMessageDesc:
                "Kullanıcının girdiği ilk mesaj, chatbot tarafından otomatik olarak işlenerek ilgili adrese yönlendirilsin.",
            cbStartMessage: "Chatbot Başlangıç Mesajı",
            messengerUserProfile: "Messenger Kişi Profili",
            instagramUserProfile: "Instagram Kişi Profili",
            noEventFound: "Etkinlik Bulunamadı",
            visitorMails: "Ziyaretçi E-postaları",
            visitorActions: "Ziyaretçi Hareketleri",
            notVerified: "Doğrulanmadı",
            visitorEvents: "Etkinlikler",
            assignedTasks: "Atanan Görevler",
            mails: "Mailler",
            prefferedAgents: "Tercih Edilen Temsilciler",
            createEvent: "Etkinlik Oluştur",
            blockManagement: "Engelleme Yönetimi",
            deleteUser: "Kullanıcıyı Sil",
            blocked: "Engellendi",
            profiles: "Profiller",
            similiarProfiles: "Benzer Profiller Bulundu",
            ReplyAsAPm: "Özel Mesaj Olarak Yanıtla ve Kapat",
            replyAsAComment: "Yorum Olarak Yanıtla ve Kapat",
            messengerAddDesc: "Aşağıdaki Bağlan düğmesine tıklayın ve Facebook hesabınıza giriş yapın.",
            instaAddPrivacyCheckDesc: "{Privacy} ve {Terms and Conditions} Okudum Ve Kabul Ediyorum.",
            instaAddDesc5: "Aşağıdaki Bağlan düğmesine tıklayın ve Facebook hesabınıza giriş yapın.",
            instaAddDesc4: "Facebook Geliştirici olarak kaydolun",
            instaAddDesc3: "<b>'Mesajlara erişime izin ver'</b> anahtarının açık olduğundan emin olun",
            instaAddDesc2: "Instagram profesyonel hesabınızın Facebook sayfanıza bağlı olduğundan emin olun",
            instaAddDesc1: "Instagram hesabınızın bir Instagram profesyonel (Business) hesabı olduğundan emin olun.",
            selectedDepartment: "Seçilen Departman",
            departmentForwardEnable: "Departman Yönlendirme Kuralı Etkin",
            departmentForwardRule: "Departman Yönlendirme Kuralı",
            departmentForwardDesc: "Kanala gelen sohbetlerin hangi departmana yönlendirileceğini seçin.",
            channelName: "Kanal Adı",
            forwardToLiveAgents: "👉 Canlı Temsilcilere Yönlendir",
            manageIgChannel: "Instagram Kanalınızı Yönetin",
            igDetail: "Instagram Detay",
            manageVisibilityDesc: "Bu kanalı kimlerin görebileceğini yönet",
            selectAnIgAccount: "Bağlamak istediğin Instagram hesabını seç.",
            connectToInsta: "Instagram'a Bağlan",
            connectToMetaLeads: "Meta Leads Hesabına Bağlan",
            deleteInstaChannelInfo: "Instagram kanalını silmek istediğinizden emin misiniz?",
            instagramChannels: "Instagram Kanalları",
            checkboxWarning: "Bu alanın seçilmesi zorunludur",
            onlyChatbot: "Sadece Chatbot",
            onlyAgents: "Sadece Temsilciler",
            sendingAllow: "Gönderim",
            receiving: "Alım",
            platform: "Platform",
            banModalTitle: "Ziyaretçi Yasaklama Ekranı",
            selectDepartmentDesc: "Görünürlüğü değiştirmek istediğiniz departmanları seçin",
            selectAgentDesc: "Görünürlüğü değiştirmek istediğiniz temsilcileri seçin",
            selectDepartment: "Departman Seç",
            selectAgent: "Temsilci Seç",
            visibleDepartments: "Gören Departmanlar",
            visibleAgents: "Gören Temsilciler",
            visibilityInfoCont: "Tüm temsilciler ve departmanlar bu kanalı görebilir",
            editDepartmentVisibility: "Departman İzinlerini Düzenle",
            editAgentVisibility: "Temsilci İzinlerini Düzenle",
            typeSTToSearch: "Kullanıcı aramak için birşeyler yazınız",
            exportToCSV: "CSV'ye Aktar",
            clear: "Temizle",
            usedSessionCount: "Kullanılan Oturum Sayısı",
            maxSessionCount: "Maksimum Oturum Sayısı",
            leftSessionCount: "Kalan Oturum Sayısı",
            planManagement: "Plan Yönetimi",
            maxAutomationTask: "Maksimun Otomasyon Görevi",
            teamChat: "Takım Konuşması",
            templateNameIsNotValid: "Şablon Adı Geçerli Değil",
            relatedAdvertisement: "İlgili Reklam",
            whatsappNumber: "Whatsapp Numarası",
            createTask: "Görev Oluştur",
            integrationsWhatsappV1:
                "Supsis ve WhatsApp arasında sorunsuz bir iletişim kurmak için WhatsApp Planı gerekmektedir.",
            integrationsWhatsappV2: "Supsis ve WhatsApp arasında sohbet bilgilerini kolayca iletebilirsiniz.",
            integrationsWhatsappBusiness:
                "Sohbet bilgilerini hızlı ve pratik bir şekilde Supsis ve WhatsApp arasında iletebilirsiniz.",
            selectDays: "Gün Seçin",
            addTime: "Saat Ekle",
            instagramContactList: "Instagram Kişi Listesi",
            archiveAllRated: "Herhangi bir puanlama yapılan tüm konuşmaları getir.",
            allChannels: "Tüm kanallar",
            comment: "Yorum",
            news: "Yenilikler",
            conversation: "Takım konuşması",
            speechTermination: "Konuşmayı sonlandır",
            noSystemMessage: "Henüz Sistemde Mesaj Yok !",
            supsisCustomerService: "Supsis'in sunduğu müşteri hizmetleri,",
            supsisClickExperience: "deneyimini tıklayarak deneyebilirsiniz.",
            customerPage: "Müşteri Sayfasına Git",
            buttonTitle: "Buton Başlığı",
            buttonType: "Buton Tipi",
            buttonSendMessage: "Mesaj gönder",
            buttonGoToBlock: "Bloğa git",
            buttonOpenUrl: "Aç URL",
            buttonPhoneCall: "Telefon görüşmesi",
            buttonOpenMoment: "Açık Anı",
            buttonCloseChat: "Sohbeti Kapat",
            buttonTransferChat: "Sohbeti Aktar",
            buttonCreateTicket: "Bilet Oluştur",
            you: "Sen",
            and: "ve",
            deleteVisitor: "Kullanıcıyı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
            deleteThread: "Tüm mailleri silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
            deleteMail: "Maili silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
            dndBlocked: "Dosya gönderim ayarları kapalı.",
            tokenCopied: "Erişim token'ı kopyalandı.",
            apiIntegration: "Geliştirici",
            generateToken: "Token Üret",
            copyToken: "Token Kopyala",
            labels: "Etiketler",
            noData: "İçerik Yok",
            color: "Renk",
            titleColor: "Başlık Rengi",
            secondTitleColor: "İkinci Başlık Rengi",
            tag_name_indicator: "Etiket Adı",
            sendMessage: "Mesaj Gönder",
            removeFromG: "Gruptan Çıkar",
            delChannel: "Bu kanalı silmek istediğinizden emin misiniz?",
            new_name: "Yeni İsim",
            set_group_info: "Grup bilgilerini düzenle",
            shortcut_desc_num: "Numeric rakamlarla aktif konuşmalar arası geçiş yapma",
            copilot_desc_num: "Chat Ekranında Copilot u açmayı sağlar",
            typing_w_chat: "yazıyor...",
            edit_group_info: "Grup Bilgilerini Düzenle",
            notif_sound: "Bildirimlerin Sesini Aç",
            notif_mute: "Bildirimleri Sessize Al",
            leave: "Ayrıl",
            group: "Grup",
            updateTag: "Etiket Güncelle",
            os_browser: "İşletim Sistemi ve Tarayıcı",
            ordered_desc: "Sohbetleri sırayla temsilcilere atar.",
            random_desc: "Sohbetleri temsilcilere rastgele atar.",
            Rrobin_desc: "Temsilcilere sohbetleri round robin tarzında atar. (En az meşgul olan temsilciler öncelikli)",
            RrobinRev_desc:
                "Temsilcilere sohbetleri round robin tarzında atar. (En fazla meşgul olan temsilciler öncelikli)",
            algo_desc: "Otomatik sohbet atama için algoritmayı seçin",
            algorithm: "Algoritma",
            addTag: "Etiket Ekle",
            tags: "Etiketler",
            searchRepresentative: "Temsilci Arayın.",
            preferredRepresentative: "Temsilciler",
            voting: "Oylanıyor",
            chatWidget: "Supsis Sohbet Balonu",
            webhooks: "Web Kancaları",
            selectHooks: "Seçenekeler",
            planRequired: "{integratable} Plan Gerekmektedir.",
            allIntegrations: "Tüm Entegrasyonlar",
            disableAgentSystemMessages: "Temsilci sistem mesajlarını gizle",
            disableAgentSystemMessagesDesc: "Temsilci Sistem Mesajlarını Gizle.",
            disableAutoTranslate: "Otomatik Tercüme",
            disableAutoTranslateDesc:
                "Farklı dillerden gelen mesajları otomatik olarak çevirir. Böylece müşterilerinizle daha kolay iletişim kurabilirsiniz.",
            shouldAddMethod:
                "Ödeme Metodu & Fatura Adresi alanını doldurmalısınız!\nHesabınızdan para cekilmeyecektir.\n" +
                "Ay sonunda kullanım tutarınıza göre fatura oluşacaktır",
            approveSelection: "Seçiminizi Onaylayın",
            trialDaysEndSelectPlan: "Plan Seçinimini Onaylayın",
            trialDaysEndSelectPlanDesc: "Deneme sürümünüz bitmiştir. Aşağıdan plan seçerek onaylamanız gerekmektedir.",
            infinitePlay: "Sürekli çal",
            hideBubbleOnMobile: "Mobilde gizle",
            deleteSystemLanguage: "Sistemden {code} dilini siler",
            assignedChat: "Atanan Chat",
            check: "Onay kutusu",
            systemStatus: "Sistem Durumu",
            chatAssignedToUser: "Yeni chat atandı",
            inactiveThresholdTime: "Pasif Chat Süresi (dakika)",
            tippyInactiveThresholdTime:
                "Konuşmada verilen süre içinde herhangi bir mesaj gönderilmediğinde konuşma pasif olarak kabul edilir.Değeri (dakika) olarak giriniz. En az 1dk En çok 120dk olmalıdır.",
            inactiveTerminateTime: "Pasif Chat Kapatma Süresi (dakika)",
            tippyInactiveTerminateTime:
                "Konuşma pasif olduktan verilen süre  sonra kapatılacaktır. Değeri (dakika) olarak giriniz. En az 0 en çok 120dk olmalıdır.",
            removePendingMessage: "Mesaj gönderimi iptal et",
            disconnected: "Bağlı Değil",
            visitorWriteEmptyChatTippy: "Müşteri, konuşamaya temsilci bağlanmadan önce yazabilir.",
            visitorWriteEmptyChat: "Müşteri, temsilci bağlanmadan yazabilir.",
            visitorConnectionEventSystemMessageEnabled:
                "Ziyaretçinin bağlantı durumu sistem mesajlarını etkinleştirir.",
            visitorConnectionEventSystemMessageEnabledTippy:
                "Ziyaretci ayrıldı ve ziyaretci geri geldi sistem mesajlarını gösterir.",
            openBubble: "Konuşma Balonu Aç",
            showHeaderImage: "Şirket Logosu ve İsim Göster",
            changeLogo: "Logoyu Değiştir",
            changePhoto: "Resmi Değiştir",
            addPhoto: "Resim ekle",
            seePhoto: "Resmi Gör",
            deletePhoto: "Resmi Sil",
            askQuestion: "Soru sor",
            locationPermsNeeded: "Bu özelliği kullanabilmeniz için konum izinleri gerekli",
            useMyLocation: "Konumumu kullan",
            acceptingChat: "Chat alımı açık",
            notAcceptingChat: "Chat alımı kapalı",
            websiteChatWidgetIntegration: "Website Chat Balonu Entegrasyonu",
            loggedOut: "Çevrimdışı",
            listStatuses: "Durumlar",
            hideInactiveAgents: "Pasif Temsilcileri Gizle",
            hideMinorValues: "Küçük Değerleri Gizle",
            agentActivities: "Temsilci Aktivitileri",
            newHASHContent: "#Etiket Ekle",
            hash: "Etiket",
            languageRemovalQuestion: "Sistemden {code} dilini silmek üzeresiniz!",
            blockBy: "Temsilci",
            hashText: "Etiket",
            exampleHash: "siparis-takip",
            cardInfos: "Kart Bilgileri",
            saveSystemCardInfo: "Kartınız sistemimize kaydedilip ödenecek tarih geldiğinde otomatik ödenir.",
            cardNumber: "Kart Numarası",
            cardType: "Kredi Kartı Türü",
            skt: "SKT",
            cvv: "CVV",
            saveCard: "Kartı Kaydet",
            cardNameSurname: "Kart Sahibinin Adı Soyadı",
            confidentialityAgreementCheck: "Gizlilik Sözleşmesini Kabul Ediyorum",
            confidentialityAgreement: "Gizlilik Sözleşmesi",
            notValidHash: "Boşluk karakteri içermemelidir",
            videoCallEnabledDesc: "Görüntülü arama özelliğini etkinleştirmek için aktif edin",
            videoCallEnabled: "Görüntülü Arama Özelliği",
            audioCallDesc: "Sesli arama özelliğini etkinleştirmek için aktif edin",
            audioCallEnabled: "Sesli Arama Özelliği",
            assignPreferredAgent: "Tercih Edilen Temsilciyi Ata",
            representativeAssignedToTheVisitor: "Ziyaretçiye atamak istediğiniz tercih edilen temsilciyi seçin.",
            agentFileSendEnabledDesc: "Temsilcilerin dosya gönderme özelliğini etkinleştirir",
            agentFileSendEnabled: "Temsilciler Dosya Gönderebilir",
            visitorFileSendEnabledDesc: "Ziyaretciler dosya gönderme özelliğini açıp kapatmanıza izin verir",
            visitorFileSendEnabled: "Ziyaretciler Dosya Gönderebilir",
            visitorAutoLogin: "Ziyaretçi Otomatik Giriş",
            visitorAutoLoginDesc: "Ziyaretçi balonu tıklar tıklamaz konuşma başlar",
            agentVoiceRecordEnabledDesc: "Temsilcilerin ses kaydetme özelliğini etkinleştirir",
            agentVoiceRecordEnabled: "Temsilciler Ses Kaydedebilir",
            visitorVoiceRecordEnabledDesc: "Ziyaretcilerin ses kaydetme özelliğini etkinleştirir",
            visitorVoiceRecordEnabled: "Ziyaretciler Ses Kaydedebilir",
            startVideoCall: "Görüntülü Görüşme",
            startAudioCall: "Sesli Görüşme",
            visitorGDPRDeleteEnabledDesc: "Ziyaretciler tüm bilgilerini silme özelliğini açıp kapatmanıza izin verir",
            visitorGDPRDeleteEnabled: "Ziyaretciler tüm bilgilerini silebilir",
            visitorLocationEnabled: "Ziyaretciler konum paylaşabilir",
            visitorLocationEnabledDesc: "Ziyaretçilerin konum paylaşımını açmasına veya kapatmasına izin verir",
            customerLocationEnabled: "Temsilciler konum paylaşabilir",
            customerAutoMergeEnabled: "Aynı kişileri otomatik birleştirir",
            customerAutoMergeEnabledDesc:
                "Bu özellik, otomatik birleştirme işlemini gerçekleştirerek aynı kişilere ait verileri etkili bir şekilde bir araya getirir. Bu sayede benzer profillere sahip kullanıcılar, veri setlerinde daha tutarlı ve düzenli bir şekilde temsil edilir.",
            chatAiCopilot: "Chat AI Copilot",
            chatAiCopilotDesc: "Chat AI Copilot Kullanarak Müşterilerinizin Sorularını Otomatik Olarak Cevaplayın",
            customerLocationEnabledDesc: "Temsilcilerin konum paylaşımını açmasına veya kapatmasına izin verir",
            thoesNotOwners: "Owner olmayanları sırada beklet",
            thoesNotOwnersDesc:
                "Görüşmenin sahibi olmayan kişileri kuyrukta tutmak için bu özelliği etkinleştirirsiniz.",
            hideContactInfo: "İletişim bilgilerini gizle",
            hideContactInfoDesc:
                "Bu özelliği etkinleştirdiğinizde, müşterilerinizin numaraları ve e-postaları temsilcilerden gizlenecektir.",
            triggerAlreadyExists: "Bu koşula ait bir tetikleyici zaten var.",
            ticketStatusForm: "Ticket Durum Formu",
            statusFormTitle: "Ticket Durum Başlığı",
            allStatus: "Tüm Durumlar",
            triggers: "Tetikleyiciler",
            trigger: "Tetikleyici",
            noTrigger: "Henüz Tetikleyici Eklemediniz",
            triggerSkipLoginForm: "Giriş Formu",
            triggerSkipLoginFormTrue: "Giriş Formunu Göster",
            triggerSkipLoginFormFalse: "Giriş Formunu Atla Mesajı Başlat",
            noContent: "içerik yok",
            toCreate: " Oluşturmak için",
            clickTheButton: "butonuna tıklayın",
            triggerContent:
                " Açılan pencerede görülmesini istediğiniz açıklamayı yazın. Yalnızca bir dilde yazmanız yeterlidir diğer dillere çeviri otomatik olarak yapılmaktadır.",
            triggerDrag: "Sürükleyerek veya çubuğa tıklayarak mesaj süresini ayarlayabilirsiniz.",
            triggerNewCondition: "Butonu ile yeni bir koşul ekleyebilirsiniz.",
            triggerNoConditionDescription1:
                "Seçenekler arasından istediğiniz koşulları oluşturabilirsiniz. Herhangi bir tetikleyici için hiçbir koşul oluşturmamanız halinde ilk sıradaki tetikleyici aktif olur.",
            triggerNoConditionDescription2:
                "Yine ziyaretçi sayfasında aynı koşullara sahip tetikleyicilerden yalnızca bir tanesi aktif olarak gözükür.",
            triggerShowAndHide: "Tetikleyicilerin göstermek istediğinizde gösterebilir veya gizleyebilirsiniz.",
            countryLanguage: "Ülke/Dil",
            addTrigger: "Tetikleyici Ekle",
            yesPlease: "Evet, lütfen!",
            noThanks: "Hayır, teşekkürler.",
            firstAnswer: "Soru Diyaloğu Olumlu Yanıt",
            secondAnswer: "Soru Diyaloğu Olumsuz Yanıt",
            noTitle: "Başlık Yok",
            sumChat_MediaFile: "Medya ve Belgeler",
            importantWarning: "ÖNEMLİ UYARI",
            images: "Resimler",
            URLS: "Linkler",
            files: "Dosyalar",
            warning: "UYARI!",
            noCondition: "Şart Yok! Artı ikonuna tıklayarak Şart ekleyebilirsiniz.",
            showTriggers: "Tetikleyicileri Göstermek için Tıklayın",
            showThisTrigger: "Bu Tetikleyiciyi Göstermek için Tıklayın",
            hideTriggers: "Tetikleyicileri Gizlemek için Tıklayın",
            hideThisTrigger: "Bu Tetikleyiciyi Gizlemek için Tıklayın",
            updateTrigger: "Tetikleyiciyi Güncelle",
            conditions: "Koşullar",

            messageDurationPerRow: "Her Bir Satır İçin Mesaj Süresi",
            dayTime: "Saat",
            weekDay: "Haftanın günü",
            spendTimePage: "Sayfada Geçirilen Zaman",
            spendTimeSite: "Sitede Geçirilen Zaman",
            pageUrl: "URL",
            pageTitle: "Sayfa Başlığı",
            equal: "Eşit",
            not_equal: "Eşit Değil",
            less_than: "Küçüktür",
            greater_than: "Büyüktür",
            less_than_or_equal: "Küçüktür veya Eşittir",
            greater_than_or_equal: "Büyüktür veya Eşittir",
            visitorName: "Ziyaretçi Adı",
            seconds10: "10 saniye",
            seconds30: "30 saniye",
            minute1: "1 dakika",
            minutes5: "5 dakika",
            minutes10: "10 dakika",
            minutes30: "30 dakika",
            hour1: "1 saat",
            hours2: "2 saat",
            hours4: "4 saat",
            hours8: "8 saat",
            hours12: "12 saat",
            hours24: "24 saat",
            maxCondition: "Maksimum Durum",
            doYouWishToDeleteTrigger: "Tetikleyiciyi Silmek İstiyor musunuz",
            contains: "İçerir",
            not_contains: "İçermez",
            chatLanguage: "Konuşma Dili",
            translating: "Çevriliyor",
            liveSupportStartingWait: "Canlı Destek Başlatılıyor , Lütfen Bekleyiniz",
            noConnection: "Bağlantı Yok!",
            buyWhatsapp: "WhatsApp satın alın",
            integrations: "Entegrasyonlar",
            refundInvoiceSure: "Faturayı iade etmek istediğinize emin misiniz?",
            invoiceMarkedAsPaidSuccess: "Fatura ödendi olarak işaretlenmiştir.",
            invoiceMarkedAsPaidError: "Hata , Fatura ödendi olarak işaretlenemedi.",
            deleteConfirm: "Bu {object} gerçekten silmek istiyor musunuz?",
            markPaidConfirm: "Bu faturayı ödendi olarak işaretlemek istediğine emin misin?",
            startChatDesc: "Konuşma Başlat",
            addLink: "Bağlantı",
            selectStep: "Bir adım seçiniz:",
            addGOTO: "Git",
            sendFastLink: "Şifresiz Giriş Linki Gönder",
            or: "Veya",
            allTags: "Tüm Etiketler",
            showDetail: "Detay Göster",
            hideDetail: "Detay Gizle",
            weLlSendPhone: "Telefonunuza Gönderelim",
            weLlSendEmail: "E-Posta Gönderelim",
            linkSentToPhone: "Link sms olarak gönderildi",
            offerlinkSendToPhone: "SMS ile size uygulamamızın indirme linkini gönderelim.",
            offerlinkSendToMail: "Mail ile size uygulamamızın indirme linkini gönderelim.",
            theEmail: "Kayıtlı E-postam",
            differentEmail: "Farklı E-posta",
            linkSentToMailBox: "Link mail adresinize gönderildi",
            errorOccurred: "Hata oluştu !",
            clickStoreIcon: "Telefonunuza uygun olan icona tıklayarak mobil uygulamaya ulaşabilirsiniz",
            meetWithSupsis: "SUPSIS mobil uygulamamız ile tanışmak ister misiniz?",
            downloadMobileApps: "Mobil Uygulamayı İndirin",
            getApps: "Uygulamaları Edinin",
            info: "Bilgi",
            conversationHistory: "Konuşma Geçmişi",
            events: "Takvim Etkinlikleri",
            reservations: "Rezervasyonlar",
            planInfoHeader: "Plan Bilgisi",
            planInformation:
                "Planınız {selectedPlan} Plan ({detailMaxAgentCount} Temsilci) ({freeAgent} Ücretsiz Temsilci)",
            creditAvailable: "Planınızda mevcut olan Temsilci krediniz: ",
            upDownGradePlan: "Planınızı yükseltmek/düşürmek istiyorsanız, lütfen",
            click: "Tıklayın",
            all: "Hepsi",
            allDepartments: "Tüm Departmanlar",
            preferredLanguage: "Tercih Edilen Dil",
            kmkAutoDepartmentBind: "KMK Otomatik Departmant Bulma",
            kmkAutoDepartmentBindDesc: "KMK Müşteri sayfalarında otomatik mağaza adını bulur ve login formuna set eder",
            visitorEmailUpdated: "Ziyaretci eposta adresi güncellendi",
            visitorEmailIsNotValid: "Girdiniz eposta adresi doğru değil",
            visitorNameUpdated: "Ziyaretci adı güncellendi",
            clickToEdit: "Düzenlemek için tıklayın",
            addEmail: "+ Email Adresi Ekle",
            addFullname: "+ Ad Ekle",
            partner: "Ref?",
            isIntegrated: "Entegrasyon?",
            agentCount: "Temsilci Sayısı",
            autoStartChat: "Otomatik Chat Başlangıcı",
            bubbleColor: "Chat Balonu Rengi",
            openFolder: "Aç",
            preDefined: "Temalar",
            customIcon: "Bilgisayarınızdan Yükleyin",
            theme: "Tema",
            themeSettings: "Tema Ayarları",
            chatThemeSettings: "Chat Tema Ayarları",
            bubbleSettings: "Chat Balonu Ayarları",
            inputHeightOfBubble: "Balon Boyutu",
            inputPixelsOfChatBubble: "Chat Balonu'nun Kenarlara Olan Uzaklıklığını Düzenlemek İçin Tıklayın",
            modalTitleIsMarginAsPixelInfo: "Chat Balonu'nun Kenarlara Olan Uzaklıklığı : ",
            inputPxOfXaxis: "Yatay Konum",
            inputPxOfYaxis: "Dikey Konum",
            inputPxOfMobileXaxis: "(Mobil) Yatay Konum",
            inputPxOfMobileYaxis: "(Mobil) Dikey Konum",
            animations: "Animasyonlar",
            preferredAnimation: "Tercih Edilen Animasyon",
            selectAnAnimation: "Bir Animasyon Seçin",
            inputOfBubbleMessage: "Genis Chat Balonlarına İçerik Ekle.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip:
                "Sohbet Balonunu Oturum Açma Durumuna Bağlı Olarak Gizleme Ayarıdır.Kapalı olması durumunda tüm ziyaretçilere gösterilir.",
            showChatBubbleOnlyLoggedUser: "Balonu Yalnızca Oturum Açmış Kullanıcıya Göster. (ideasoft)",
            helloDoUNeedHelp: "Merhaba, yardımcı olabilirim!",
            bubbleIcon: "Chat Balonu Resmi",
            overrideMargins: "Kenar Boşluklarını Özelleştir",
            autoHideBubble: "Chat Balonunu Gizle",
            vtippyAutoHideBubble: "Temsilciler çevrimdışıyken chat balonunu gizler",
            hideBubble: "Chat Balonunu Devredışı Bırak",
            vtippyHideBubble: "Chat balonunu devredışı bırakır, göstermez.",
            overrideMobileMargin: "Mobil Versiyon Boşlukları Özelleştir",
            vtippyMobileMargin: "Mobil versiyon için chat balonu kenar boşluklarını özelleştir",
            vtippyHideBubbleOnMobile: "Chat Balonu mobile kullanan ziyaretçilerde gizlenir.",
            isFabsActive: "Açılır Menüleri Göster",
            isAlwaysActive: "Menü her zaman açık",
            isAlwaysActiveDesc: "Web görünümünde sohbet balonu menüsünün her zaman açık kalmasını ister misiniz?",
            bubbleOpenableMenu: "Chat Balonu Açılır Menü",
            vtippyIsFabsActive: "Açılır Menüleri Gösterme / Gizleme Ayarıdır",
            vtippyIsFabsAsIcon: "Açılır menünde ikonların görünüp görünmeyeceğinin ayarıdır.",
            vtippyTranslateButton: "Seçili Olan Dili Diğer Dillere Çevirir.",
            vtippyTranslateClearButton: "Diğer dillerdeki içerikleri temizler.",

            vtippySelectnotification: "Bildirim sesi seçebilirsiniz.",
            vtippyVoiceLevel: "Ses seviyesini ayarlayabilirsiniz.",
            vtippyStartVoice: "Dinle",
            vtippyInfiniteNotification:
                "Yeni gelen Chatler panel de aktif değilseniz çalmaya devam eder. Tıklayarak aktif-pasif düzenleyebilirsiniz.",

            vtippyNewVisitorNotification: "Web sitenize gelen ziyaretçiler için sesli bildirim ayarları.",
            vtippyNewChatNotification: "Sisteme gelen her yeni chat için sesli bildirim ayarları.",
            vtippyNewConversationNotification: "Size atanan her yeni chat için sesli bildirim ayarları.",
            vtippyNewMessageNotification: "Size atanmış chatlerden gelen mesaj bildirim ayarları.",
            vtippyPrivateMessageNotification: "Takım konuşmasından gelen mesajlar için sesli bildirim ayarları.",

            isFabsAsIcon: "Menü İkonlarını Göster.",
            setMarginAsPixel: "Piksel olarak ayarla",
            returnDefaultMargins: "Varsayılan Kenar Boşluğu Ayarları",
            closePreviewColors: "Ön İzlemeyi Kapat",
            previewColors: "Ön İzlemeyi Aç",
            videoCalls: "Görüntülü Görüşmeler",
            filterLost: "Kaçan Konuşmalar",
            vtipyCustomLogin:
                "Ziyaretçileriniz sisteme bağlanırken giriş formunda istenecek bilgileri buradan özelleştirebilirsiniz.",
            vtipyLoginlessChat:
                "Ziyaretçileriniz sisteme bağlanırken giriş formu gösterilmez. Temsilciler ziyaretçilerin kişisel bilgilerini isteyerek kullanılır",
            loginlessChat: "Ziyaretçi Giriş Formu",
            imageUrl: "Resim",
            replied: "Yanıtlandı",
            solved: "Çözüldü",
            openImage: "Resmi Aç",
            writeFeedback: "Supsis ile  ilgili geri bildirimini buraya yazabilirsin.",
            feedbackFailed: "Geri bildirim gönderimi sırasında hata oluştu.",
            feedbackSuccessful: "Geri bildirim gönderimi başarılı.",
            sendFeedback: "Geribildirim Gönder",
            errorReport: "SUPSIS ile ilgili yaşadığınız sorunlar hakkında bize geri bildirimde bulunabilirsiniz.",
            sendErrorFeedBack: "Yaşadığınız sorunla ilgili bize geri bildirimde bulunun.",
            successImgUpload: "Resminiz başarıyla yüklendi",
            successImgDelete: "Resim başarıyla silindi.",
            errorImgUpload: "Resminiz yüklenirken bir hata meydana geldi",
            errorImgDelete: "Resim silinirken bir hata meydana geldi",
            chatBotEndStatics: "Chatbot Konusma Sonuçlandırma Oranı",
            videoCallDist: "Video Görüşme Dağılımı",
            deleteSite: '" {siteName} " Sitesi Silinsin mi ?',
            deleteThisSite: "Bu siteyi sil",
            departmentInfo: "Departman Bilgisi",
            infoAboutDepartment: "Departman hakkında kısa bilgi",
            deleteDepartmentQuestion: "Bu departmanı gerçekten silmek istiyor musunuz?",
            departmentDeleted: "Departman silindi",
            departmentTitle: "Departman Başlığı",
            updateDepartmentForm: "Departman Güncelleme Formu",
            updateCompleted: "Güncelleme Tamamlandı",
            CatalogUpdatedSuccessfully: "Güncelleme Başarıyla Tamamlandı",
            integrateSupsiswithIntegratable: "Supsis ve {integratable} arasında sohbet bilgilerini kolaylıkla iletin.",
            installationOK: "Yüklü",
            newDepartmentForm: "Yeni Departman Kayıt Formu",
            newDepartment: "Yeni Departman",
            departmentSaved: "Departman Kaydedildi",
            sameDepartment: "Aynı isimde bir departman mevcut!",
            sameValue: "Aynı isimde bir değer mevcut!",
            sameTag: "Aynı isimde bir etiket mevcut!",
            departments: "Departmanlar",
            department: "Departman",
            announcements: "Duyurular",
            announcement: "Duyuru",
            newAnnouncement: "Yeni Duyuru",
            announcementInfo: "Duyuru Bilgisi",
            infoAboutAnnouncement: "Duyuru hakkında kısa bilgi",
            deleteAnnouncementQuestion: "Bu duyuruyu gerçekten silmek istiyor musunuz?",
            announcementDeleted: "Duyuru silindi",
            announcementTitle: "Duyuru Başlığı",
            updateAnnouncementForm: "Duyuru Güncelleme Formu",
            newAnnouncementForm: "Yeni Duyuru Kayıt Formu",
            announcementSaved: "Duyuru kaydedildi.",
            chatTimingSettings: "Chat Süre Ayarları",
            assetOversize: "Göndermek istediğiniz dosyanın boyutu 10mb'den büyük olmamalıdır.",
            assetOversizeMB: `Göndermek istediğiniz dosyanın boyutu {mb} mb'den büyük olmamalıdır.`,
            assetOversizeWithExt: "Dosya boyutu 10mb'tan küçük ve png,jpg formatında olmalıdır.",
            messageDeleted: "Bu mesaj silindi",
            filterVideoCall: "Görüntülü Görüşmeleri Gösterir",
            filterLostChat: "Kayıp Sohbetleri Filtreler",
            filterClosedByAgent: "Temsilci Tarafından Kapatılan Sohbetleri Filtreler",
            notificationText: "Supsis bildirimlerinin doğru şekilde çalışması için ",
            notificationTitle: "Bildirimler Kapalı",
            deniedText:
                "Bildirimleriniz kapalıdır, Müşterilerinizi kaçırmamanız için bildirimlerinizi açmanız gerekmektedir.",
            deniedTitle: "Bildirimlerinizi Açmak İçin Tıklayınız !",
            deniedHeader: "Müşterilerinizi kaçırmamak için bildirimlerinizi açmanız gerekmektedir!",
            showNotificationGuide: "Detaylar için tıklayın",
            howToEnableNotification: "Bildirimleri Nasıl Etkinleştirebilirim",
            notificationOK: "Tamam",
            notificationUnderstood: "Anladım",
            notificationCancel: "İptal",
            howToEnableNotificationInstruction1: "Tarayıcının adres çubuğundaki kilit ikonuna tıklayınız",
            howToEnableNotificationInstruction2: "İzinler kısmında 'Bildirimler' pasif gözüküyorsa aktifleştirin",
            howToEnableNotificationInstruction3:
                'İzinler kısmında "Bildirimler" gözükmüyorsa "Site Ayarlarına" tıklayınız',
            howToEnableNotificationInstruction4:
                'Site ayarları sayfasından "İzinler" bölümden "Bildirimler" iznini açınız',
            checkPaymentMethod: "Lütfen ödeme yönteminizi kontrol edin",
            pushNotificationEnabled: "Harika, Bildirim gönderimi etkin.",
            pushNotificationDenied: "Bildirim izinlerini reddettiniz",
            suspendedMessage: "Hesabınız askıya alındı",
            suspendedDescription: "Hesabınız ödenmemiş faturalarınız yüzünden askıya alındı.",
            enableNotification: "Bildirimlerinizi açınız.",
            languageSettings: "Konuşma Dili",
            problemsSound:
                'Eğer bildirimler ile ilgili sorun yaşıyorsanız, tarayıcınızın adres çubuğundan (Resimde Gösterilen) kilit iconuna tıklayıp "Site Ayarları" alanından tıklayarak, açılan  bölümden "Ses" izin ver olarak değiştirebilirsiniz.',
            betweenRepresentative: "Bir temsilci yeni mesajı.",
            desktopNotifications: "Bildirimler",
            notificationDisable: "Temsilci ayarlarından masaüstü bildirimlerini kapatabilirsiniz.",
            notificationEnabled: "Supsis bildirimleri aktif.",
            newMessageAlert: "Yeni bir mesajınız var.",
            newConversationAlert: "Yeni bir konuşmanız var.",
            chatBot: "ChatBot",
            ticketResponse: "Representative Response:",
            archived: "Arşivle",
            chatbotChatCount: "CHATBOT",
            closeChat: "Mesajlaşmayı Bitir",
            ticket: "Ticket",
            formStep: "Form Adımı",
            menuStep: "Menü Adımı",
            contentStep: "İçerik Adımı",
            menuTitle: "Menü Başlığı",
            messageContent: "Mesaj İçeriği",
            goToLive: "Temsilciye Aktar",
            prevStep: "Önceki Adıma Dön",
            button: "Buton",
            addImage: "Görüntü",
            addText: "Metin",
            stepTitle: "Adım Başlığı",
            addTicket: "Ticket",
            formDescription: "Soru",
            addInput: "Soru",
            addRandomText: "Rastgele Metin",
            changeTitle: "Başlığı Değiştir",
            changeVisitorTitle: "Visitor Başlığını Değiştir",
            catalog: "Katalog Başlığı",
            openTheCatalog: "Kataloğu Aç",
            catalogNotOpen:
                "Katalog özelliği devre dışı. Müşterilerinize önceden hazırlanmış içeriklerle destek sağlamak için katalok özelliğini açabilirsiniz.",
            showCatalogCategories: "Katalog menünüsün chat balonunda gözükme durumunu değiştir.",
            showChatBot: "ChatBot menünüsün chat balonunda gözükme durumunu değiştir.",
            openCatalog: "Katalog",
            unreadMessages: "Okunmamış Mesajlar",
            personalFirstMsg: "Temsilci İlk Cevaplama Süresi Ortalaması(sn)",
            personalRating: "Personel Puan Ort.",
            soundSettings: "Bildirim Ayarları",
            newPrivateMessage: "Özel Mesaj",
            addNewGroup: "Yeni Grup Oluştur",
            teamChatTeam: "Takım Mesajları",
            teamChatDm: "Dm Mesajları",
            teamChatDepartment: "Departman Mesajları",
            teamChatGroup: "Grup Mesajları",
            newMessage: "Yeni Mesaj",
            newConversation: "Yeni Chat",
            newVisitor: "Yeni Ziyaretçi",
            chatPosition: "Chat Konumu",
            bottomLeftCorner: "Sol alt köşe",
            leftDocked: "sola Yerleştir",
            bottomRightCorner: "Sağ alt köşe",
            rightDocked: "sağa Yerleştir",
            chatPositionSelect: "Konum Seçiniz",
            bottomLeft: "Sol Alt",
            left: "Sola yaslı",
            bottomRight: "Sağ Alt",
            right: "Sağa yaslı",
            mailorname: "E-Posta ya da İsim",
            breaksByTime: "Zamana göre mola sayıları",
            clPlaceholder: "Müşteri formunda gözükücek isim",
            fieldName: "Anahtar İsim",
            value: "Değer",
            addSetting: "Yeni Bir Ayar Ekle",
            globalSettings: "Genel Ayarlar",
            target: "Yük testi adresi",
            duration: "Yük testi süresi(sn)",
            arrivalCount: "Bot Sayısı(adet)",
            bootMaxLife: "Bir botun ayakta kalma süresi(sn)",
            startLoadTest: "Yük Testini Başlat",
            noClusterInstanceFound: "Sunucu bulunamadı",
            stopLoadTest: "Yük Testini Bitir",
            integrationDesc: "Aşağıdaki  tek satırlık kodu sitenize  eklemeniz yeterlidir.",
            integrationDemoCode: "Örnek entegrasyon demo kodu",
            integrationWindow: "Siteme Nasıl Entegre Yaparım ?",
            notIntegrated: "Entegrasyon",
            help: "Yardım",
            notIntegratedDesc:
                "Chat sistemini sitenize eklemediğinizi farkettik. Sitenize entegre edip ilk görüşmeyi başlattığınızda entegrasyonu tamamlamış olacaksınız. ENTEGRASYON KODU için tıklayınız",
            backToLogin: "Tekrar Giriş Yap",
            passwordlessLoginUnsuccessful:
                "Giriş başarısız.Giriş linkinin süresi dolmuş veya daha önce kullanılmış olabilir.",
            passwordlessLogin: "Şifresiz Giriş",
            loginWithEmail: "Eposta ile Giriş Yap",
            loginWithPassword: "Şifre ile Giriş Yap",
            enteringPasswordless: "Şifresiz Giriş Yapılıyor...",
            toMainPath: "Anasayfaya yönlendir",
            userRoleChanged: "Kullanıcı izinleriniz değişti. Devam etmek için ana sayfaya yönlendirileceksiniz.",
            passwordChangeSuccess: "Şifre Değiştirme İşleminiz Başarılı...",
            feedback: "Geri bildirim",
            showFeedbackHistory: "Geri bildirim gönderilmiş mesajları göster.",
            newSelfServiceSite: "Yeni Self Servis Site",
            subdomain: "Alt alan adı",
            rootUserEmail: "Kullanıcı Eposta",
            rootUserName: "Adınız",
            newVersion: "Yeni Sürüm Mevcut",
            closeLiveSupport: "Canlı Desteği Kapat",
            newVersionShort: "Yeni Sürüm",
            bannedWordRestrict: "Yasaklı Kelime Engelleme",
            ticketShow: "Müşterilerin Ticket Oluşturmasına izin ver",
            ticketShowDesc: "Chat Menüsünden Ticket Oluşturma Seçeneğini aktif et",

            autoLoadIframe: "Canlı Trafik",
            autoLoadIframeDesc: "Iframe otomatik yükler ve tüm ziyaretci trafiği alır",
            bannedWordRestrictDesc:
                "Yasaklı Kelime Engelleme açık olduğunda temsilciler sisteme tanımlanana yasaklı kelimeleri ziyaretcilere yazması engellenir",
            agentDown: "Temsilci Düştü",
            delayChat: "Geciken Konuşma",
            tableSettingTippy: "Tabloda görünecek bilgileri burdan değiştirebilirsiniz.",
            tableSettings: "Tablo Ayarları",
            tableSettingsInfo:
                "Tabloda görünecek bilgileri burdan değiştirebilirsiniz. En fazla 7 tane sütun seçebilirsiniz",
            privateParametry: "Özelliştirilmiş Kullanıcı Parametreleri",
            systemOperetor: "Sistem Bilgileri",
            cityAndDistrict: "Şehir/İlçe",
            general: "Genel",
            availability: "Temsilci Çalışma Saatleri",
            home: "Anasayfa",
            successful: "Başarılı",
            forgetPasswordSent: "Parola sıfırlama maili gönderildi, e-mailinizi kontrol ediniz.",
            saturday: "Cumartesi",
            friday: "Cuma",
            thursday: "Perşembe",
            wednesday: "Çarşamba",
            tuesday: "Salı",
            monday: "Pazartesi",
            sunday: "Pazar",
            download: "Dosyayı İndir",
            calendarPassedTimeHour: "{hour} saat {name}",
            calendarPassedTime: "{hour} saat {min} dk {name}",
            calendarPassedTimeMinSec: "{min} dk {sec} sn {name}",
            calendarPassedTimeMin: "{value} dk {name}",
            calendarPassedTimeSec: "{hour} saat {min} dk {sec} sn {name}",
            workScheduleOneDay: "{name} Adlı Kullanıcının {sDate} Günü çalışma Takvimi",
            workSchedule: "{name} Adlı kullanıcın {sDate} - {eDate} Arası Çalışma Takvimi",
            calendar: "Takvim",
            noRating: "Hiç Puanlama Yapılmamış",
            rateDist: "Puan Dağılımı",
            distConversation: "Temsilcilerin Konuşma Dağılımı",
            distributionConversa: "Puanlama Dağılımı",
            distChatbotAgent: "İletişim Kanalları",
            distAgent: "Chatbot & Agent",
            distFugitive: "Kaçan Konuşma & Karşılanan Konuşma",
            distLive: "Canlı Sohbet",
            distChatbot: "Chatbot",
            distComplex: "Chatbot + Canlı Sohbet",
            distHandled: "Karşılanan Konuşma",
            distMissed: "Kaçan Konuşma",
            distWeb: "Web Site",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "Whatsapp Chat Sayısı",
            statsByTime: "Zamana Göre Konuşma Sayıları",
            selectRep: "Bir temsilci seçin",
            allRepresentatives: "Bütün Temsilciler",
            avgRating: "Puan Dağılım ({point}) ({count} değerlendirme)",
            avgFirstMessageTime: "Ortalama ilk müdehale süresi ",
            totalBreakTime: "Sistem Mola Süresi",
            totalBreakNum: "Mola Sayısı",
            averageConTime: "Ortalama Konuşma Süresi",
            multiWpReportTitle: " Whatsapp Konuşma Sayısı",
            multiWpReport: " Whatsapp Chat Dağılımı",
            multiWpReportExplanation: " Whatsapp Kanallarınızın Chat Miktarını Görebilirsiniz.",
            longestConTime: "En uzun Konuşma Süresi",
            shortestConTime: "En Kısa Konuşma Süresi",
            refresh: "Yenile",
            waitingReply: "Cevap Bekleyenler",
            organizationName: "Organizasyon Adı",
            companySlogan: "Şirket Sloganı",
            messageSentErr: "Mesaj gönderilemedi, tekrar deneyiniz.",
            messageSent: "Mesaj gönderildi.",
            openPrivateChat: "Temsilciler arası konuşmayı aç",
            escKey: "Aktif konuşmayı gizle",
            archiveChatKey: "Arşiv Sayfası alttaki sohbete inmeyi sağlar.",
            chatCopilot: "Chat CoPilot özelliğini açar",
            privateChat: "Temsilciler Arası Konuşma Paneli",
            multiModeAlertDesc:
                'SUPSIS başka bir pencerede açık. SUPSIS\'ı bu pencerede kullanmak için "Burada Kullan"a tıklayın.',
            useHereText: "Burada Kullan",
            brandVisibility: "SUPSIS marka etiketi chat balonunda gözükür",
            focusInput: " İmleci aktif olan konuşmanın yazma alanına odaklar",
            send: "Gönder",
            notYet: "Henüz değil",
            sending: "Gönderiliyor",
            onlyRepresentative: "Mesajınız sadece temsilciler tarafından görülecektir.",
            yourMessage: "Mesajınız",
            liveFabListDescription: "Canlı Destek",
            messengerIntegrationDesc:
                " Facebook sayfası üzerinden müşterilerinizle sohbet edin , chatbot ile otomatik mesajlar gönderin.",
            checkDepartmentToAgent: "Çevrimiçi temsilcinin kontrol edileceği departman",
            ifAllOfflineStory: "Çevrimiçi temsilci yoksa yönlendirmek için hikaye",
            AssignMessagesToAgents: "Tüm mesajları Temsilcilere Yönlendir",
            firstChatbotAndAssign: "Önce Chatbot Cevap Verir ve Sonra Temsilciye Yönlendirir",
            hybridAssign:
                "Sistem, çevrimiçi bir temsilci olup olmadığını görmek için departmanı kontrol eder ve çevrimiçi bir temsilci yoksa, bunu chatbot'a atar.",
            ticketFabListDescription: "Ticket",
            whatsappFabListDescription: "Whatsapp",
            phoneFabListDescription: "Telefon",
            emailFabListDescription: "E-posta",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Bu alana {channelLink} kanalınızın linkini koyabilirsiniz.",
            typeYourAccountLink: "Bu alana {accountLink} hesabınızın linkini koyabilirsiniz.",
            typeYourMessage: "Mesajınızı buraya yazın",
            typeYourMessageMail:
                "Bu alana girilen mesaj Müşteri tarafından yukarıdaki mail adresine ilk mesaj olarak gönderilecektir.",
            typeYourMessageDesc:
                "Bu alana girilen mesaj, Müşteri tarafından yukarıdaki telefon numarasına ilk mesaj olarak gönderilecektir.",
            sendNumber: "Mesajın gönderileceği telefon numarası: {path}",
            callNumber: "Müşterinizin arayacağı telefon numarası: {phoneNumber}",
            numberIsNotCorrect: "Eksik numara girildi !!",
            emailIsNotCorrect: "E-posta Hatalı !",
            selectFab: "Bir Fab Seçin",
            notValid: "Sadece harf girebilirsiniz.(Tek karakter). e,d,f,z,a,x,c,v,w,t,n harfleri geçersizdir",
            forMacUsers: " Mac kullanıcıları Control(⌃) tuşunu kullanabilir",
            basePriceValue: "Taban Fiyat",
            basePriceDiscount: "İndirim",
            basePriceCurrency: "Para Birimi",
            customerDBEnabled: "Veritabanı Seçimi: Müşterinin Kendi Veritabanı Sunucusu Kullan",
            customerDBDisabled: "Veritabanı Seçimi: Supsis Veritabanı Sucunusu Kullan",
            mongoConnectionString: "Mongo Bağlantısı",
            whatsappBasePriceValue: "Whatsapp Taban Fiyatı",
            whatsappPlusBasePriceValue: "Whatsapp Plus Taban Fiyatı",
            instagramBasePriceValue: "Instagram Taban Fiyatı",
            instagramPlusBasePriceValue: "Instagram Plus Taban Fiyatı",
            clientAddress: "İstemci Adresi",
            customerClientAddress: "Müşteri İstemci Adresi",
            apiAddress: "Api Adresi",
            socketAddress: "Soket Adresi",
            backendAddress: "BackEnd Adresi",
            panelLogoUrl: "Panel Logo Adresi",
            panelCustomCssUrl: "Özel Panel Css Adresi",
            customerLogoUrl: "Müşteri Logo Adresi",
            customerCssUrl: "Müşteri css Adresi",
            siteAlias: "Site Adı",
            language: "Dil",
            features: "Özellikler",
            interactionPopularity: "Etkileşimlerin popülerliği",
            interactionCount: "Etkileşim Sayısı",
            uniqueUserCount: "Benzersiz Kullanıcı Sayısı",
            allUserPercentage: "(%) Tüm Kullanıcıların Yüzdesi",
            represantativeSettings: "Temsilci Ayarları",
            documentTitle: "Supsis Doküman Formu",
            supsisDocument: "Supsis Döküman",
            ApiDoc: "Api Dönümanı",
            chatBalloonTehemeSettings: "Sohbet Balonu ve Tema Ayarları",
            customLoginFormSettingsTitle: "Ziyaretçi Giriş Formunu Özelleştir",
            addNewField: "Yeni Alan Ekle",
            editField: "Alanı Düzenle",
            typeHere: "Buraya yaz",
            pco: "PÇO",
            perPage: "/sayfa",
            perPageInFilter: "Adet",
            noUserInfoFound: "Kullanıcı Bilgisi Bulunamadı",
            startFilter: "Aramaya başla",
            CHAT: "Sohbet",
            showMyChats: "Bana Atananları Göster",
            showOnlineAgents: "Sadece Çevrimiçi Olanları Göster",
            showWaitingChats: "Temsilci Bekleyenleri Göster",
            addNewStatus: "Durum Ekle",
            newTitleContent: "Başlık Ekle",
            roleName: "Rol Adı",
            error: "Hata",
            contentType: "İçerik Tipi",
            contentTitle: "İçerik Başlığı",
            newSiteForm: "Yeni Site Kayıt Formu",
            updateSiteForm: "Site Güncelleme Formu",
            newBannedWordForm: "Yeni Yasaklı Kelime Kayıt Formu",
            updateBannedWordForm: "Yasaklı Kelime Güncelleme Formu",
            newWelcomeMessageForm: "Yeni Karşılama Mesajı Kayıt Formu",
            updateWelcomeMessageForm: "Sistem Mesajı Güncelleme Formu",
            newDefaultContentForm: "Yeni Hazır İçerik Kayıt Formu",
            updateDefaultContentForm: "Hazır İçerik Güncelleme Formu",
            newSubjectForm: "Yeni Konu Kayıt Formu",
            updateSubjectForm: "Konu Güncelleme Formu",
            showIntro: "Tanıtımı Göster",
            showChatColorMeaning: "Sohbet Renkleri",
            options: "Seçenekler",
            resetPassword: "Şifreyi yenile",
            audioLevel: "Sesli uyarı ses seviyesi",
            privateChatNotificationSound: "Bildirim sesi",
            continue: "Devam et",
            newRoleForm: "Yeni Rol Kayıt Formu",
            updateRoleForm: "Rol Güncelleme Formu",
            newUserForm: "Yeni Kullanıcı Kayıt Formu",
            updateUserForm: "Kullanıcı Güncelle Formu",
            changeOSRForm: "Çevrimdışı Mesaj Değiştir",
            tooltipOSRForm: "Çevrimdışı mesajı değiştireblirsiniz.",
            newOSRForm: "Çevrimdışı Destek Formu",
            newOSRMessages: "Çevrimdışı Mesaj Ekle",
            newOsrMessageTitle: "Çevrim Dışı Mesaj Başlığı",
            updateOSRForm: "Çevrimdışı Güncelleme Formu",
            osrTitle: "Başlık",
            osrTitleDescription: "Çevrimdışı destek formu başlığı ekleyebilirsiniz",
            osrContent: "İçerik",
            osrContentDescription: "Çevrimdışı destek formu içeriği ekleyebilirsiniz",
            hello: "merhaba dünya",
            date: "Tarih",
            startDate: "Başlangıç Tarihi",
            finish: "Bitiş",
            start: "Başlangıç",
            search: "Aramaya Başla",
            endDate: "Bitiş Tarihi",
            representative: "Temsilciler",
            representative_: "Temsilci",
            star: "Yıldız",
            filter: "FİLTRELE",
            reset: "SIFIRLA",
            dailyChatList: "Günlük Konuşma Listesi",
            dailyChatDuration: "Günlük Konuşma Süreleri",
            chatDuration: "Konuşma Süresi",
            dailyChatGraph: "Günlük Konuşma Grafiği",
            ok: "Tamam",
            cancel: "Vazgeç",
            chatCount: "Chat Sayısı",
            shortest: "En Kısa",
            longest: "En Uzun",
            average: "Ortalama",
            count: "Adet",
            averagePoint: "Ortalama Puan",
            pointDist: "Puan Dağılımı",
            point: "Puan",
            filters: "Filtreler",
            totalCustomer: "Toplam Müşteri",
            avResponseTime: "Ort. İlk Müdahale Zamanı",
            breakDuration: "Mola Süresi",
            breakCount: "Mola Adeti",
            active: "Aktif",
            passive: "Pasif",
            userForm: "Kullanıcı Formu",
            startChat: "Chat Başlat",
            sender: "Gönderen",
            profile: "Profil",
            name: "Ad",
            number: "Numara",
            username: "Kullanıcı Adı",
            updateUserName: "Kullanıcı Adı Güncelle",
            email: "E-Posta",
            password: "Şifre",
            oldPassword: "Eski Şifre",
            newPassword: "Yeni Şifre",
            passwordAtLeast: "Şifre (en az {num} karakter)",
            passwordRepeat: "Şifre Tekrar",
            changePassword: "Şifre Değiştir",
            status: "Durum",
            enableState: "Aktif?",
            douYouWishToDeleteUser: "Bu kullanıcıyı gerçekten silmek istiyor musunuz?",
            douYouWishToDeleteAnnouncement: "Bu duyuruyu gerçekten silmek istiyor musunuz?",
            userDeleted: "Kullanıcı silindi",
            userSaved: "Kullanıcı kaydedildi.",
            oldPasswordError: "Eski şifre hatalı, lütfen kontrol edin.",
            chooseAnOption: "Lütfen tercih ettiğiniz bildirim sesini seçin.",
            userVolumeUpdated: "Ses ayarı güncellendi.",
            save: "Kaydet",
            update: "Güncelle",
            addNewMenu: "Yeni Menü Ekle",
            addNewContent: "Yeni İçerik Ekle",
            pleaseTitleEnter: "Lütfen başlık girin",
            like: "Beğenilme",
            disLike: "Beğenilmeme",
            users: "Kullanıcılar",
            visitor: "Ziyaretçiler",
            allContacts: "Tüm Bağlantılar",
            allUsers: "Tüm Temsilciler",
            allSites: "Tüm Siteler",
            newUser: "Yeni Kullanıcı",
            noNewUser: "Henüz bir kullanıcı yok.",
            noNewAdminUser: "Henüz bir admin kullanıcı yok.",
            noNewAnnouncement: "Henüz bir duyuru yok.",
            noRoleFound: "Henüz bir rol yok.",
            noBannedWordFound: "Henüz yasaklı kelime yok.",
            noWelcomeMessageFound: "Henüz sistem mesajı yok.",
            noSubjectFound: "Henüz konu yok.",
            noVisitorFound: "Ziyaretci bulunamadı.",
            noContactFound: "Rehber bulunamadı.",
            sendResponse: "Cevap Yaz",
            delete: "Sil",
            duplicate: "Kopyala",
            makeDefault: "Varsayılan Yap",
            checkMore: "Daha Fazlası",
            useReadyTemplates: "Hazır Şablonlar Kullanın",
            useAITemplates: "Hazır Yapay Zeka Şablonları Kullanın",
            noRePresentativeFound: "Temsilci bulunamadı.",
            noLiveSupportFound: "Henüz canlı destek kaydı yok.",
            noLiveSupportFoundWithDepartment: " Departmanına Ait Chat Kaydı Yoktur",
            noBannedVisitorFound: "Henüz bir yasaklı ziyaretçi yok.",
            removeBanDescription: "Yasağı kaldır",
            editThisItem: "Bu kaydı güncelle",
            removeThisItem: "Bu kaydı sil",
            role: "Rol",
            newRolePlaceHolder: "Yeni rol eklemek için tıklayınız...",
            autoChatAssignLimit: "Otomatik Konuşma Atama Limiti",
            chatAssignInfo: "-1 = Sistem varsayılanı, 0 = Hiç atama yapılmaz, >0 = Verilen değer kadar atama yapılır.",
            relatedDepartments: "İlgili Departmanlar",
            subjectInfo: "Konu seçilmemesi halinde tüm konulara izin verilecektir..",
            archive: "Arşiv",
            offlineSupportRequests: "Çevrimdışı Destek",
            offlineModeMessage: "Çevrimdışı Mesaj",
            offlineMode: "Çevrimdışı Mod",
            first: "İlk",
            last: "Son",
            query: "Aramaya Başla",
            clean: "Temizle",
            loading: "Yükleniyor",
            loadMore: "Daha fazla yükle",
            noMessage: "Hiç mesaj yok...",
            selectChat: "Konuşma Seçiniz",
            noMessageInChat: "Bu konuşmada herhangi bir mesaj bulunamadı",
            noMediaToShow: "Gösterilecek Medya Yok",
            userInfo: "Kullanıcı Bilgileri",
            firstSeen: "İlk Görülme",
            userProfile: "Profil",
            addCalendarEvent: "Etkinlik +",
            chatId: "Konuşma ID",
            visitorId: "Ziyaretçi ID",
            visitingPage: "Ziyaret Edilen Sayfa",
            osAndBrowser: "İşletim Sistemi & Tarayıcı",
            customerClientVersion: "Müşteri Versiyonu",
            visitorFeedback: "Müşteri Geri Bildirimi",
            notes: "Notlar",
            nameSurname: "Adı Soyad",
            chats: "Konuşmalar",
            bannedVisitors: "Yasaklı Ziyaretçiler",
            country: "Ülke",
            city: "Şehir",
            cityDistrict: "İl İlçe",
            browser: "Tarayıcı",
            os: "İşletim Sistemi",
            ipAddress: "IP Adresi",
            connectionDate: "Bağlantı Zamanı",
            transaction: "İşlem",
            banRemoved: "Engelleme kaldırıldı.",
            bannedWords: "Yasaklı Kelimeler",
            newBannedWord: "Yeni Yasaklı Kelime",
            noBannedWord: "Henüz bir engelli kelime yok.",
            bannedWordForm: "Yasaklı Kelime Formu",
            word: "Kelime",
            bannedWordAndWordGroup: "Yasaklı kelime / kelime grubu",
            doYouWishToDeleteBannedWord: "Bu yasaklı kelimeyi gerçekten silmek istiyor musunuz?",
            doYouWishToOfflineSupportRequest: "Bu mesajı silmek istiyor musunuz?",
            bannedWordSaved: "Yasaklı kelime kaydedildi",
            deletedSuccessfully: "Başarıyla silindi",
            deleteErrorMsg: "Silme işlemi gerçekletirilemedi, tekrar deneyiniz",
            socketError: "Sockete Bağlantı sorunu. Lütfen sayfayı yenileyip tekrar deneyiniz",
            socketConnecting: "Sunucu ile bağlantı kuruluyor",
            offlineModeDescription: "Sistem kapalı, müşteriler canlı desteğe erişemeyecek.",
            offlineModeSettingsDescription: "Ayarlar menüsünde 'Çevrimdışı Mod' özelliğini kontrol edin.",
            offlineModeUser: "Sistemde en az bir online temsilci olması gerekir.",
            adminCannotConnectSocket: "Adminler sokete bağlanamaz.",
            liveSupport: "Canlı Destek",
            siteVisitors: "Site Ziyaretçileri",
            visitors: "Ziyaretçiler",
            mail: "Mailler",
            thoseConnectedToLiveSupport: "Canlı Desteğe Bağlananlar",
            visitorHistory: "Ziyaretçi Geçmişi",
            visitorHistoryDescription: "Ziyaretçi sohbet geçmişini görüntüleyebilir ve indirebilirsiniz.",
            privateMessage: "Özel Mesaj",
            addRepresentative: "Temsilci Ekle",
            forwardRepresentative: "Temsilciye Yönlendir",
            keyboardShortcuts: "Klavye Kısayolları",
            chatColorMeanings: "Konuşma Renk Anlamları",
            connLostCheckInternet: "Bağlantınız koptu. Lütfen internet bağlantınızın olduğundan emin olunuz.",
            wishToEndThisChat: "Bu görüşmeyi sonlandırmak istiyor musunuz?",
            defaultContents: "Şablonlar",
            contents: "İçerikler",
            newDefaultContent: "Yeni Hazır İçerik",
            newCTRLContent: "CTRL İçeriği Ekle",
            newALTContent: "ALT İçeriği Ekle",
            newTABContent: "TAB İçeriği Ekle",
            title: "Başlık",
            shortcutChar: "Kısayol Karakteri",
            pickOne: "Birini seçin",
            writeSomething: "Bir karakter yazın (a-z|0-9)",
            letterSequence: "Harf Serisi",
            exampleText: "Örnek: fut -> futbol",
            anyChar: "Herhangi bir karakter",
            shorcutKey: "Kısayol tuşu",
            content: "İçerik",
            shortcutName: "Kısayol Adı",
            type: "Tip",
            shortcut: "Kısayol",
            deleteContentQuestion: "Bu Hazır İçeriği gerçekten silmek istiyor musunuz?",
            defaultContentDeleted: "Hazır İçerik silindi.",
            defaultContentSaved: "Hazır İçerik kaydedildi.",
            defaultContentForm: "Hazır İçerik Formu",
            titleContentForm: "Hazır İçerik Başlığı",
            contentMoved: "İçerik taşındı.",
            cannotMoveFullParent: "Bu elemanı taşıyamazsınız",
            yourEmail: "E-Posta Adresiniz",
            yourName: "Adınız ve Soyadınız",
            lostPassword: "Şifremi Unuttum",
            login: "Giriş",
            forgotPassword: "Parolamı Unuttum",
            multipleSession: "Başka bir yerde oturum açtınız.",
            notAuthorizedToDisplayPage: "Bu sayfayı görüntülemek için izniniz bulunmuyor!",
            permissions: "İzinler",
            newPermission: "Yeni İzin",
            permissionForm: "İzin Formu",
            displayTitle: "Görüntüleme başlığı",
            key: "Anahtar",
            keyToUseInSystem: "Sistemde kullanılacak anahtar değer",
            deletePermissionQuestion: "Bu izni gerçekten silmek istiyor musunuz?",
            permissionDeleted: "İzin silindi.",
            permissionSaved: "İzin kaydedildi.",
            newRole: "Yeni Rol",
            selectARole: "Bir Rol Seç",
            yes: "Evet",
            no: "Hayır",
            fullAuth: "Tam Yetki",
            roleDeleted: "Rol silindi.",
            sameRole: "Aynı isimde bir rol mevcut",
            roleSaved: "Rol kaydedildi.",
            roleForm: "Rol Formu",
            roles: "Roller",
            settings: "Ayarlar",
            selectTopic: "Departman Seçimi",
            autoCallTransfer: "Otomatik Görüşme Aktarımı",
            customerTyping: "Kullanıcı Yazıyor",
            typing: "Yazıyor",
            agentTyping: "Temsilci  Yazıyor",
            disconnectTime: "Konuşmayı Sonlandırma Süresi (sn)",
            tippyDissconnectTime: "Hareketsiz durumdaki konuşmayı kaç saniye sonra kapatılacağını ayarlar",
            queueNumberVisibleFeature: "Ziyaretciye Sırada Bekleyen Kişi Sayısını Göster",
            privateChatEnabled: "Temsilciler Arası Sohbeti Göster",
            delayedTalkTime: "Gecikme Süresi(sn)",
            employeeAverageChatCount: "Personel chat oranı için ortalama konuşma sayısı",
            customerDownTimeWhenRepExit: "Temsilci çıkış yaptığında müşteri boşa düşme süresi(sn.)",
            autoAssignLimit: "Otomatik Atama Limiti",
            wasted: "Boşa Düşme Süresi (sn)",
            settingsSaved: "Ayarlar kaydedildi.",
            settingsCannotSaved: "Ayarlar Kaydedilemedi",
            noAuthorization: "Yetkiniz Yok!",
            warningBadInput: "0 ile 70 arasında bir sayı girmeniz önerilir.",
            warningBadInputMarginY: "Dikey Kenar Boşluğu Girişi Hakkında Uyarı ⚠️",
            warningBadInputMarginX: "Yatay Kenar Boşluğu Girişi Hakkında Uyarı ⚠️",
            warningBadInputBubbleSize: "Balon Boyutu Girişi Hakkında Uyarı ⚠️",
            settingFormWrong: "Girdiğiniz veriler hatalıdır, kontrol edip tekrar deneyiniz",
            delayTime: "Gecikme Zamanı (sn.)",
            sites: "Siteler",
            newSite: "Yeni Site",
            noSiteYet: "Henüz bir site yok.",
            siteAddress: "Site Adresi",
            turnBack: "Geri Dön",
            customerRepLimit: "Müşeri Temsilcisi Limiti",
            siteSaved: "Site kaydedildi.",
            siteSaveError: "Site oluştururken hata oluştu.",
            subjects: "Konular",
            newSubject: "Yeni Konu",
            noSubject: "Henüz bir konu yok.",
            subject: "Konu",
            subjectTitle: "Konu Başlığı",
            description: "Açıklama",
            infoAboutSubject: "Konu hakkında kısa bilgi",
            deleteSubjectQuestion: "Bu konuyu gerçekten silmek istiyor musunuz?",
            subjectDeleted: "Konu silindi",
            subjectSaved: "Konu kaydedildi.",
            osrFromMessageSaved: "Çevrimdışı mesaj kaydedildi.",
            welcomeMessages: "Sistem Mesajları",
            newWelcomeMessages: "Yeni Karşılama Mesajı",
            noWelcomeMessage: "Henüz bir sistem mesajı yok.",
            welcomeMessageContent: "Sistem mesaj içeriği",
            makeChoice: "Bir seçim yapın...",
            welcomeMessage: "Karşılama Mesajı",
            repLoggedIn: "Temsilci oturum açtı",
            loginMessage: "Oturum kapatma mesajı",
            message: "Mesaj",
            messageTitle: "Başlık",
            deleteWelcomeMessageQuestion: "Bu sistem mesajını gerçekten silmek istiyor musunuz?",
            welcomeMessageDeleted: "Sistem mesajı silindi",
            welcomeMessageSaved: "Sistem mesajı kaydedildi.",
            welcomeMessageForm: "Sistem Mesajı Formu",
            noRep: "Henüz bir temsilci yok.",
            addChat: "Görüşmeye Ekle",
            forwardChat: "Görüşmeyi Yönlendir",
            ago: "önce",
            repName: "Temsilci Adı",
            lastOnline: "Son Bağlantı/Online zamanı",
            lastStatusChange: "Son Durum Değişikliği",
            activeChat: "Aktif konuşma",
            userMaxCapacity: "Max Chat Kapasitesi",
            noActiveChat: "Aktif konuşma yok.",
            watch: "İZLE",
            join: "KATIL",
            open: "KONUŞMAYI AÇ",
            directMessage: "ÖZEL MESAJ",
            block: "ENGELLE",
            transactions: "İşlemler",
            informations: "Bilgiler",
            visitStart: "Ziyaret Başlangıcı",
            fullName: "Adı Soyadı",
            waitChatTime: "Bekleme Süresi/Chat Süresi",
            blockUserConfirm: "Bu kişiyi gerçekten engellemek istiyor musunuz?",
            messaging: "Mesajlaşma",
            hideChat: "Konuşmayı Gizle",
            block_: "Engelle",
            privateMessage_: "Gizli Mesaj",
            assignRep: "Temsilci Ata",
            joinChat: "Konuşmaya Katıl",
            forwardRep: "Yönlendir",
            leaveChat: "Görüşmeden Ayrıl",
            endChat: "Görüşmeyi Sonlandır",
            translatedTextDescription: "Amazon  bu mesajın {from} -> {to} çevirisini yapmıştır.",
            autoTranslate: "Otomatik Tercüme",
            translateThisMessage: "Bu mesajı çevir",
            autoTranslateDetectedDesc:
                "Ziyaretçi {visitorLanguage} dilinde konuşuyor. Otomatik Tercümeyi Etkinleştirmek İçin Buraya Tıklayın",
            on: "Açık",
            off: "Kapalı",
            copy: "Kopyala",
            prevChats: "Önceki Konuşmalar",
            noShortCut: "Kısayol yok",
            leaveChartConfirm: "Konuşmadan ayrılmak istediğinize emin misiniz?",
            endChatConfirm: "Bu görüşmeyi sonlandırmak istiyor musunuz?",
            chatBar: "Konuşma Gösterge Paneli",
            endConversation: "Görüşmeyi Sonlandır",
            onlyOneRep: "Bu konuşmadaki tek temsilci sizsiniz!",
            chatList: "Konuşma Listesi",
            unreadTitle: "Okunmamış",
            visitorLeftTitle: "Ziyaretci Çıkış",
            activeChatTitle: "Aktif Konuşma",
            autoAssignedTitle: "Otomatik Atanmış",
            watchModeTitle: "İzleme Modu",
            lostChat: "Temsilci Bağlantısı Kopmuş",
            repLostConn: "Temsilci konuşmadan koptu ise konuşma arkaplanı pembe olur.",
            chatWidthDelay: "Gecikmeye Düşen Chat",
            repChatWidthDelay:
                "Sistemde aktif temsilci olmadığında veya yoğunluktan dolayı ziyaretçi alınmadığında konuşma arka planı yeşil rengi olur. ",
            unreadMsg: "Okunmamış Mesaj Varsa  arkaplan açık mavi olur.",
            visitorLeftChat: "Ziyaretçi konuşmadan ayrıldı ise arkaplan koyu gri olur.",
            activeChatMsg: "Konuşma aktif ise arkaplan yeşil olur",
            autoAssignMsg: "Otomatik atama ile atandı ve konuşmaya daha bakılmadı ise arkaplan hardal olur",
            watchModeMsg: "İzleme modunda açıldı ise arkaplan kırmızı olur",
            online: "Çevrimiçi",
            beRightBack: "Hemen Dönecek",
            away: "Hemen Dönecek",
            busy: "Meşgul",
            offline: "Çevrimdışı",
            logout: "Çıkış Yap",
            forWindows: "Windows İçin",
            forMac: "Mac İçin",
            nextChatFromActive: "Aktif konuşmadan bir sonraki konuşmaya geç",
            previousChatFromActive: "Aktif konuşmadan bir önceki konuşmaya geç",
            hideActiveChat: "Aktif konuşmayı gizle",
            closeActiveChat: "Aktif konuşmayı bitir",
            firsthiddenChat: "En çok beklemiş müşterinin konuşmasına bağlan",
            firstChatWaiting: "Cevap bekleyen konuşmaya geçiş yap",
            previousOpenedChat: "Sıra farketmeksizin, bir önce açılan konuşmaya geçiş yap",
            hashHintMessage: "ile hashtag kısayollarını hızlıca girebilirsiniz",
            pmHintMessage: "İle Gizli mesaj Gönderebilirsiniz (Örnek pm: selam)",
            vtippyTicketNotification: "Size gelen her yeni ticket için bildirim ayarları",
            newTicketSound: "Yeni Ticket",
            vtippyDepartmentNotification: "Departman konuşmasından gelen mesajlar için bildirim ayarları ",
            vtippyGroupNotification: "Oluşturulan gruplardan gelen mesajlar için bildirim ayarları ",
            vtippyAnnouncemenNotification: "Yeni gelen duyurular için bildirim ayarları",
            billingAddress: "Fatura Adresi",
            addNewAddress: "Yeni Adres Ekle",
            adressTitle: "Adres Başlığı",
            address: "Adres",
            languageSelection: "Dil Seçimi",
            shortcutHintMessage: "Kısayol mesajları ile daha hızlı mesajlar iletebileceğinizi biliyormusunuz. ",
            switchBetweenConversations: "kısayolları ile chatler arası hızlıca geçiş yapabileceğini biliyor musun?",
            atNameHintMessage: "ile ziyaretçinin adını hızlıca yazabileceğini biliyor musun?",
            dndHintMessage: "Sürükle bırak ile dosya upload edebilirsiniz.",
            pasteFile: "ile dosya gönderebilirsiniz.",
            atEmailHintMessage: "ile ziyaretçinin E-postasını hızlıca yazabileceğini biliyor musun?",
            pastePlainText: "Kopyaladığınız ifadeyi stilsiz düz metin olarak yapıştırır.",
            pressAndTalk: "Basarak konuşmanı yazıya dökebilirsin",
            historyDetails: "Geçmiş Detayları",
            chat: "Konuşma",
            chatNotFound: "Konuşma Bulunamadı.",
            dataNotFound: "Data bulunamadı",
            visitorInfo: "Ziyaretçi Bilgileri",
            timeSpent: "Geçen Süre",
            noActiveVisitors: "Aktif ziyaretçi yok",
            select: "Seç",
            fullname: "Tam Ad",
            text: "Metin",
            numeric: "Sayısal",
            phone: "Telefon",
            optionsPlaceholder: "Seçenek değeri",
            selectField: "Açılır Menü eklemek istiyorsanız tıklayın",
            fullnameField: "Tam Ad alanı eklemek istiyorsanız tıklayın.",
            textField: "Metin alanı eklemek istiyorsanız tıklayın.",
            labelField: "Açıklama alanı eklemek istiyorsanız tıklayın.",
            numericField: "Sayısal alanı eklemek istiyorsanız tıklayın.",
            phoneField: "Telefon alanı eklemek istiyorsanız tıklayın.",
            departmentField: "Bölüm eklemek istiyorsanız tıklayın",
            emailField: "Email alanı eklemek istiyorsanız tıklayın.",
            visible: "Görünür",
            required: "Zorunluluk",
            label: "Açıklama",
            totalConnected: "Konuşma Sayısı",
            missedChat: "Kaçan Konuşma Sayısı",
            workTime: "Mesai Süresi",
            closedChatCount: "Kapatılan Konuşmalar",
            activeConvo: "Aktif konuşulan",
            notAnswered: "Henüz cevap verilmemiş",
            delayedConvo: "Gecikmiş Konuşmalar",
            leavingRep: "Ayrılan temsilci",
            staffRate: "Personel Çalışma Oranı",
            customLoginAlert: "Formunuzda  en az 1 adet görünür alan olmak zorundadır.",
            atLeastOneLanguage: "En az bir dil açıklaması olmak zorundadır.",
            requiredField: "Bu alan zorunludur.",
            notRequiredField: "Bu alan zorunlu değildir.",
            visibleField: "Bu alan formda gözükür.",
            notVisibleField: "Bu alan formda gözükmez.",
            connectServer: "Sunucuya bağlısınız",
            disconnectServer: "Sunucu ile bağlantınız kesildi",
            liveChatOff: "Canlı Destek Kapalı",
            visitorScreen: "Ziyaretçi Ekranı",
            viewOnTheSite: "Sayfada Görüntüle",
            viewOnTheSiteTippy: "Yaptığınız Değişikliklerin Nasıl Durduğunu Görmek İçin Tıklayın.",
            showHint: "İpucu Göster",
            dontShowHint: "İpucu Gösterme",
            liveChatOn: "Canlı Destek Açık",
            nightModeOff: "Gece Modu Kapalı",
            nightModeOn: "Gece Modu Açık",
            edit: "Düzenle",
            deleteField: "Sil",
            arrow_upward: "Yukarı Taşı",
            arrow_downward: "Aşağı Taşı",
            doubleClickEdit: "Düzenlemek için iki kere tıklayın veya düzenle butonuna basın.",
            newCatalogCategory: "Yeni Katalog Kategorisi",
            childCreate: "Alt içerik oluşturmak için tıklayın",
            updateCatalogCategoryFrom: "Katalog Kategori Güncelle Formu",
            newCatalogCategoryFrom: "Yeni Katalog Kategori Formu",
            catalogMenu: "Menü",
            catalogContent: "İçerik",
            catalogCategoryName: "Katalog kategori adı",
            newCatalogContentFrom: "Yeni Katalog İçerik Formu",
            catalogContentName: "Katalog içerik adı",
            catalogCategorySaved: "Katalog katagorisi kaydedildi",
            catalogCategoryDeleted: "Katalog kategorisi silindi.",
            catalogCategoryRate: "İçerik Puanı",
            catalogContentFeature: "Katalog Özelliği",
            vtipyAudioLevel: "Bildirim seslerini kısmanız veya açmanız için kullanılır.",
            vtipyOrganizationName: "Organizasyon adını değiştirip güncelleyebilirsiniz.",
            vtipyBrandVisibility: "Supsis etiketinin, chat balonunda gösterip gösterilmeyeği ayarıdır.",
            vtipyBrandVisibilityForced: "Yalnızca ProPlan kullanıcıları değiştirebilir!!",
            vtipyClientDefault: "Temsilci sayfası dilini buradan değiştirebilirsiniz.",
            vtipyCustomerClientDefault: "Müşteri(Chat) sayfasının dilini buradan değiştirebilirsiniz.",
            vtipyVisitorPreferredLang: "Müşteri(Chat) sayfasında konuşma dilini seçebilir.",
            vtipyCustomerClientLanguageDetect: "Müşteri(Chat) sayfasının dilini otomatik olarak algılıyabilirsiniz.",
            vtipySelectTopic:
                "Müşterilerin seçtiği konulara göre departmanlara(konulara) yönlendirmek zorunlu hali gelir.",
            vtipyAutoCallTransfer: "Müsait olan temsilcilere, bekleyen görüşmeleri otomatik atar.",
            vtipyCustomerTyping: "Müşterinin chat ekranında yazdıklarını, temsilci chat ekranında görmenizi sağlar.",
            vtipyAgentTyping: "Temsilcinin yazma durumunu müşteri baloncuğunda gösterir.",
            vtipyQueueNumberVisibleFeature:
                "Temsilcilerin yoğun oldukları zamanda, bağlanmak isteyen müşterilere kaçıncı sırada olduklarını gösterir.",
            vtipyPrivateChatEnabled: "Temsilciler arası konuşma panelini gösterir.",
            vtipyDelayedTalkTime:
                'Bu süre zarfında konuşmaya hiçbir temsilci bağlanmadığında "Geciken Konuşma" olarak etiketlenir.',
            vtipyOfflineMode: "Sistemi çevrim dışı moda almanızı sağlar.",
            vtipyAutoAssignLimit: "Temsilciye otomatik kaç tane müşteri(chat) atama yapılacağını belirler.",
            vtipyCustomerDownTimeWhenRepExit: "Temsilci çıkış yaptığında müşteri boşa düşme süresi(sn.)",
            tippyDisconnectTime: "Müşteri bağlantısı koptuktan sonra chatin kapanma süresi (sn).",
            changeSettings: "Global Ayarı Değiştirin",
            totalBg: "TOPLAM SOHBETLER",
            activeBg: "SANA ATANMIŞ",
            watchBg: "İZLEME",
            waitingBg: "KUYRUKTAKİLER",
            lateBg: "ÇOK BEKLEYENLER",
            freeBg: "BOŞTA OLANLAR",
            maxCapacityBg: "MAKS KAPASITE",
            addNewSettings: "Yeni Bir Global Ayar Ekleyin",
            darkMode: "Gece Modu",
            clientDefault: "Panel varsayılan dil",
            customerClientDefault: "Müşteri kısmı varsayılan dil",
            customerClientLanguageDetect: "Müşteri kısmı dili otomatik algıla",
            visitorPreferredLang: "Müşteri konuşma dilini seçsin",
            preferredThemeColor: "Konuşma Ekranı Tema Tercihi",
            detail: "İncele",
            langSetting: "Dil Ayarı",
            supportUs: "Bize Ulaşın (Canlı Destek)",
            changeLang: "Dil Değiştir",
            fontSizeSetting: "Ekran Büyütme Ayarı",
            changeLangDesc: "Uygulama dilini {code} olarak ayarlar.",
            trLang: "Türkçe",
            enLang: "İngilizce",
            fieldRequired: "{field} alanı gereklidir.",
            selectALanguage: "Bir Dil Seçiniz",
            selectATheme: "Bir Tema Seçiniz",
            responseForm: "Cevap Formu",
            clientRequestInfo: "Müşteri Talep Bilgisi",
            createdDate: "Oluşturma Tarihi",
            descMessage: "Mesaj",
            new: "Yeni",
            lastLoginPlatform: "Platform",
            requiredFieldField: "Bu alan zorunludur",
            catalogCategoryMenu: "Katalog Kategori menüsü ekle",
            catalogCategoryLeaf: "Katalog kategorisi alt menüsü ekle",
            selectAllPermission: "Tümünü Seç",
            catalogCategories: "Katalog",
            copiedClipboard: "Panoya kopyalandı",
            organizationLogo: "Şirket Logosu",
            changePlan: "Plan Değiştir",
            close: "Kapat",
            vtipyUploadLogo:
                "Şirket logonuzu bu alandan yükleyerek müşteri maillerinde ve müşteri sayfasında kendi logonuzu kullanabilirsiniz.",
            tagName: "Etiket Adı",
            tagDescription: "Etiket Açıklaması",
            tagColor: "Etiket Rengi",
            userInformations: "Kullanıcı Bilgileri",
            incomingChat: "Gelen Chat",
            support: "Destek",
            team: "Takım",
            groups: "Gruplar",
            newConversationStarted: "Yeni görüşme başladı",
            allHistoryLoaded: "Tüm geçmiş yüklendi",
            chatCreator: "Sohbet Oluşturan",
            enterGroupTitle: "Grup başlığı girin",
            requiredTitle: "Başlık alanı boş geçilemez",
            requiredChannel: "Kanal adı boş geçilemez",
            next: "Sonraki",
            add: "Ekle",
            selectPeople: "Kişileri seçin",
            textLimitAlertMessage:
                "WhatsApp'ta karakter sınırlaması 19 karakterdir ve bu sınırdan sonrası görüntülenmez. Ancak web üzerinde, 19 karakter sınırını aşan metinler bir alt satıra otomatik olarak geçirilir ve görüntülenir.",
        },
        telegram: {
            typeInTelegramToken: "Telegram Token'i Girin",
            token: "Token",
            telegram: "Telegram",
            telegramTokenTitle: "Telegram Supsis Entegrasyonu",
            telegramAlertForm: "Telegram bot token adresinden alabilirsiniz",
            telegramAlertTitle: "Jetonu gerçekten silmek istiyor musunuz?",
            telegramAlertText: "Belirteç kalıcı olarak kaybolacak!",
        },
        wp: {
            sendAgain: "Tekrar Gönder",
            shippingDetails: "Gönderim Detayları",
            whatsapp: "Whatsapp",
            importContactsFromFile: "Kişileri Dosyadan İçe Aktar",
            chatStartingWait: "Konuşma başlatılıyor , Lütfen Bekleyiniz",
            chatStarted: "Konuşma başlatıldı",
            chatNotStarted: "Konuşma başlatılamadı",
            contactSelected: "kişi seçildi",
            startChatWithAnyNo: "Herhangi Bir Numara ile Sohbete Başlayın",
            toLittleChar: "Eksik rakam girildi !",
            typeInANumberDesc: "Sohbet başlatmak için numarayı yazın",
            wpPlusAndLicenceRequired: "Whatsapp Plus Planı ve Lisansı Gereklidir.",
            wpPlusAndLicenceRequiredDesc:
                "Rehberinizde kayıtlı olmayan numaralara sohbet başlatabilmeniz için whatsapp planınızı yükseltmeli ve bir lisans almalısınız.",
            agreement: "Sözleşme",
            purchase: "Satın Alma",
            activating: "Whatsapp Hizmeti Etkinleştirme",
            authenticating: "QR Kodu Doğrulama",
            ready: "Tamamla",
            activationTitle: "Supsis Üzerinde Whatsapp Entegrasyonu Etkinleştirme:",
            wpIntegrationInstruction1: "Whatsapp'ı Telefonunuzda Açın",
            wpIntegrationInstruction2: "Menü'yü yada Ayarlar'ı seçin ve Bağlı Cihazlar'a tıklayın. ",
            wpIntegrationInstruction3: "Kodu taramak için telefonunuzu bu ekrana doğrultun",
            qrGeneratingWait: "QR Kodu Oluşturuluyor lütfen bekleyin...",
            pleaseContinueToWaitUntilCompleted:
                "QR Kodu doğrulandıktan sonra otomatik olarak tamamlandı alanına geçecektir. Lütfen bekleyiniz...",
            authenticatingWait: "Oturum açılıyor, lütfen bekleyin...",

            enableFeature: "Whatsapp Özelliğini Etkinleştir",
            unsubscribeWpInetgration: "Whatsapp Entegrasyonu aboneliğini sonlandır",
            unsubscribeIGIntegration: "Instagram Entegrasyonu aboneliğini sonlandır",
            wpBack: "Geri",
            terminatelWpInetgration:
                "Abonelikten çık butonuna tıkladığınızda whatsapp entegrasyonunuz sonlandırılacaktır.",
            cancelWpInetgration: "Whatsapp entegrasyonunu iptal etmek istiyor musunuz?",
            terminatelIGIntegration:
                "Abonelikten çık butonuna tıkladığınızda instagram entegrasyonunuz sonlandırılacaktır.",
            cancelIGIntgeration: "Instagram entegrasyonunu iptal etmek istiyor musunuz?",
            startChatWp: "Sohbet Başlat",
            readAndAgree: "Okudu onaylıyorum",
            subscribe: "Abone Ol",
            subscribed: "Abone olundu",
            toEnableWpDescription: "Whatsapp Özelliklerini etkinleştirmek için aşağıdaki butona tıklayın.",
            waitForWpActivationDescription:
                "Whatsapp hesap hizmetiniz aktif hale geliyor. Lütfen bekleyin. Yaklaşık 30 saniye sürer.",
            greatWpActivatedDescription: "Whatsapp hesap hizmetiniz etkinleştirildi.",
            unsubscribe: "Abonelikten Çık",
            planDetails: "Özellikler",
            sendReceiveMessage: "Mesaj Gönderme & Alma ",
            sendReceiveImage: "Resim Gönderme & Alma ",
            sendReceiveAudio: "Ses Kaydı Gönderme & Alma ",
            sendReceiveGif: "GIF Gönderme & Alma",
            startChat: "Supsis'te Chat Başlatma",
            supsisFunctionality: "Kullanışlı Supsis Sohbet Özelliği",
            onePhoneMultiAgent: "Tek Telefon ile Birden Fazla Temsilci",
            basicIntegration: "Uğraştırmayan Basit Entegrasyon",
            purchaseHeader: "Supsis-Whatsapp Entegrasyonu Satın Alma",
            wpServices: "Whatsapp Hizmeti",
            wpServicesIntegrationCompleted: "Whatsapp entegrasyonunuz tamamlandı. Artık kullanabilirsiniz.",
            purchasePaymentDescription:
                "Whatsapp Özelliği aydan aya faturalandırılır. Aboneliği kabul ettikten sonra whatsapp hizmetiniz aktif hale gelecektir.",
            wpIntegrationFeatures: "Whatsapp Entegrasyonu Özellikler",
            saveChanges: "Değişiklikleri Kaydet",
            contactList: "Kişi Listesi",
            broadcast: {
                broadcast: "Toplu Mesaj",
                detail: "Detay",
                customer: "Müşteri",
                phoneNumbers: "İrtibat Numaraları",
                showMore: "Daha Fazla Göster",
                showLess: "Daha Az Göster",
                groupName: "Grup İsmi",
                messages: "Mesajlar",
                status: "Durum",
                usageCost: "Kullanım Maliyeti",
                sendingTime: "Gönderme Zamanı",
                progress: "İlerleme",
                groupDetail: "Grup Detayı",
                messagesPerContact: "Kişi Başına Mesaj Sayısı",
                successRatio: "Başarı Oranı",
                message: "Mesaj",
            },
            messages: "Mesajlar",
            broadcastRequests: "Toplu Mesaj İstekleri",
            customerGroups: "Müşteri Grupları",
            messageTemplates: "Mesaj Şablonları",
            plans: "Planlar",
            wpIntegrationRequired: "Whatsapp Entegrasyonu Gerekli",
            wpRequiredIntegrationDescription:
                "Üzgünüz, ziyaret ettiğiniz sayfa whatsapp'ınızı entegre ettiğinizde aktif hale gelecektir.",
            integrateWp: "Hadi, Whatsapp'ı Entegre Edin",
            active: "Aktif",
            archived: "Arşivlenmiş",
            createBroadcastMessage: "Toplu Mesaj Oluştur",
            title: "Başlık",
            description: "Açıklama",
            createdAt: "Oluşturma Tarihi",
            numbers: "Numaralar",
            actions: "Hareketler",
            action: "Aksiyon",
            createCustomerGroup: "Özel bir müşteri grubu oluşturun",
            search: "Aramaya Başla",
            name: "İSİM",
            contacts: "Kişiler",
            noContactFound: "Kişi Bulunamadı",
            broadcastTitle: "Toplu mesajınıza bir başlık yazın.",
            recipients: "Alıcılar",
            selectRecipients: "Alıcıları Seçin",
            writeYourMessage: "Mesajınızı yazın.",
            schedule: "Planla",
            scheduleNowOrLater: "Şimdi veya daha sonra planlayın.",
            summary: "Özet",
            cancel: "İptal",
            send: "Gönder",
            sending: "Gönderiliyor",
            deleteCustomerGroup: "Bu müşteri grubunu silmek istediğinizden emin misiniz? {name}",
            customerGroupDeleting: "Müşteri grubu siliniyor ...",
            customerGroupDeletingSuccess: "Müşteri grubu başarıyla silindi",
            customerGroupDeletingError: "Müşteri grubu silinirken hata oluştu",
            wpPlusRequired: "Whatsapp Plus Planı Gerekli.",
            broadcastMessageArchived: "Toplu mesaj grubu arşivlendi",
            broadcastMessageNotArchived: "Toplu mesaj grubu arşivlenmedi",
            groupNameSearch: "Müşteri Grubu Adını Yazın",
            groupNameDesc: "Müşteri grubu adı müşteri gruplarınızı tanımlayın",
            save: "Kaydet",
            number: "NUMARA",
            addColumn: "Sütun Ekle",
            addColumnDesc: "Tabloya bir sütun ekleyin",
            addNewContact: "Yeni Kişi Ekle",
            addNewContactDesc: "Tabloya kişi ekleme",
            importFile: "Dosyadan İçe Aktar",
            importFileDesc: "Kişileri excel veya csv dosyasından içe aktarın",
            contactAdded: "Kişi eklendi",
            updateCustomerGroup: "Müşteri grubu güncelleniyor...",
            updateCustomerGroupSuccess: "Müşteri grubu başarıyla güncellendi",
            sendBroadcastMessage: "Toplu Mesaj Gönder",
            columnName: "Sütun Adı",
            columnType: "Sütun Tipi",
            defaultValue: "Varsayılan Değer",
            setDefaultValue: "Varsayılan değeri mevcut kişilere ayarla",
            age: "Yaş",
            location: "Konum",
            gender: "Cinsiyet",
            selectContactFile: "Kişilerin Olduğu Dosyayı Seçin",
            selectContactCsvOrExcel: "Bir CSV veya EXCEL dosyası seçin.",
            importConfiguration: "Dosyanızı içe Aktarın",
            customizeFile: "Eklediğiniz kişiler dosyasını düzenleyin.",
            sendMessageTo: "Mesajı kime göndermek istiyorsunuz?",
            allContact: "Tüm Kişiler",
            messageTypes: "Mesaj Tipleri",
            whenSendMessage: "Mesajı ne zaman göndermek istiyorsunuz?",
            instantlyRightNow: "Hemen Şimdi",
            completed: "Tamamlandı",
            scheduleFuture: "Gelecekteki bir tarih için zamanlama",
            messageDesc: "Mesajınız anında tüm alıcılara gönderilecektir",
            messageSendAt: "Mesajınız adresindeki tüm alıcılara şu tarihte iletilecektir: ",
            estimatedPrice: "Tahmini Fiyat",
            estimatedTime: "Tahmini Süre",
            now: "Şimdi",
            tenMinute: "10 Dakika",
            cancelled: "İptal Edildi",
            failed: "Başarısız",
            running: "Devam Ediyor",
            queued: "Sıraya Alındı",
            scheduled: "Planlanmış",
            noNumberAdded: "Numara Eklenmedi",
            csvOrExcelFile: "CSV veya Excel Dosyası",
            broadcastMessagesToContactFile: "Kişi Listesine Toplu Mesaj Gönderme",
            broadcastMessageTemplates: "Toplu Mesaj Şablonları",
            messageFlow: "Mesaj Akışı",
            textMessageSupport: "Kısa Mesaj Desteği",
            imageMessageSupport: "Resimli Mesaj Desteği",
            spamPreventions: "Spam Mesaj Önleme",
            includesAllBasicPlans: "Whatsapp Paketindeki Tüm Özellikleri İçerir",
            chatbotIntegration: "Chatbot Entegrasyonu",
            messageToNewNumbers: "Yeni Numaralara Mesaj Gönderme",
            broadcastMessageToEveryone: "Herkese Toplu Mesaj Gönderme",
            personalizedBroadcastMessage: "Kişiselleştirilebilir Toplu Mesajlar",
            customerGroupSegmentation: "Müşteri Grubu Segmentasyonu",
            scheduleBroadcastMessage: "Toplu Mesaj Planlama",
            locationMessageSupport: "Konum Mesajı Desteği",
            advancedSpamPreventions: "Gelişmiş Spam Mesaj Önleme",
            whatsappPlans: "Whatsapp Planları",
            selectBestPlan: "Sana uygun planı seç",
            comingSoon: "Çok Yakında...",
            selectFile: "Bir dosya seçin",
            created: "Oluşturuldu",
            message: "Mesaj",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            instagramComments: "Instagram Yorumları",
            messengerComments: "Messenger Yorumları",
            trendyolComments: "Trendyol Yorumları",
            ticketSelection:"Ticket Seçildi",
            bulkClose:"Toplu Kapat",
            igComment: "Instagram Yorum",
            igMentioned: "Instagram Bahsetme",
            incomingReqChatbot: "Chatbot ile Gelen Talepler",
            incomingReqWebForm: "Web Formdan Gelen Talepler",
            incomingReqAutomation: "Otomasyondan Gelen Talepler",
            thisPersonEmailAnswered: "Bu kişi e-posta ile cevaplanmak istiyor",
            thisPersonWpAnswered: "Bu kişi WhatsApp üzerinden cevap bekliyor.",
            clickStartWpChat: "WhatsApp chat başlatmak için tıklayınız",
            requestProgress: "Talep İlerleme Durumu",
            requestMessage: "Talep Mesajı",
            clickAddMailAddress: "Mail adresi eklemek için tıklayınız",
            sendReplyCloseTicket: "Cevap Gönder ve Ticket'ı Kapat",
            closeTicket: "Ticket'ı Kapat",
            selectEmailSender: "E-posta Göndericisini Seçin",
            withEmailWillNotRecievice: "Bu mail adresi ile gönderimlerde maile verilen yanıtları alamazsınız!",
            deleteCommentAndClose: "Yorumu sil ve kapat",
            sendReplyAndClose: "Yanıtı Gönder ve Kapat",
            startChatWp: "WhatsApp Chat Başlat",
            sureWantToDeleteTicket: "adet bileti silmek istediğinizden emin misiniz?",
            bulkDeleteConfirmation: "Toplu Silme Onayı",
            selectedTicketSucsDelete: "Seçili biletler başarıyla silindi.",
            thereErrorDeletingTicket: "Biletler silinirken bir hata oluştu.",
            deleteConfirm: "Silme Onayı",
            sureDeleteTicket: "Bu bileti silmek istediğinizden emin misiniz?",
            ticketSucsDelete: "Bilet başarıyla silindi.",
            represantiveSucsAppoint: "Temsilci başarıyla atandı.",
            ticketClosedSucs: "Ticket başarıyla kapatıldı.",
            ticketCloureFailed: "Ticket kapatma işlemi başarısız oldu.",
            unprocessed: "İşlenmemişler",
            pleaseSelectValidStatus: "Lütfen geçerli bir durum seçin.",
            ticketStatusBeenUpdatd: "Bilet Durumu güncellendi.",
            doYouWantCloseTicket: "Ticket'ı kapatmak istiyor musunuz?",
            ticketWillMarkedClosed: "Ticket kapandı olarak işaretlenecek ve arşivlenecek.",
            errorUpdatingTicketFailed: "Ticket Status güncellenirken bir hata oluştu.",
            igCommentDeleteIgPost: "Instagram yorumu IG gönderinizden silinmiştir.",
            igCommentHideChange: "Instagram yorum gizleme durumu değiştirildi.",
            pleaseChooseRepresent: "Lütfen bir temsilci seçin.",
            selectedTicketSucsDelegated: "Seçili biletlere temsilci başarıyla atandı.",
            errorOccuredDuringDelegation: "Temsilci atama işlemi sırasında bir hata oluştu.",
            bulkTicketClosing: "Toplu Bilet Kapatma",
            sureWantCloseTicket: "adet bileti kapatmak istediğinizden emin misiniz?",
            selectedTicketSucsClosed: "Seçili biletler başarıyla kapatıldı.",
            thereErrorClosingTicket: "Biletler kapatılırken bir hata oluştu.",
            changeFilterTicketPage: "Biletler sayfasındaki filtreleri değiştirme",
            nameOfFilter: "Filtrenin adı.",
            filterValue: "Filtre değeri",
            deletesSelectedTickets: "Seçilen biletleri siler",
            idTicketBeDelete:
                "Silinecek biletlerin id'leri.  (seçilen bilet kimlikleri veya listelenen tüm bilet kimlikleri)",
            assignsAgentSelectedTickets: "Seçilen biletlere bir temsilci atar",
            idTicketBeAssigned:
                "Atanacak biletlerin id'leri. (seçilen bilet kimlikleri veya listelenen tüm bilet kimlikleri)",
            idAgentAssigned: "Atanacak temsilcinin kimliği",
            changesStatusSelectedTicket: "Seçilen biletlerin durumunu değiştirir",
            idTicketWhoseStatus:
                "Durumu değiştirilecek biletlerin id'leri. (seçilen bilet kimlikleri veya listelenen tüm bilet kimlikleri)",
            newStatus: "Yeni Durum",
            selectedTicketsSucsUpdated: "Seçili biletlerin durumu başarıyla güncellendi.",
            errorWhileChangingStatus: "Biletlerin durumu değiştirilirken bir hata oluştu.",
            thisPageVoiceAssistant: "Bu Sayfada Sesli Asistanı Var",
            hello: "Merhaba!",
            voiceAssistantContent: ` Bu sayfada size yardımcı olacak bir <strong>Yapay Zeka Asistanı</strong> olduğunu biliyor muydun?.
            Asistanı kullanmak için aşağıdaki yöntemleri deneyebilirsiniz:`,
            commandHoldingDownTheKey: "tuş kombinasyonuna basılı tutup konuşarak komut verebilirsiniz.",
            topRightContent: "Sağ üst köşedeki",
            clickOnTheIcon: "simgesine tıklayarak asistanı başlatabilirsiniz.",
            sampleVoiceCommands: "Örnek Sesli Komutlar:",
            showMyTickets: "Benim ticketlarımı göster",
            showMeZeynepsOpenTicket: "Bugünkü Zeynep'in açık ticketlarını göster.",
            deleteTicketsScreen: "Ekrandaki ticketları sil",
            assigntLastTicketAli: "Sonuncu ticket'ı Ali'ye ata.",
            changeStatusAllTicket: "Tüm ticketların durumunu yapıldı olarak değiştir.",
            setStatusTicketsScreen: "Ekrandaki ticketların durumları ...... olarak ayarla.",
            assigntUserTicketScreen: "Ekrandaki ticketlara .... kullanıcısına ata.",
            assigntFirstTicket: "İlk ticket'ı bana ata.",
            showIgTickets: "Geçen ayki instagram ticketlarını göster.",
            makeChoice: "Seçim Yap",
            makeAssignment: "Atama Yap",

            tickets: "Ticketlar",
            instagramTickets: "İnstagram Ticketları",
            facebookTickets: "Facebook Ticketları",
            trendyolTickets: "Trendyol Ticketlerı",
            automationTickets: "Otomasyon Ticketlerı",
            supsisFormTickets: "Supsis Form Ticketları",
            columnSettings: "Kolon Ayarları",
            ticketField: "Ticket Alanı",
            contactPropertyFields: "Mülkiyet Alanlarına Ulaşın",
            ticketFilterList: {
                archivedRequests: "Arşivlenmiş Talepler",
                comingFromFacebook: "Facebook dan Gelenler",
                comingFromInstagram: "Instagram'dan Gelenler",
                unassignedOpenRequests: "Atanmamış Açık Talepler",
                openRequests: "Açık Talepler",
                requestsOpenedThisWeek: "Bu Hafta Açılan Talepler",
                specialList: "Özel Liste",
                creationDate: "Oluşturulma Tarihi",
                supsisFromTheForm: "Supsis Formdan Gelenler",
                fromTrendyol: "Trendyoldan Gelenler",
                comesWithAutomation: "Otomasyondan Gelenler",
                label: "Etiket",
                status: "Durum",
                subject: "Konu",
                email: "E-Posta",
                name: "İsim",
                phone: "Telefon",
                type: "Tür",
                assignedUser: "Atanan Kullanıcı",
            },
            appointingRepresentative: "Temsilci ata",
            ticketTagFilter: "Ticket Konusu Filtre Etiketi",
            ticketEmails: "Yönlendirelecek E-Posta Listesi",
            save: "Kaydet",
            delete: "Sil",
            transactions: "İşlemler",
            noEmailTicketNotifications: "Ticket Eposta  Yönlendirme Kaydı Bulunamadı",
            emailIsNotValid: "Eposta Adresi Geçersiz",
            emailNotificationDeleted: "Ticket Yönlendirme Kaydı Silindi",
            emailNotificationDeleteError: "Ticket Yönlendirme Kaydı Silinemedi!!",
            tagFilterRequired:
                "Ticket Konusu Filtre Etiketi Gereklidir. Tüm ticket'lar için * (wildcard) etiketini kullanabilirsiniz!",
            emailsRequired: "Ticket Yönlendirmesi için en az 1 Eposta adresi girilmelidir",
            emailNotificationCreated: "Ticket Yönlendirme Kaydı Oluşturuldu",
            emailNotificationCreateError: "Ticket Yönlendirme Kaydı Oluşturulamadı!!",
            ticketForwarding: "Ticket E-posta Yönlendirme",
            ticketTagFilterDesc:
                "Ticket filtrelemek için chatbot tasarımda kullandığınız ticket konularını kullanır. Farklı bir etiket yazıp enter'a basıp ekleyebilirsinz. '*' etiketi seçerseniz tüm ticketları seçer",
            ticketEmailsDesc:
                "Ticket'ların yönlendireleceği eposta listesi. Sistemdeki temsilcilerin adresleri seçerek ekleyebilirsiniz. Sistem dışı  eposta/lar da ekleyebilirsiniz.",
            ticketList: "Ticket Yönlendirme Kuralları",
            ticketTagFilterPlaceHolder: "Ticket filtresi, hepsi için * seçiniz",
            ticketEmailsPlaceHolder: "Yönlendirme eposta listesi",
        },
        theme: {
            headerColor1: "Başlık (Sol)",
            headerColor1A: "Başlık Kısmı Renk/Saydamlık",
            headerColor2: "Başlık (Sağ)",
            headerColor2A: "Başlık Kısmı 2. Renk/Saydamlık",
            backgroundColor: "Arkaplan (Sol)",
            backgroundColorA: "Arkaplan 1. Renk/Saydamlık",
            backgroundColor2: "Arkaplan (Sağ)",
            backgroundColor2A: "Arkaplan 2. Renk/Saydamlık ",
            opacity: "Saydamlık",
            textColor: "Genel Metin Rengi",
            errorTheme: "Hata Rengi",
            bubbleBackground: "Temsilci balon rengi",
            bubbleVisitorBackground: "Müşteri balon rengi",
            bubbleBackgroundA: "Temsilci balon saydamlığı",
            bubbleVisitorBackgroundA: "Müşteri balon saydamlığı",
            bubbleText: "Temsilci konuşma rengi",
            bubbleVisitorText: "Müşteri konuşma rengi",
            textFormColor: "Form rengi",
            selectCustom: "Özel Tema Seç",
            font: "Font",
            headerColorSecond: "Başlık Üst Rengi",
            headerColorFirst: "Başlık Alt Rengi",
            backgroundColorFirst: "Arkaplan Üst Rengi",
            formColor: "Form Yazı Rengi",
            buttonColor: "Buton Rengi",
            backgroundColorSecond: "Arkaplan Alt Rengi",
            chatBotButtonText: "Chatbot Yazı Rengi",
            chatBotButtonColor: "Chatbot Buton Rengi",
        },
        billing: {
            invoiceSettings: "Fatura Ayarları",
            invoiceEmailAddress: "Fatura E-Posta Adresi",
            defaultRootEmail: "Varsayılan: Temel e-posta",
            popular: "Popüler",
            selectedPlan: "Seçilen Plan",
            editPlan: "Planı Düzenle",
            removePlan: "Planı Kaldır",
            showPlan: "Planı Göster",
            hiddenPlan: "Planı Gizle",
            contactSales: "Satışla İletişime Geç",
            showLess: "Daha az göster",
            more: "Daha Fazla",
            selectTransactionType: "İşlem Tipi Seçiniz",
            walletLogs: "Cüzdan Kayıtları",
            addBalance: "Bakiye Ekle",
            availableBalance: "Kullanılabilir Bakiye",
            appsumoPack: "Appsumo Packet",
            updatePlan: "Planı Güncelle",
            createPlan: "Plan Oluştur",
            freePack: "Ücretsiz Plan",
            instantFee: "Anında Ücret Alınacaktır",
            planSequence: "Plan Sırası",
            requiredCodes: "Gerekli Kod Sayısı",
            subHeading: "Alt Başlık",
            featureKey: "Özellik Anahtarı",
            customerKey: "Müşteri Anahtarı",
            monthlyPrice: "Aylık Fiyat",
            monthlyNonDiscounted: "Aylık İndirimsiz Fiyat (Fonksiyonel Olmayan Ekran)",
            twoYearDiscount: "2 Yıllık İndirim",
            yearDisccount: "Yıllık İndirim",
            sixMonthDiscount: "6 Ay",
            threeMonthDiscount: "3 Ay",
            features: "Özellikler",
            sessionCount: "Oturum Sayısı",
            subType: "Abonelik Türü",
            skipTrialVersion: "Deneme Sürümünü Atla",
            skipTrialVersionDesc:
                "Deneme sürümünü atlayabilir ve işletmeniz için uygun paketi seçerek devam edebilirsiniz. Deneme sürümünü atlarsanız, bu eylem geri alınamaz.",
            skipStep: "Bu Adımı Atla",
            switchToPay: "Ödemeye Geç",
            forward: "İleri",
            pleaseFillInCard: "Lütfen kart bilgilerini doldurun!",
            fillInTheBillingAddress: "Lütfen fatura adresi bilgilerini doldurun!",
            cardNumberWrong: "Kart Numarası Yanlış!",
            pleaseConfirmTheUser: "Lütfen kullanıcı sözleşmesini onaylayın.",
            pleaseCheckYourCard: "Lütfen kartınızı ve bilgilerinizi kontrol edin.",
            site: "Site",
            period: "Dönem",
            billStatus: "Fatura Durumu",
            totalPrice: "Toplam Fiyat + KDV",
            depositMoneyWallet: "Cüzdana Para Yatır",
            threeMonthly: "3 Aylık",
            sixMonthly: "6 Aylık",
            twoYearly: "2 Yıl",
            forever: "Sonsuza dek",
            extraPackage: "Ekstra Paket",
            teamPackage: "Ekip Paketleri",
            adventPackage: "Avantajlı Paketler",
            couponError: "Kupon kodu yanlış veya süresi dolmuş.",
            enterYourCard: "Lütfen Kredi Kartınızı girin",
            invalidCard: "Geçersiz kredi kartı, Ödeme Alınmadı",
            calculateThis: "Şunun için hesaplayın:",
            adventageousPackage: "Avantajlı paket indirimleri!",
            cupponApplied: "Kupon başarıyla uygulandı",
            subStart: "Abonelik Başlatıldı",
            subSuccessStart: "Aboneliğiniz başarıyla başlatıldı.",
            success: "Başarılı",
            succesDesc: "Abonelik başarıyla oluşturuldu.",
            successDesc: "Özelliğiniz başarıyla etkinleştirildi.",
            maxNumber: "Konuşulacak maksimum temsilci sayısı",
            currentAmountDetails: "Mevcut tutarın ayrıntıları",
            endOfMonthForecastDetails: "Ay sonu tahmin ayrıntıları",
            totalAmount: "Toplam Tutar",
            vatAmount: "KDV Tutarı (%20)",
            totalAmountIncludingVAT: "KDV Dahil Toplam Tutar",
            hideDetails: "Ayrıntıları Gizle",
            createInvoice: "Fatura Oluştur",
            reimbursementMade: "Geri Ödeme Yapıldı",
            invalidInvoice: "Geçersiz Fatura",
            balanceTopUp: "Whatsapp Bakiye Yükleme",
            paidSuccessfully: "Fatura başarıyla ödendi.",
            paymentFailed: "Fatura ödeme işlemi başarısız oldu.",
            areYouSurePaid: "Bu faturanın ödenmiş olarak işaretlenmesini istediğinizden emin misiniz?",
            invoiceMarkedPaid: "Fatura ödendi olarak işaretlendi.",
            invoiceMarkedFailed: "Bir hata oluştu ve fatura ödendi olarak işaretlenemedi.",
            areYouSureRefundInvoice: "Bu fatura için bir geri ödeme işlemi yapmak istediğinizden emin misiniz?",
            youMustFillInEmpty: "Tüm boş alanları doldurmalısınız.",
            createdNewInvoice: "Yeni fatura başarıyla oluşturuldu.",
            createdNewInvoiceFailed: "Fatura oluşturulurken bir hata oluştu.",
            invoiceUpdated: "Fatura tutarı başarıyla güncellendi.",
            invoiceUpdatedFailed: "Faturanın güncellenmesinde bir sorun oluştu.",
            plans: "Planlar",
            companyName: "Şirket Adı",
            company: "Şirket",
            person: "Kişi",
            invoiceAddressInfo: "Fatura Adres Bilgileri",
            idNo: "Türk Kimliği",
            taxOffice: "Vergi Dairesi",
            taxNumber: "Vergi Numarası",
            packageCanNotDownSupsis:
                "Paketinizin seviyesi düşürülemiyor. Paketinizi düşürmek için lütfen birkaç Temsilcinizi silin veya devre dışı bırakın.",
            packageCanNotDownWp:
                "Paketiniz düşürülemez. Paketinizi düşürmek için lütfen WhatsApp Kanallarınızdan birkaçını silin.",
            packageCanNotDownWPBussiness:
                "Paketiniz düşürülemez. Paketinizi düşürmek için lütfen WhatsApp İş Kanallarınızdan birkaçını silin.",
            chooseYourPlan: "Plan Seçin",
            numberOfRepresentatives: "Temsilci Sayısı",
            numberOfChannels: "Kanal Sayısı",
            wpNumberOfChannels: "WhatsApp Kanal Sayısı",
            igNumberOfChannels: "Instagram Kanal Sayısı",
            msNumberOfChannels: "Messenger Kanal Sayısı",
            cancelIt: "İptal et",
            activePlan: "Aktif Plan",
            activate: "Etkinleştir",
            noTransition: "Geçiş Yok",
            daysLater: "Günler Sonra",
            payBack: "Geri Öde",
            areYouSoreRefundInvoice: "Bu fatura için iade işlemi yapmak istediğinizden emin misiniz?",
            paid: "Ödendi",
            unPaid: "Ödenmemiş",
            editPrice: "Fiyatı Düzenle",
            payNow: "Şimdi Öde",
            youAreCurrentlyOnTrial:
                "Şu anda deneme süresindesiniz. Özel paketleri görmek için şimdi denemeyi atlayabilirsiniz.",
            youAreCurrentlyLimited:
                "Paketleriniz koşulsuz olduğu için şu anda sistem tarafından sınırlandırılmış durumdasınız.",
            youHaveOneRepresentative: "Bir temsilciniz var.",
            deactivateOrDeleteYourPiece:
                "Parça Temsilcinizi devre dışı bırakın veya silin ya da bir temsilci satın alın.",
            youHaveOneWhatsappQRChannel: "Bir Whatsapp QR kanalınız var.",
            deleteYourWhatsAppQR: "Whatsapp QR kanalınızı silin veya bir kanal satın alın.",
            youHaveAWhatsappBusiness: "Bir Whatsapp Business kanalınız var.",
            deleteYourWhatsapp: "Whatsapp Business kanalınızı silin veya bir kanal satın alın.",
            youHaveAnInstagram: "Bir Instagram kanalınız var.",
            deleteYourInstagram: "Instagram kanalınızı silin veya bir kanal satın alın.",
            youHaveAMessenger: "Bir Messenger kanalınız var.",
            deleteYourMessenger: "Messenger kanalınızı silin veya bir kanal satın alın.",
            additionalPackages: "Ek Paketler",
            availablePackages: "Mevcut Paketler",
            buyNow: "Satın Al",
            invoiceInformation: "Fatura Bilgileri",
            invoiceAddress: "Fatura Adresi",
            invoiceType: "Fatura Türü",
            review: "İncele",
            viewDetails: "Detayları Görüntle",
            addNewAddress: "Yeni Adres Ekle",
            enterYourBillingAddress: "Fatura Adresinizi Giriniz",
            selectPlan: "Plan Seç",
            paymentStatus: "Ödeme Durumu",
            amount: "Tutar",
            invoiceID: "Fatura ID",
            expected: "Bekleniyor..",
            currentAmount: "Mevcut Tutar",
            monthlyEstimatedAmount: "Ay Sonu Tahmini Tutar",
            creationDate: "Kesim Tarihi",
            invoiceStatus: "Fatura Durumu",
            invoicePeriod: "Fatura Dönemi",
            newPaymentMethod: "Yeni Ödeme Yöntemi",
            channelCount: "Kanal Sayısı",
            remainingTime: "Kalan Süre",
            chatbotLimit: "Chatbot Limiti",
            free: "Ücretsiz",
            maxChatbotSession: "Maksimum Chatbot Sayısı",
            buyIt: "Satın al",
            renewalDate: "Yenilenme Tarihi",
            monthly: "Aylık",
            yearly: "Yıllık",
            packagePeriod: "Paket Dönemi",
            packageType: "Paket Türü",
            packageManagement: "Paket Yönetimi",
            invoiceManagement: "Fatura Yönetimi",
            futureInvoice: "Gelecek Fatura",
            pastInvoices: "Geçmiş Faturalar",
            creditCard: "Kredi kartı",
            invoice: "Fatura",
            mustBeUpgradePlanForChatBot: "Chatbot özelliğini aktif edebilmeniz için Pro Plan'a geçmelisiniz!",
            incorrect: "Hatalı",
            cardInfo: "Kart Bilgisi",
            billingDetails: "Fatura Detayları",
            firstPreferredCard: "Birincil Kart Olarak Ayarla",
            primary: "Birincil",
            addCardIyzico:
                "Kayıtlı bir kartınız bulunmamaktadır. Aylık kullanım ücretlerinizi ödeyebilmeniz için kart eklemeniz gerekmektedir.Ödeme sistemi iyzico tarafından sağlanmaktadır.",
            billingPlanSettings: "Fatura & Ödeme Yöntemi",
            paymentMethod: "Ödeme Yöntemi",
            billingDate: "Fatura Tarihi",
            isPaid: "Ödeme Durumu",
            billingHistory: "Fatura Geçmişi",
            markPaid: "Ödendi Olarak İşaretle",
            paymentDate: "Ödeme Tarihi",
            pay: "Faturayı Öde",
            newInvoice: "Fatura Oluştur",
            updateBilling: "Fatura Adresini Değiştir",
            updateCard: "Kredi Kartını Değiştir",
            paymentBilling: "Ödeme Metodu & Fatura Adresi",
            price: "Fatura Tutarı",
            billingAddress: "Açık Adres",
            billingCity: "Şehir",
            billingCountry: "Ülke",
            contactName: "Faturalandırma Kişi Adı",
            expireMonth: "Son Kullanma T. Ay",
            expireYear: "Son Kullanma T. Yıl",
            cardNumber: "Kart Numarası",
            cardHolderName: "Kart Üzerindeki Ad Soyad",
            cardAlias: "Kart takma isim",
            identityNumber: "Kimlik/Vergi  Numarası",
            name: "Ad",
            surname: "Soyad",
            email: "Eposta",
            addCard: "Kart Ekle",
            update: "Güncelle",
            cancel: "Vazgeç",
            save: "Kaydet",
            saving: "Kaydediliyor",
            noInvoiceFound: "Fatura kaydı bulunamadı",
            year: "Yıl",
            updating: "Güncelleniyor",
            newInvoiceForm: "Yeni Fatura Oluşturma Formu",
            error: "Hata",
            transactions: "İşlemler",
            paymentMethodAdded: "Ödeme yöntemi başarıyla eklendi",
            paymentMethodAddError: "Ödeme yöntemi eklenemedi, Hata oluştu",
            creditCardChanged: "Kredi kartınız değiştirildi",
            errorOccurred: "Bir hata oluştu, tekrar deneyin.",
            billingDetailUpdated: "Fatura bilgileriniz güncellendi",
            invoiceCreated: "Fatura kaydı başarıyla oluşturuldu",
            paymentSuccess: "Faturanız başarıyla ödendi, teşekkür ederiz",
            paymentFail: "Faturanız ödenirken  hata oluştu daha sonra tekrar deneyiniz.",
            startWith: "{binNumber} ile başlayan {cardFamily} kart",
            billingAddressChanged: "Fatura Adresi bilgileri güncellendi ",
            hidePlan: "Planı Gizle",
            informationShopping:
                "Ödeme bilgileriniz, fatura bilgileriniz, kredi kartı bilgileriniz Shopify tarafından kontrol edilmektedir.",
            trialTimeInformation:
                "Deneme Sürümü bitmesine {dayCount} gün kaldı. Bu süre bitimine kadar ödeme yöntemi girmemeniz durumunda sistem tarafından otomatik olarak FREE Plan'a geçilir.",
            trialTimeInformationShort: "Son {dayCount} Gün",
            currentPlanLabel: "Mevcut Plan: {planName} Plan ({agentCount} Temsilci)",
            changeCancelPlan: "Planı Değiştir/İptal et",
            oneAgent: "Temsilci",
            agent: "Temsilci",
            yourCurrentPlan: "Mevcut Plan",
            month: "Ay",
            billedMonthToMonth: "(Aylık Faturalandırma)",
            selectAgentCount: "Temsilci Sayısı Seçin",
            selectFreePlan: "Free Plan Seçin",
            planDetails: "Plan Detayları",
            multiAgent: "(Çok Temsilci)",
            selectProPlan: "Pro Plan Seçin",
            foreverFree: "Süresiz Free",
            websiteIntegration: "Web Sitesi Entegrasyonu",
            websiteIntegrationUnlimited: "Web Sitesi Entegrasyonu",
            ChatBotUnlimited: "ChatBot",
            videoCallUnlimited: "Görüntülü Arama",
            multiAgentUpTo: "Çok Temsilcili ({agentCount} Temsilciye Kadar)",
            audioCallUnlimited: "Sesli Arama",
            screenSharingUnlimited: "Ekran Paylaşımı",
            fileTransferUnlimited: "Dosya Paylaşımı",
            autoChatAssignerUnlimited: "Otomatik Sohbet Ataması",
            multiLanguageTranslationUnlimited: "Otomatik Dil Çeviricisi",
            detailedReporting: "Raporlama",
            days30TrialsAvailable: "30-Günlük Ücretsiz Deneme",
            limitedArchiveLookupLastMo: "Sınırlı Arşiv Araması (Son {monthCount}-ay)",
            fullCustomizationUnlimited: "Özelleştirme",
            planUpdated: "Planınız başarıyla güncellendi.",
            planUpdating: "Planınız güncelleniyor...",
            planUpdatingDescription: "Güncelleme süresince lütfen bekleyin!",
            done: "Tamamlandı",
            freePlanUpdated: "Planınız Free Plan olarak güncellendi. (Maksimum Temsilci Sayısı: 1)",
            proPlanUpdated: "Planınız Pro Plan olarak güncellendi. (Maksimum Temsilci Sayısı: {proPlanUpdated}) ",
            canNotDwnGrade:
                "Planınız PRO {agentCountFirst} Temsilci sayısından {valNewPlnToUppr} {agentCountSecond} sayısına  düşürülemez!. Temsilci kredileriniz kullanımda. ",
            deleteWarning: " {valDif} Temsilci silmeniz gerekmektedir.",
            warnMessage: "Seçilen plan, mevcut plandan farklı olmalıdır",
            add: "Ekle",
            cancelYourPlan: "Planını İptal Et",
            upgradeYourPlan: "Planını Yükselt",
            downgradeYourPlan: "Planını Düşür",
            agree: "KABUL ET",
            disagree: "VAZGEÇ",

            invoices: "Faturalar",
            priceIntervals: "Tutar Aralığı",
            selectSiteAlias: "Site Adı Girin veya Seçin",
            selectPriceInterval: "Tutar Aralığı Girin veya Seçin",
            isRefunded: "Geri Ödeme Yapıldı mı?",
            invoiceId: "Fatura No",
            siteId: "Site No",
            createdDate: "Olurşturulma Tarihi",
            failCount: "Başarısız Çekim Denemesi Adeti",
            failDate: "Yapılmayan Ödemenin tarihi",
            Dashboard: "Gösterge Paneli",
            Agents: "Temsilciler",
            Integration: "Entegrasyon",
            Settings: "Ayarlar",
            Contacts: "Kişiler",
            Domain: "Domain",
            lastActivity: "Son Aktivite",
            basePrice: "Taban Fiyat",
            packagePrice: "Paket Fiyatı",
            whatsappPrice: "Whatsapp Fiyatı",
            realtimeVisitorCount: "Anlık Ziyaretçi",
            suspend: "Askıya Al",
            partner: "Partner",
            plan: "Plan",
            trialDay: "Deneme Günü",
            mobile: "Mobil",
            webSite: "Web Sitesi",
            websiteOrigins: "Web Sitesi Kaynağı",
            ownerName: "Sahibinin Adı",
            ownerEmailAddress: "Sahibinin Email'i",
            discount: "İndirim",
            daysLeft: "Kalan Gün",
            newTrialPopUp: "Yeni Deneme Süresi Kaç Gün Olsun",
            newWpPricePopUp: "Yeni Whatsapp Ücreti Ne Kadar Olsun ?",
            newIGPricePopUp: "Yeni Instagram Ücreti Ne Kadar Olsun ?",
            newBasePricePopUp: "Yeni Supsis Taban Fiyatı Ne Kadar Olsun ?",
            siteInfoUpdated: "Site Bilgisi Güncellendi",
            siteInfoNotUpdated: "Site Bilgisi Güncellenmedi",
            siteInfoNotUpdatedErr: "Hata Oluştu! Site Bilgisi Güncellenmedi.",
        },
        tour: {
            representativeTab: "Temsilci Tablosu",
            stats: "İSTATİSTİK PANELİ",
            chats: "CHAT PANELİ",
            settings: "AYARLAR",
            status: "DURUM",
            prevStep: "Önceki Adım",
            nextStep: "Sonraki Adım",
            finish: "Bitir",
            skip: "Atla",
            skip2: "Sistemi biliyorum bir daha gösterme",
            startTour: "Tura Başla",
            firstTimeIntro:
                "Sisteme ilk defa girdiğini keşfettim izin verirsen ufak bir tanıtıcı tur başlatmak istiyorum",
            hi: "Merhaba",
            welcomeTo: "Supsis Canlı Destek'e Hoşgeldin",
            statsPanel: "Sistemle anlık olarak bekleyen, toplam, aktif chat sayılarını gösteren durum çubuğudur.",
            sidebarMenu: "Menü",
            sidebarMenuContent: "Sayfalar arası geçişleri buradan yapabilirsiniz.",
            representativePrivateMessage: "Temsilciler Arası Konuşma Paneli",
            representativePrivateMessageContent: "Temsilciler arası özel konuşmaları buradan görebilirsiniz.",
            helpMenu: "Yardım Menüsü",
            helpMenuContent: "Sistem hakkında yardım bilgilerine buradan ulaşabilirsiniz.",
            settingsMenu: "Ayarlar Menüsü",
            settingsMenuContent: "Dil, gece modu ve ekran büyütme adımlarını buradan yapabilirsiniz.",
            startChat: "Sohbeti Başlat",
            profileMenu: "Profil Menüsü",
            profileMenuContent: "Müsaitlik durumunuzu değiştireblir ve temsilci ayarlarınızı buradan yapabilirsiniz.",
            visitorsTab: "Ziyaretçiler",
            visitorsTabContent: "Ziyaretçileri buradan görebilirsiniz.",
            visitorTabHistory: "Ziyaretçi Geçmişi",
            visitorTabHistoryContent: "Ziyaretçi geçmişini buradan görebilirsiniz.",
            representativ_eTab: "Temsilciler",
            representativeTabContent: "Temsilcileri buradan görebilirsiniz.",
            liveSupport: "Canlı Destek",
            liveSupportContent: "Canlı Destek alan müşteri sayısını buradan görebilirsiniz. ",
            siteVisitors: "Site Ziyaretçileri",
            siteVisitorsContent: "Site ziyaretçi sayısını buradan görebilirsiniz. ",
            tableSettings: "Tablo Ayarları",
            tableSettingsContent: "Tabloda kolon gösterme veya gizlemeyi buradan yapabilirsiniz.",
            watchModeButton: "İzleyici Butonu",
            watchModeContent: "İzleyici mode olarak buradan katılabilirsiniz ve sadece yazılanları görüntülersiniz.",
            popoverInfo: "Ziyaretçi Detay",
            popoverInfoContent: "Ziyaretçi hakkında  bilgi verir.",
            popoverButton: "Gelişmiş Konuşma Ayarları",
            popoverButtonContent:
                "Konuşmayı açar, temsilciye direk mesaj atabilir veya ziyaretçiyi engelleyebilirsiniz.",
            openChat: "Konuşma Katıl Butonu",
            openChatContent: "Konuşmayı buradan açabilirsiniz",
            pagination: "Sayfalama Menüsü.",
            paginationContent: "Sayfa sayısını buradan arttırabilirsiniz.",

            chatwindow: {
                chatWindowSettingsButtons: "KONUŞMA PENCERESİ AYARLAR BUTONU",
                chatWindowActionButtons: "KONUŞMA PENCERESİ GENEL İŞLEM BUTTONLARI",
                chatPanelActions: "KONUŞMA PANELİ İŞLEMLERİ",
                otherPanels: "DİĞER PANELLER",
                settingsButton: "Konuşma engelleme, yönlendirme, gizli mesaj atma ve temsilci atama yapabilirsiniz.",
                chatColorButton: "Konuşma balonlarındaki hangi renk ne anlama geldiğini buradan öğrenebilirsiniz",
                keyboardShortcutButton:
                    "Yazışma esnasında kolaylık sağlayan fonksiyonların veya diğer kullandığın özelliklerin kısayollarını buradan bulabilirsin",
                hideButton: "Açık konuşmayı aşağıya indirir arka planda açık kalmaya devam eder",
                closeButton: "Açık konuşması sonlandırır ve konuşmadan çıkarsınız",
                ellipsisButton:
                    "Daha fazla işlemler burada yer almaktadır. Özel mesaj gönderme , ziyaratci banlama , temsilci atama gibi işlemler buradan yapılır",
                userInfoWidget: "Ziyaretçi hakkında detaylı bilgiler burada yer alacaktır",
                preparedContentWidget:
                    "Burada hazır içerik şablonları bulunmaktadır. İster tıklayarak ister kısayolunu konuşma ekranında yazı yazma alanında kısayol serisi tuşlayarak hazır içerikleri hızlıca ekleyebilirsin",
                chatHistoryWidget:
                    "Bu ziyaretcinin geçmiş konuşmaları varsa burada listelenecektir. Eski konuşma detaylarını buradan inceleyebilirsin",
                chatBarButton:
                    "Aktif konuşmayı buradan engelleyebilir, temsilciye gizli mesaj atabilir ve görüşmeden ayrılabilirsiniz.",
            },
        },
        adminUser: {
            newAdminUserForm: "Yeni Admin Kullanıcısı Kayıt Formu",
            updateAdminUserForm: "Admin Kullanıcısı Güncelleme Formu",
            adminUsers: "Admin Kullanıcılar",
            newAdminUser: "Yeni Admin Kullanıcı",
            noAdminUser: "Henüz bir admin kullanıcı yok.",
            adminUserName: "Admin Kullanıcı Adı",
        },
        report: {
            incomingMessages: "Gelen Mesajlar",
            outgoingMessages: "Giden Mesajlar",
            customerCount: "Müşteri Sayısı",
            mailCount: "Posta Sayısı",
            answered: "Cevaplandı",
            unanswered: "Cevapsız",
            selectChannel: "Bir Kanal Seçin",
            sentMails: "Gönderilen Postalar",
            sentMailCount: "Gönderilen Posta Sayısı",
            ticketDistribution: "Bilet Dağıtımı",
            selectWorkflow: "İş Akışınızı Seçin",
            chartView: "Grafik Görünümü",
            tableView: "Tablo Görünümü",
            fullScreen: "Tam Ekran",
            distributionOfTasks: "Görevlerin Dağılımı",
            mostMissioned: "En Görevli",
            leastTask: "En Az Görev",
            leastTasked: "En Az Görevli",
            totalNumberTasks: "Toplam Görev Sayısı",
            errorFetchingTask: "Görev verileri alınırken hata oluştu:",
            pipelinePhase: "Boru Hattı Aşaması",
            status: "Durum",
            numberOfTasks: "Görev Sayısı",
            insufficientData: "Yetersiz Veri",
            hourly: "(Saatlik)",
            hourlyAverage: "Saatlik Ortalama",
            hourlyMax: "Saatlik Maksimum",
            hourlyMin: "Saatlik Minimum",
            dailyAverage: "Günlük Ortalama",
            dailyMax: "Günlük Maksimum",
            dalyMin: "Günlük Minimum",
            totalAmount: "Toplam Miktar",
            averageAmount: "Ortalama Miktar",
            minAmount: "Minimum Miktar",
            maxAmount: "Maksimum Miktar",
            siteCount: "Site Sayısı",
            agentCount: "Temsilci Sayısı",
            channelsTimeSeries: "Kanallar Grafiği",
            channelPies: "Kanallar Pasta Grafiği",
            pieView: "Pasta Grafiği",
            topVisitorCountry: "En Çok Ziyaretçinin Geldiği Ülke",
            websiteTrafficByCountry: "Ülkeye Göre Website Trafiği",
            visitorCount: "Ziyaretçi Sayısı",
            websiteVisitorTraffic: "Website Ziyaretçi Trafiği",
            websiteTraffic: "Website Trafiği",
            author: "Yazan",
            topWorstComments: "En Kötü Yorumlar",
            topBestComments: "En İyi Yorumlar",
            topBestWorstComments: "En İyi/Kötü Yorumlar",
            topComments: "Yorum Analizi",
            noComment: "Henüz Yorum Yapılmadı",
            minWaitingTime: "Minimum Bekleme Süresi",
            maxWaitingTime: "Maksimum Bekleme Süresi",
            averageWaitTime: "Ortalama Bekleme Süresi",
            waitTime: "Bekleme Süresi (Saniye)",
            agentWaitDurationTitle: "Temsilci Bekleme Süresi Grafiği",
            incomingMessage: "Gelen Mesaj(lar)",
            outgoingMessage: "Giden Mesaj(lar)",
            totalSpent: "Toplam Harcama",
            avgSpent: "Ortalama Harcama",
            totalPayment: "Toplam Yükleme",
            walletStatus: "Cüzdan Durumu",
            walletBalanceStatus: "Cüzdan Bakiyesi Durumu",
            messageTraffic: "Mesaj Trafiği",
            breakCount: "Mola Sayısı",
            agentBreakTime: "Temsilcilerin Mola Sayıları ☕",
            agentStatusHour: "Temsilci Durumu (Saat)",
            agentWorkTimeCalendar: "Temsilci Çalışma Süresi Takvimi",
            agentActivity: "Temsilci Aktivitesi",
            noEnoughtData: "Yeterli Veri Yok",
            averageFirstResponse: "Ortalama İlk Cevap Süresi",
            slowestResponser: "En Yavaş Cevap Veren",
            fastestResponder: "En Hızlı Cevap Veren",
            firstAnswerTimeSec: "İlk Mesaj Süresi (Saniye Olarak)",
            firstAnswerByAgent: "Temsilcilerin İlk Mesaj Süresi",
            averageSolutionTime: "Ortalama Çözüm Süresi",
            slowestSolver: "En Yavaş Çözen",
            fastestSolver: "En Hızlı Çözen",
            averageChat: "Ortalama Chat",
            leastChatReceiver: "En Az Chat Alan",
            mostChatRecipients: "En Çok Chat Alan",
            averageTicket: "Ortalama Ticket",
            leastTicketReceiver: "En Az Ticket Alan",
            mostTicketRecipients: "En Çok Ticket Alan",
            resolveTime: "Çözüm Süresi (dk)",
            resolveTimeByUser: "Kullanıcıya Göre Chat Çözüm Süresi (Dakika olarak)",
            chatResolveTimeByAgent: "Temsilcilere Göre Sohbet Çözüm Süresi",
            chatDistByHandDesc: "Temsilci, chatbot ve hibrit tarafından kaç sohbet gerçekleştirildi?",
            chatDistByHandleType: "Yanıtlayana Göre Chat Dağılımı",
            chatCountsByHandleType: "Yanıtlayana Göre Chat Sayıları",
            missed: "Kaçırıldı",
            chatDistByAnsDesc: "Kaç sohbet yanıtlandı ya da kaçırıldı?",
            chatCountsByAns: "Yanıta Göre Chat Sayıları",
            chatCountByPlatform: "Platforma Göre Chat Sayıları",
            chatDistByPDesc: "Hangi platforma kaç chat geldi?",
            chatDistByPlatform: "Platforma Göre Chat Dağılımı",
            ticketCountByUser: "Temsilcilere Göre Ticket Sayıları",
            ticketCountByStatus: "Yanıtlama Durmuna Göre Chat Sayıları",
            user: "Temsilci",
            saveAsImage: "Görsel olarak indir",
            download: "İndir",
            chatDistByUsers: "Temsilcilere Göre Chat Dağılımı",
            chatCountsByUsers: "Temsilcilere Göre Chat Sayıları",
            minDuration: "Minimum Süre",
            maxDuration: "Maksimum Süre",
            totalDurationByAgent: "Temsilci Toplam Oturum Süresi",
            averageDurationByAgent: "Temsilci Ortalama Oturum Süresi",
            totalDurationByCB: "Chatbot Toplam Oturum Süresi",
            averageDurationByCB: "Chatbot Ortalama Oturum Süresi",
            viewUnitAs: "Birim",
            hybrid: "Hibrit",
            handledBy: "Tarafından:",
            sessionDurationOverall: "Genel Oturum Süresi",
            allChannels: "Tüm Kanallar",
            sessionsDurationOverall: "Oturum Süreleri Genel",
            sessionsOverall: "Oturumlar Genel",
            eventCount: "Etkinlik Sayısı",
            calendarEvents: "Takvim Etkinlikleri",
            reservationEvents: "Rezervasyon Etkinlikleri",
            incomingMails: "Gelen Mailler",
            incomingMailCount: "Gelen Mail Sayısı",
            reservation: "Rezervasyon",
            event: "Etkinlik",
            reservationEventCount: "Rezervasyon Etkinlik Sayısı",
            channelBreakdown: "Kanal Dağılımı",
            websiteAnalysis: "Website Analizi",
            customerSatisfaction: "Müşteri Memnuniyeti",
            teamBreakAnalysis: "Takım Çalışma/Mola Analizi",
            dailyAgentActivity: "Günlük Temsilci Aktiviteleri",
            agentPerformance: "Temsilci Performansı",
            chatDistributions: "Chat Dağılımı",
            contactDistributions: "Kişi Dağılımı",
            users: "Kullanıcı",
            segmentTimeseries: "Segment Grafiği",
            segmentsOverall: "Genel Segmentler",
            unmatchRatio: "Eşleşmeme Oranı",
            totalMatchCount: "Toplam Eşleşme Sayısı",
            totalUnmatchCount: "Toplam Eşleşmeme Sayısı",
            matchRatio: "Eşleşme Oranı",
            matched: "Eşleşen",
            trainingOverall: "Genel Eğitim",
            trainingStatusTimeseries: "Eğitim Durumu Zaman Grafiği",
            duration: "Süre",
            totalSessionDuration: "Toplam Oturum Süresi",
            averageSessionDuration: "Ortalama Oturum Süresi",
            second: "Saniye",
            minute: "Dakika",
            hour: "Saat",
            aggregateAs: "Şu şekilde hesapla",
            chatbotSessionDurationOverall: "Genel ChatBot Oturum Süresi",
            ratingTimeSeries: "Oylama Grafiği",
            chatCountTimeseries: "Sohbet Sayısı Zaman Grafiği",
            notRated: "Puanlanmamış",
            totalRatingCount: "Toplam Değerlendirme Sayısı",
            averageRating: "Ortalama Değerlendirme",
            weightedAverageRating: "Ağırlıklı Ortalama Değerlendirme",
            rate: "Puanlama",
            ratingOverall: "Müşteri Değerlendirmeleri",
            session: "Oturum",
            total: "Toplam",
            average: "Ortalama",
            max: "En Fazla",
            min: "En Az",
            sessionCount: "Oturum Sayısı",
            uniqueUsers: "Benzersiz Kullanıcılar",
            viewAs: "Şu şekilde görüntüle: ",
            overall: "Genel",
            detailReport: "Detaylı Rapor",
            dailyReports: "Günlük Raporlar",
            pointBasedReports: "Puan Bazlı Raporlar",
            personDateBasedPointReport: "Kişi ve Gün Bazlı Puan Raporu",
            personDateBasedReport: "Kişi ve Gün Bazlı Rapor",
            personBasedReport: "Kişi Bazlı Raporlar",
            personAndDateBasedGraph: "Kişi ve Gün Bazlı grafiği",
            noReport: "Rapor Yok",
            reports: "Raporlar",
            totalBar: "Toplam",
            ticketCount: "Ticket Sayısı",
        },
        announcements: {
            menu: "Duyurular",
            newAnnouncementForm: "Yeni Duyuru Kayıt Formu",
            updateAnnouncementForm: "Duyuru Güncelleme Formu",
        },
        stats: {
            total: "Sistemdeki aktif konuşmaların sayısıdır.",
            active: "Size ait olan aktif konuşmaların sayısıdır.",
            waiting: "Temsilci atanmayı bekleyen yeni aktif konuşma sayısıdır.",
            late: "Belli bir süre geçmiş  ve temsilci atanmayı bekleyen yeni konuşmaların sayısıdır.",
            free: "Temsilcisi çıkış yaptıktan sonra yeni temsilci atamayı bekleyen konuşmaların sayısıdır.",
            pco: "[Personel Çalışma Oranı] : Sistemdeki çevrimiçi temsilcilerin toplam alabildiği konuşma sayısının doluluk oranınıdır. ",
            maxCapacity: "Sistemin bekletmeden temsilci atayabileceği maksimum chat sayısıdır",
            chatbot: `Chatbot'un aktif konuşma sayısı`,
        },
        time: {
            lastYear: "Son Yıl",
            thisYear: "Bu Yıl",
            last3Months: "Son 3 ay",
            last7: "Son 7 Gün",
            today: "Bugün",
            yesterday: "Dün",
            lastWeek: "Geçen Hafta",
            currentWeek: "Bu Hafta",
            currentMonth: "Bu Ay",
            lastMonth: "Geçen Ay",
            last30Day: "Son 30 gün",
            allTime: "Tüm Zamanlar",
            custom: "Farklı Bir Zaman",
        },
        fastWizard: {
            generalColors: "Genel Renkler",
            tellUsMore: "Deneyiminizi kişiselleştirebilmemiz için bize daha fazla bilgi verin",
            moreInfo: "Genel Ayarlar",
            display: "Tema Ayarları",
            availability: "Temsilci Çalışma Saatleri",
            preview: "Ön İzleme",
            installCode: "Kurulum",
            previous: "Önceki Adım",
            setupSupsisLiveChat: "SUPSIS LIVE Hızlı Kurulum",
            continue: "Sıradaki Adım",
            completeInitialize: "Hızlı Kurulumu Tamamla",
            completedMessage: "SUPSIS Live Hızlı Kurulumu Başarıyla Gerçekleştirildi.",

            websiteIntegration: "Supsis Live entegrasyonu için web sitenizin adresi",

            customizeLiveChat: "Canlı Sohbetinizi Özelleştirin",
            createBrandedExperience: "Ziyaretçileriniz için markalı bir sohbet deneyimi oluşturun.",
            chatColor: "Chat Rengi",
            chooseChatColor: "Bir Renk Seçin.",
            chatBubble: "Chat Balonu",
            selectBubble: "Bir Chat Balonu Seçin",
            chatBubbleColor: "Chat Balonu Rengi",
            selectChatBubbleColor: "Chat Balonu Rengini Seçin",
            customSelection: "Özel Seçim:",

            onlineSupportVisitorTime: "Ziyaretçilerinize hangi zaman aralıklarında hizmet sağlarsınız ?",
            channelAvailability: "Çevrimci Zamanlama",
            availability724: "7/24 Sürekli Hizmet",
            basedOnTeam: "Temsilci Çalışma Saatleri Dahilinde",
            basedOnTeamExplanation:
                "En az 1 temsilci çevrimçi olduğunda sohbet çevrimiçi görünür. Çevrimiçi temsilci yoksa offline olarak görünür",
            customHours: "Özel Çalışma Saatleri",
            customHoursExplanation: "Kendi Çalışma Saatlerinizi Belirleyin",
            customHoursTimezone: "Bölgesel Zaman Dilimi:",
            customHoursFrom: "Başlangıç:",
            customHoursTo: "Bitiş:",
            customHoursAddHours: "+Saat Ekle",

            previewDesktop: "Masaüstü",
            previewIpad: "Tablet",

            installationAndInstructions: "Kurulum & Talimatlar",
            installationTrackingCode: "Takip numarasını web sitenize yükleyin",
            installationTrackingCodePlease:
                "Lütfen kodu, SUPSIS Canlı sohbeti etkinleştirmek istediğiniz herhangi bir sayfada {bodyTag} etiketinin bitiminden hemen önce aşağıdaki talimatlara uygun olarak yapıştırın.",
            installationInstructionsJavascript:
                " Yukarıda verilen entegrasyon kodunu {bodyTag} etiketi içerisinde kapanıştan hemen öncesine yapıştırın.",
            installationInstructionsShopify1: "1. Shopify panelinize giriş yapın",
            installationInstructionsCopy: "Kopyala",
            installationInstructionsCoppyMessage: "Entegrasyon komutları panoya kopyalandı",
            installationInstructionsShopify2:
                "2. Online Store > Themes > Actions 'a gidin,altındaki açılır menüden  Current Theme > Edit code >theme.liquid 'e ilerleyin",
            installationInstructionsShopify3:
                "3.Yukarıda verilen entegrasyon kodunu, theme.liquid scriptinin sonundaki {bodyTag} etiketinin hemen önüne yerleştirin.",
            installationInstructionsIdeaSoft1: "1. Bayi panelinize giriş yapınız.",
            installationInstructionsIdeaSoft2: "2. Ayarlar -> SEO -> Arama Motoru Servisleri adımını takip ediniz.",
            installationInstructionsIdeaSoft3:
                '3. Takip Kodu  kısmından "Meta Tag ile Site Doğrulama"  seçeneğini seçiniz.',
            installationInstructionsIdeaSoft4:
                "4. Açılan kutuya yukarıdaki entegrasyon kodunu kopyalayıp yapıştırın ve kaydediniz.",
            installationInstructionsIdeaSoft5:
                '5. Ayarlar -> Optimizasyonlar -> "Ön Belleği Temizle" butonuna basınız. Entegrasyon tamamlanmıştır.',
            installationInstructionsWordPress1: "1. WordPress yönetici panelinize giriş yapın",
            installationInstructionsWordPress2: "2. Görünüm > Tema Düzenleyici'ye gidin",
            installationInstructionsWordPress3:
                "3. (en sağda) Tema Dosyaları altında, Tema Altbilgisini (footer.php)'yi bulun ve seçin",
            installationInstructionsWordPress4:
                "4.Yukarıdaki entegrasyon kodunu alttaki {bodyTag} etiketinin önüne yapıştırın.",
            installationInstructionsWordPress5: "5. Değişiklikleri kaydetmek için Dosyayı Güncelle'yi tıklayın",
            installationInstructionsOpenCart1: "1. Opencart admin panelinize giriş yapın",
            installationInstructionsOpenCart2: "2. Tasarım > Tema Düzenleyici'ye gidin",
            installationInstructionsOpenCart3:
                "3. 'common' klasörünü seçin ve içerisindeki 'header.twig' dosyasını açın.",
            installationInstructionsOpenCart4:
                "4.Yukarıdaki entegrasyon kodunu, alttaki {headTag} etiketinin önüne yapıştırın.",
            installationInstructionsOpenCart5: "5. Kaydet butonuna tıklayın",
            installationInstructionsTicimax1: "1. Ticimax yönetim panelinize giriş yapın",
            installationInstructionsTicimax2: "2. Tasarım > Tasarım ayarları > Header Footer Tasarımını açın",
            installationInstructionsTicimax3: "3. Logo tasarımı kısmında 'Kaynak'butonunu tıklayın.",
            installationInstructionsTicimax4: "4. HTML kodunun altına yukarıdaki entegrasyon kodunu yapıştırın.",
            installationInstructionsEticaretteyim1: "1. Eticaretteyim yönetim panelinize giriş yapın",
            installationInstructionsEticaretteyim2:
                "2. Eklentiler > HTML Oluştur > Kısmından SUPSIS Adını Verip  Kodu Kopyalamanız Yeterlidir.",
            installationInstructions: "Talimatlar",
            installationVerify: "Web Sitenizin Supsis Kurulumunu Doğrulayın",
            installationVerifyChecking: "Kontrol Ediliyor",
            installationVerifyCheck: "Kontrol Et",
            installationVerifyCheckingStatus: "{website} sitesinin SUPSIS entegrasyon durumu kontrol ediliyor",
            installationCheckingStatusMessageYes: "SUPSIS LIVE {website} sitesine entegre olmuştur.",
            installationCheckingStatusMessageNo: `SUPSIS şu anda {website} sitesine entegre değil.\n Entegrasyon işleminizi şimdi ya da daha sonra tamamlayabilirsiniz.`,

            vtippyPreferredLanguage: "Tercih Edilen Dil ",
        },
        packages: {
            mostPopular: "EN ÇOK TERCİH EDİLEN",
            currency: "₺",
            activePlan: "AKTİF PLAN",
        },
        totalCost: {
            title: "SUPSİS MALİYETİ",
            monthlyPayments: "Aylık Ödemeler",
            currency: "₺",
            currencyMonthly: "₺ / Aylık",
            oneTimePayments: "Tek Seferlik Ödemeler",
            oneTimeDiscount: "Yıllık Paket İndirimi",
            currencyYearly: "₺ / Yıllık",
            totalOneTimeCost: "Toplam İlk Seferde ödenecek Tutar",
            totalTax: "Vergi ( %18 )",
            referenceCode: "Referans Kodunuz var mı?",
            referencePlaceholder: "Lütfen Kodu Giriniz",
            codeButton: "Uygula",
            monthlyCost: "Hesabınızdan Aylık Çekilecek Tutar?",
            oneTimeFullCost: "Tek Seferlik Herşey Dahil Tutar?",
            payment: "Ödemeyi Yap",
        },
        akinon: {
            typeOrSelectSKU: "SKU yazın veya seçin",
            akinonUserId: "Akinon Kullanıcı Id",
            userEmail: "Kullanıcı Email",
            userEmailDesc: "Kullanıcı e-postasını yazın veya seçin...",
            send: "Gönder",
            selectCity: "İlçe Seçin",
            city: "İlçe",
            selectState: "İlinizi Seçin",
            state: "İl",
            useMap: "Haritayı Kullan",
            chooseAddress: "Adres Seç",
            selectCountry: "Ülke Seç",
            country: "Ülke",
            productIdDesc: "Ürün yazın veya seçin...",
            productId: "Ürün Id'si",
            userIdDesc: "Akinon kullanıcı id'si yazın...",
            productSKU: "Ürün SKU'su",
            latitudeDesc: "Hedef konum enlemini yazın veya seçin...",
            longitudeDesc: "Hedef konumun boylamını yazın veya seçin...",
            orderNumber: "Sipariş numaranız",
            orderDesc: "Sipariş numarasını yazın...",
            longitude: "Boylam",
            latitude: "Enlem",
        },
        probel: {
            branchCode: "Branş Kodu",
            branchCodeDesc: "Branş kodunu yazın veya seçin...",
            hospitalBranchCode: "Şube Kodu",
            hospitalBranchCodeDesc: "Şube kodunu yazın veya seçin...",
            clinicCode: "Poliklinik Kodu",
            clinicCodeDesc: "Poliklinik kodunu yazın veya seçin...",
            date: "Randevu Tarihi",
            dateDesc: "Randevu tarihini girin veya seçin...",
            patientToken: "Hasta Token",
            patientTokenDesc: "Hasta tokenini yazın veya seçin...",
            appointmentId: "Randevu Id",
            appointmentIdDesc: "Randevu id'sini yazın veya seçin...",
            identityType: "Kimlik Türü",
            identityNumber: "Kimlik Numarası",
            name: "Hasta Adı",
            surname: "Hasta Soyadı",
            gender: "Hasta Cinsiyet",
            birthDay: "Hasta Doğum Tarihi",
            phoneNumber: "Hasta Telefon Numarası",
            identityTypeDesc: "Kimlik türünü yazın veya seçin...",
            identityNumberDesc: "Kimlik numarasını yazın veya seçin...",
            nameDesc: "Hasta adını yazın veya seçin...",
            surnameDesc: "Hasta soyadını yazın veya seçin...",
            genderDesc: "Hasta cinsiyetini yazın veya seçin...",
            birthDayDesc: "Hasta doğum tarihini yazın veya seçin...",
            phoneNumberDesc: "Hasta telefon numarasını yazın veya seçin...",
        },
        headBar: {
            source: "Kaynak",
            label: "Etiket",
            completed: "Tamamlandı mı?",
            email: "E-mail",
            phone: "Telefon",
            name: "Ad",
            date: "Tarih",
            subject: "Konu",
            situation: "Durum",
            representative: "Temsilci",
            transactions: "İşlemler",
        },
        login: {
            loginTitle1: "SUPSIS'e",
            loginTitle2: "Hoşgeldiniz",
            email: "Email Adresiniz",
            emailPlaceholder: "Lütfen e-posta adresinizi giriniz.",
            emailError: "Lütfen Geçerli E-posta Giriniz",
            password: "Şifreniz",
            passwordLogin: "Şifresiz Giriş",
            passwordAndLogin: "Şifre ile Giriş Yap",
            passwordNew: "Şifremi Yenile",
            loginAnd: "Veya",
            passwordPlaceholder: "Lütfen şifrenizi giriniz.",
            loginMemory: "Bu cihazı hatırla",
            passwordForget: "Şifremi unutum",
            passwordNewAgain: "Yeni Şifre",
            passwordNewAgainTwo: "Yeni Şifre Tekrarı",
            passwordNewAgainPlaceholder: "Lütfen yeni şifrenizi giriniz.",
            passwordNewAgainPlaceholderTwo: "Lütfen yeni şifre tekrarınızı giriniz.",
            login: "Giriş Yap",
            loginFooter: "Veya, E-Posta ile Giriş Yap",
            emailLogin: "E-Posta ile Giriş yap",
        },
        settings: {
            ipAddress: "IP Adresim",
            whiteList: "Güvenli IP Listesi",
            whiteListAdd: "Güvenli IP Ekle",
            whiteListDeletedSuccessfully: "Güvenli IP Listesinden silindi",
            whiteListDeletedFailed: "Güvenli IP Listesinden silinemedi",
            whiteListAddedSuccessfully: "Güvenli IP Listesine eklendi",
            whiteListAddedFailed: "Güvenli IP Listesine eklenemedi",
            deleteWhiteListTitle: "Güvenli IP Listesinden silmek istediğinize emin misiniz?",
            talkSettings: "Konuşma Ayarları",
            talkSubtitles: "Konuşma Ayarlarınızı Yönetin",
            dateAndTime: "Tarih ve Saat",
            actor: "Aktör",
            event: "Etkinlik",
            accessControl: "Erişim Kontrolü",
            organizationLongName: "Organizasyon Uzun Adı",
            visitorNewDesc: "Ziyaretçi temasının yeni sürümünü kullanabilirsiniz.",
            transactionType: "İşlem Tipi",
            priorBalance: "Önceki Bakiye",
            nextBalance: "Sonraki Bakiye",
            amount: "Tutar",
            phoneNumber: "Telefon Numarası",
            profileInfoRemoved: "Profil bilgisi kaldırıldı.",
            newValueUpdated: "Yeni Değer Güncellendi.",
            ballanceToTransferred: "Aktarılıcak Bakiye",
            availableBalance: "Mevcut Bakiye",
            balanceReceived: "Alınan Bakiye",
            totalBalance: "Toplam Bakiye",
            paymentCard: "Ödeme Yapılacak Kart",
            wpPhoneNumber: "Whatsapp Telefon Numarası",
            wpSendingMessage: "Whatsapp İlk Mesaj Gönderme",
            auditlogs: "Denetim Logları",
            myaccount: "Hesabım",
            notifications: "Bildirimler",
            company: "Şirket",
            features: "Özellikler",
            general: "Genel",
            chat: "Sohbet",
            timings: "Süre Ayarları",
            language: "Dil",
            wallet: "Cüzdan",
            "bubble-settings": "Sohbet Balonu Ayarları",
            "bubble-actions": "Sohbet Balonu Özellikleri",
            "theme-settings": "Sohbet Teması Ayarları",
            visitorLoginForm: "Ziyaretçi Giriş Formu",
            visitorAttribute: "Ziyaretçi Profil Bilgileri",
            timing_settings: "Süre Ayarları",
            auto_assign: "Otomatik Chat Atama",
            availability: "Temsilci Çalışma Saatleri",
            "website-integration": "Web Sitesi Entegrasyonu",
            General: "Genel",
            Chat: "Sohbet",
            Timings: "Süre Ayarları",
            Integration: "Entegrasyon",
            developer: "Geliştirici",
            integration: "Entegrasyon",
            visitorNew: "Yeni Ziyaretçi Tasarıma Geçiş",
            companySubtitles: "Şirketinizin genel bilgilerini yönetin.",
            featuresSubtitles: "Supsis'in akıllı özelliklerini yönetin.",
            languageSubtitles: "Şirketinizin tercih ettiği dili yönetin.",
            bubbleSettings: "Sohbet Balonu Ayarları",
            bubbleSettingsSubtitles: "Sohbet balonu ayarlarınızı yönetin.",
            bubbleActionsSubtitles:
                "Sohbet balonu özelliklerinizi genişletin. Firmanıza ait whatsapp ,mail ,telefon bilgilerini ziyaretçilerinizle paylaşabilirsiniz.",
            chatThemeSettingsSubtitles: "Sohbet teması ayarlarınızı yönetin.",
            visitorLoginFormSubtitles: "Ziyaretçi giriş formu ayarlarınızı yönetin.",
            chatTimingSettingsSubtitles: "Chat Süre Ayarları - Konuşma Süresi Kontrolleri ve Seçenekleri.",
            webSiteIntegrationSubtitles: "Web sitenize sohbet balonu ekleyin.",
            apiAccessTitle: "API Erişimi",
            apiAccessSubtitles: "Token kodunuza burdan ulaşabilirsiniz.",
            youTubeActionForm: "Youtube Kanalınızı Ekleyin",
            linkedinActionForm: "Linkedin Hesabınızı Ekleyin",
            telegramActionForm: "Telegram Hesabını Ekleyin",
            facebookActionForm: "Facebook Sayfanızı Ekleyin",
            tiwitterActionForm: "Twitter Sayfanızı Ekleyin",
            instagramActionForm: "Instagram Sayfanızı Ekleyin",
            liveSupportDescription: "Müşterilerinizle canlı bir sohbet açın",
            ticketDescription: "Müşterilerinizle canlı bir sohbet açın",
            whatsappDescription: "Müşterileriniz WhatsApp ile size ulaşsın",
            phoneDescription: "Müşterileriniz telefon ile size ulaşsın",
            emailDescription: "Müşterileriniz e-posta ile size ulaşsın",
            facebookDescription: "Müşterileriniz Facebook ile size ulaşsın",
            twitterDescription: "Müşterileriniz Twitter ile size ulaşsın",
            instagramDescription: "Müşterileriniz Instagram ile size ulaşsın",
            youtubeDescription: "Müşterileriniz Youtube ile size ulaşsın",
            linkedinDescription: "Müşterileriniz Linkedin ile size Ulaşsın",
            telegramDescription: "Müşterileriniz Telegram ile size Ulaşsın",
            whatsappModalTitle: "Whatsapp İşlem Formu",
            whatsappModalDescription: "Whatsapp hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            phoneModalTitle: "Telefon İşlem Formu",
            phoneModalDescription: "Telefon numaranızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            emailModalTitle: "E-Posta İşlem Formu",
            emailModalDescription: "E-posta hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            facebookModalTitle: "Facebook İşlem Formu",
            facebookModalDescription: "Facebook hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            twitterModalTitle: "Twitter İşlem Formu",
            twitterModalDescription: "Twitter hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            instagramModalTitle: "Instagram İşlem Formu",
            instagramModalDescription: "Instagram hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            youtubeModalTitle: "Youtube İşlem Formu",
            youtubeModalDescription: "Youtube hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            linkedinModalTitle: "LinkeIn İşlem Formu",
            linkedinModalDescription: "LinkedIn hesabını bağlama için lütfen aşşağıdaki formu doldurunuz",
            telegramModalTitle: "Telegram İşlem Formu",
            telegramModalDescription:
                "Telegram Hesabınızı bağlama için aşağıdaki forma Telegram profil linkini yazınız",
            instagramAlertTitle: "Instagram Entegrasyonu Gerekli",
            instagramAlertDesc:
                "Üzgünüz, ziyaret ettiğiniz sayfa, Instagram'ınızı entegre ettiğinizde etkinleştirilecektir.",
            instagramActivateText: "Haydi, Instagram'ı Entegre Et",
            remove: "Kaldır",
            edit: "Düzenle",
            connected: "Bağlı",
            add: "Ekle",
            themeDescription: "Sohbet Tema  Ayarları.",
            fontDescription: "Sohbet Yazı Tipi Ayarları.",
            emailTitle: "E-Posta Adresinizi Giriniz",
            emailMessage: "E-posta İlk Gönderim Mesajı",
            isFabsAsIcon: "Menü İkon Yazılarını Göster.",
            chatBubbleTextSetting: "Chat Balonu Yazı Ayarı",
            textOnChatBubble: "Chat Balonu üzerinde gözükecek metin ayarlarını yapabilirsiniz.",
            textToAppearOnChatBubble: "Chat Balonu üzerinde Gözükecek Metin",
            newVisitorProfileInformation: "Yeni Ziyaretçi Profil Bilgisi",
            newVisitorProfileInformationDescription: "Ziyaretçi profil bilgisine yeni değer ekler",
            create: "Oluştur",
            newAdd: "Yeni Ekle",
            toInform: "Bilgilendirme",
            toInformDescription: "Bu sayfada eklediğiniz değerleri ziyaretci giriş formu ile eşleştirebilirsiniz.",
            showVisitor: "Ziyaretçiyi Göster",
            label: "Etiket",
            text: "Yazı",
            email: "E-posta",
            phone: "Telefon",
            number: "Sayı",
            url: "URL",
            date: "Zaman",
            dropdown: "Seçilebilir",
            languageTimeZone: "Dil & Bölge",
            timeZoneTitle: "Bölge & Saat Dilimi",
            timeZoneDescription: "Bölge ve saat dilimi ayarları",
        },
        userInfoWidget: {
            userInformation: "Kullanıcı Bilgileri",
            fullName: "Adı Soyadı",
            newValue: "Yeni Değer",
            newProfileInfo: "Yeni Profil Bilgisi",
            affiliatedRepresentatives: "Temsilciler",
            preferredAgents: "Tercih Edilen Temsilciler",
            labels: "Etiketler",
            agentNotes: "Temsilci Notları",
            newNote: "Yeni Not",
            note: "Not",
            available: "adet not mevcut.",
            systemInformation: "Sistem Bilgileri",
            speechID: "Konuşma Kimliği",
            customerVersion: "Müşteri Version",
            IPAddress: "IP Adresi",
            pageVisited: "Ziyaret Edilen Sayfa",
            systemAndBrowser: "İşletim Sistemi & Tarayıcı",
            countryAndLanguage: "Ülke & Dil",
            clickToEdit: "Düzenlemek Yazının içine tıklayın",
            adsYouAreInterestedIn: "İlgilendiği Reklamlar",
            detail: "Detay",
            adsTitle: "Başlık",
            adUrl: "Reklam Url",
            sourceID: "Kaynak ID",
            resourceType: "Kaynak Türü",
            adsBody: "İçerik",
            adsCreateDate: "Oluşturma Tarihi",
            adsUpdateDate: "Güncellenme Tarihi",
        },
        newWizartV2: {
            generalSettings: "Genel Ayarlar",
            themeSettings: "Tema Ayarları",
            representativeWorkingHours: "Temsilci Çalışma Saatleri",
            preview: "Önizleme",
            setup: "Kurulum",
            formStepTitle: "Deneyiminizi kişiselleştirebilmemiz için bize daha fazla bilgi verin",
            supsisEntergation: "Supsis'i Hangi Websitenizde kullanacaksınız? :",
            goToNextStep: "Bir Sonraki Adıma Geç",
            readytemplate: "Hazır Renk Şablonu Kullan",
            customSettings: "Özel Ayarlar",
            customerMessageView: "Müşteri mesaj Görünümü",
            backcgroundColor: "Arka Plan Rengi",
            textColor: "Yazı Rengi",
            agentMessageView: "Temsilci Mesaj Görünümü",
            workingHours: "Ziyaretçilerine hangi zaman aralıklarında hizmet sağlarsınız?",
            continuousService: "Sürekli Hizmet",
            continuousServiceDescription: "Chat balonu her zaman aktif olur. Siz sistemde olmasanız bile.",
            vote: "Seçimini Yap",
            representativeWorking: "Temsilci Çalışma Saatleri Dahilinde",
            representativeWorkingDescription:
                "En az 1 temsilci çevrimçi olduğunda sohbet çevrimiçi görünür. Çevrimiçi temsilci yoksa offline olarak görünür.",
            computer: "Bilgisayar",
            tablet: "Tablet",
            uploadTrackingCodeToYourWebsite: "Entegrasyon Kodunu Web Sitenize Yükleyin",
            password: "Set New Password",
        },
        whatsappChannel: {
            whatsappTitleV1: "Whatsapp V1 Kanalları (QR)",
            whatsappTitleV2: "Whatsapp V2 Kanalları (QR)",
            channelName: "Kanal",
            phoneNummer: "Telefon Numarası",
            forwardToChatbot: "Chatbot'a ilet",
            forwardingChatbotOrLiveAgent: "Yönlendirme (Chatbot veya Live Agent)",
            addChannel: "Kanal Ekle",
            newWhatsappChannel: "Yeni Whatsapp Kanalı",
            newWhatsappChannelDescription: "QR Kodunu tarayarak yeni bir whatsapp kanalı oluşturun",
            editWhatsappChannel: "Whatsapp Kanalını Düzenleyin",
            editWhatsappChannelDescription: "Whatsapp kanalını düzenleme",
            whatsappChannel: "Whatsapp Kanalı",
            deleteWhatsappChannelDescription: "Bu kanalı silmek istediğinizden emin misiniz?",
            whatsappIntegration: "Whatsapp Entegrasyonu",
            deleteChannel: "Kanalı Sil",
            restartChannel: "Kanalı Yeniden Başlat",
            wantRestartChannel: "Kanalı yeniden başlatmak istiyor musun?",
            deleteSMSChannelDescription: "SMS kanalını silmek istediğinizden emin misiniz?",
            smsChannel: "SMS Kanalı",
            maxChannelCount: "Birden Fazla SMS Kanalı Oluşturamazsınız !",
            smsModalText:
                "Modern iletişim çözümleriyle entegre olmamız, size kolay ve etkili bir şekilde SMS gönderme imkanı sunuyor. İletişimde sınırları kaldırın, müşterilerinizle doğrudan bağlantı kurun!",
            smsModalBtn: "Sms Kanalı Açmak İçin Tıklayınız...",
            postaCellDetail: "PostaCell Kanal Detayı",
        },
        noPermission: "Bu işlemi gerçekleştirmek için yetkiniz yok. Yöneticinizle görüşün.",
        mail_integration_detail: {
            title: "Mail Detay",
            integration: "Entegrasyon",
            sender: "Gönderen Maili",
            signature: "İmza",
            inbox: "Gelen Kutusu",
            medias: "Medya",
            visibility: "İzinler",
            settings_group: "Ayarlar",
            contacts: "Kişiler",
        },
        whatsapp_business_api: {
            userVisibility: "Kullanıcı Görünürlüğü",
            userVisibilityDesc:
                "Kullanıcıların erişebileceği kanallar, rollerine ve kanalın görünürlük ayarlarına bağlıdır. Full Admin veya root rolüne sahip kullanıcılar tüm kanalları görebilir. Eğer bir kanalın görünürlük ayarları boş ise, kanal herkese açıktır. Ancak, kanal belirli kullanıcılar veya departmanlar için tanımlanmışsa, sadece bu kullanıcılar veya departman üyeleri kanalı görebilir.",
            searchTemplate: "Şablon ara...",
            forwardToChatbot: "Chatbot'a Yönlendir",
            forwarding: "Yönlendirme (Chatbot veya Canlı Temsilci)",
            forwardLiveAgents: "👉 Canlı Desteğe Yönlendir",
            forwardingToDepartment: "Departmana Yönlendirme",
            selectDepartment: "Departman Seç",
            createWbChannel:
                "Whatsapp Business kanalı oluşturmak için Whatsapp Business paketi satın almalısınız. Uygun fiyatlı paketlere hemen ulaşabilirsiniz.",
            wbCreateChannelMax: "Whatsapp Business kanal oluşturma limitine ulaştınız. Maximun",
            wbContinue:
                "Whatsapp Business Kanalı oluşturabilirsiniz. Devam etmek için paketinizi yükseltin yada Whatsapp Business kanalarınızdan bir kaçını siliniz.",
            chatInitiatorTemplate: "Sohbet Başlatıcı Şablonu",
            selectChatInitiatorTemplate: "Sohbet başlatıcı şablonunuzu seçin.",
            dailyUsageReport: "Günlük Kullanım Raporu",
            freeChat: "Ücretsiz Sohbet",
            paidChat: "Ücretli Sohbet",
            templateMessage: "Şablon Mesajı",
            outgoingSession: "Giden Oturum",
            incomingSession: "Yaklaşan Oturum",
            totalCost: "Toplam Maliyet",
            allOptNumbers: "Tüm katılım numaraları.",
            startChat: "Sohbet Başlat",
            lastMessageDate: "Son Mesaj Tarihi",
            sureDeleteTemplate: "Bu şablonu silmek istediğinize emin misiniz?",
            manageWhoChannelChat: "Bu kanal sohbetlerini kimlerin görebileceğini yönetin",
            profileImageDesc: "Bu, işletmenizin WhatsApp ekran resmi olacaktır",
            bussinesDesciption: "Bussines Açıklama ",
            descOfWork: "İşletmenizin birkaç kelimeyle açıklaması (Maksimum 512 Karakter)",
            accountStatus: "Hesap Durumu",
            dockerStatus: "Docker Durumu",
            phoneQuality: "Telefon Kalitesi",
            customersOrDay: "Müşteriler/Gün",
            messagingLimit: "Mesajlaşma Sınırı",
            canSendMessage: "Mesaj Gönderilebilir",
            officialDetails: "Resmi Detaylar",
            officialDetailsDesc:
                "Bu adresler, WhatsApp'ta sizinle sohbet eden kullanıcılara her zaman profil bölümünde gösterilecektir. Düzenledikten sonra onay için WhatsApp'a göndereceğiz.",
            addressLine: "Adres Hattı",
            stateIfApplic: "Eyalet (varsa)",
            zipCodeOrPostCode: "Zip Kodu/Posta Kodu",
            selectCountry: "Ülke Seçiniz",
            selectBussVertical: "İş Alanı Seçiniz",
            saveInfo: "Bilgileri Kaydet",
            active: "Aktif",
            banned: "Yasaklı",
            low: "Düşük",
            medium: "Orta",
            high: "Yüksek",
            connected: "Bağlı",
            disConnected: "Bağlantı Kesildi",
            flagged: "İşaretlendi",
            pending: "Beklemede",
            restricted: "Kısıtlanmış",
            unknown: "Bilinmiyor",
            available: "Mevcut",
            limited: "Sınırlı",
            blocked: "Engellendi",
            success: "Başarılı",
            succesDesc: "Profil bilgileriniz başarılı bir şekilde güncellendi.",
            wabaOverview: "WABA Sağlığına Genel Bakış",
            manageChannelDetail: "Kanal bilgilerinizi yönetin",
            wpBussChannelDetail: "Whatsapp Business Kanal Detayı",
            manageWpBussChannel: "Whatsapp iş kanalınızı yönetin",
            channelName: "Kanal Adı",
            phoneNumberE164: "Telefon Numarası (E164 Formatı)",
            phoneNumberE164Place: "Telefon Numarası (E164 Formatı). örn: 908501234455",
            channelUpdatedSucs: "Kanal başarıyla güncellendi",
            faieldUpdateChannel: "Kanal güncellenemedi",
            title: "Whatsapp Business API Kanalları",
            integration: "Entegrasyon",
            detail: "Detay",
            visibility: "Görünürlük",
            templates: "Tüm Şablon Mesajlar",
            settings_group: "Ayar",
            template_message_group: "Şablon Mesajları",
            new_template: "Yeni Şablon Oluştur",
            broadcast_group: "Toplu Mesaj",
            broadcast_requests: "Toplu Mesaj Gönderimleri",
            customer_groups: "Müşteri Grupları",
            chat_initiator_template: "Chat Başlatma Şablonu",
            reports: "Raporlar",
            contacts: "Kişiler",
            numbers: "Numaralar",
            all_contacts: "Tüm Kişiler",
            businessChannelDetail: "Whatsapp Business Kanal Detayı",
            wallet: "Cüzdan",
            postacellMessage: "SMS Gönder",
            postacellAllMessage: "Toplu SMS Gönder",
            message_group: "Mesaj",
            createNewTemplate: "Yeni şablon mesaj oluştur",
            templateName: "Şablon adı",
            templateNameDesc: "Mesaj şablonunuza bir isim verin.",
            templateInfo: "Şablon Bilgileri",
            viewTemplates: "Şablonları gör",
            templateNameRules: "Şablon adı sadece küçük harf, sayı ve alt çizgi içerebilir.",
            category: "Kategori",
            categoryDesc: "Ne tür bir şablon oluşturmak istediğinizi seçin",
            categoryUtility: "Yardımcı",
            categoryUtilityDesc:
                "Hesap güncellemeleri, sipariş güncellemeleri, uyarılar ve daha fazlası gibi yardımcı bilgiler gönderin.",
            categoryMarketing: "Pazarlama",
            categoryMarketingDesc:
                "Farkındalığı ve etkileşimi artırmak için promosyon teklifleri, ürün teklifleri ve daha fazlasını gönderin.",
            categoryAuth: "Doğrulama",
            categoryAuthDesc: "Müşterilerinizin hesaplarına erişmesi için kodlar gönderin.",
            optional: "Tercihen",
            languageDesc: "Şablon mesajınızın hangi dilde gönderileceğini seçin",
            header: "Başlık",
            headerRules: "Mesajınıza 60 karakterlik bir başlık ekleyin. Başlıkta yalnızca bir değişken desteklenir.",
            headerOptionMedia: "Medya",
            headerOptionText: "Metin",
            none: "Hiçbiri",
            headerType: "Başlık tipi",
            headerText: "Başlık metni",
            body: "Gövde",
            bodyRules: "Mesajnınız için seçtiğiniz dilde bir metin girin",
            addVariable: "Değişken ekle",
            variables: "Değişkenler",
            variable: "Değişken",
            defaultVariableName: "Varsayılan Değişken Adı",
            defaultVariableToolTip:
                "Değişkeniniz şablonda bu isimle gözükür.<br> Ayrıca aksi durumlarda mesajınızda varsayılan olarak bu değer gönderilir.",
            selectATemplate: "Mesaj Şablonunuzu Seçin",
            variableSettings: "Değişken ayarları",
            example: "Örnek",
            footer: "alt bilgi",
            footerDesc: "Mesajınıza 60 karakterlik bir altbilgi ekleyin. Altbilgide değişkenler desteklenmez.",
            buttons: "Butonlar",
            buttonType: "Buton tipi",
            buttonTypeReply: "Cevapla",
            submit: "Kaydet",
            submitting: "Kaydediliyor",
            addButton: "Buton Ekle",
            rejectWhatsapp: "Whatsapp tarafından reddedildi.",
            approvedWhatsapp: "Whatsapp tarafından kabul edildi.",
            pendingWhatsapp: "Onay Bekliyor",
            daily_usages: "Günlük Kullanımlar",
        },
        multi_whatsapp_api: {
            profile: "Profil",
            integration: "Entegrasyon",
            detail: "Detay",
            visibility: "Görünürlük",
            templates: "Tüm Şablon Mesajlar",
            settings_group: "Ayar",
            template_message_group: "Şablon Mesajları",
            new_template: "Yeni Şablon Oluştur",
            broadcast_group: "Toplu Mesaj",
            broadcast_requests: "Toplu Mesaj Gönderimleri",
            customer_groups: "Müşteri Grupları",
            chat_initiator_template: "Chat Başlatma Şablonu",
            contacts: "Kişiler",
            all_contacts: "Tüm Kişiler",
            numbers: "Numaralar",
        },
        archive: {
            destroyedBy: {
                agent: "Temsilci",
                visitor: "Ziyaretçi",
                system: "Sistem",
                chatbot: "Chatbot",
            },
        },
        upgradeMessages: {
            ticket: "Offline olsanız bile, yapay zeka ve chatbot ile talepleriniz anında kaydedilsin. Müşterilerinizi her zaman memnun edin!",
            tasks: "Görevlerinizi ve projelerinizi kolayca yönetin. Ekip üyelerinizle işbirliği yapın ve projelerinizi zamanında teslim edin!",
            calendar:
                "Randevularınızı ve toplantılarınızı kolayca planlayın. Ekip üyelerinizle senkronize olun ve zamanınızı daha verimli kullanın!",
            mail_integration:
                "E-postalarınızı kolayca yönetin. Müşterilerinizle iletişiminizi güçlendirin ve işbirliğinizi artırın!",
            team_integration:
                "Takımınızla daha hızlı ve etkili iletişim kurun. İşbirliğinizi artırın ve projelerinizi zamanında teslim edin!",
            webhook_integration:
                "Webhook entegrasyonu ile uygulamalarınızı birbirine bağlayın ve veri alışverişini kolaylaştırın!",
            whatsapp_v2: "Whatsapp entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            whatsapp: "Whatsapp entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            whatsapp_business_api: "Whatsapp entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            instagram: "Instagram entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            messenger: "Messenger entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            sms_postacell: "SMS entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            ready_contents: "Hazır İçerikler, müşterilerinizle daha hızlı ve etkili iletişim kurmanızı sağlar.",
            automation:
                "Otomasyon ile işlerinizi otomatikleştirin. İşlerinizi daha hızlı ve etkili bir şekilde yönetin!",
            form: "Form Oluşturucu, müşterilerinizle daha hızlı ve etkili iletişim kurmanızı sağlar. Form Oluşturucu ile müşterilerinizden daha fazla bilgi alın ve işbirliğinizi artırın!",
            customer_tables:
                "Müşteri Tabloları ile kendi tablonuzu oluşturun, hızlı ve pratik bir şekilde müşteri bilgilerinizi kaydedin ve yönetin!",
            trendyol: "Trendyol entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            access_control: "Erişim Kontrolü ile kötü niyetli kullanıcıları engelleyin ve verilerinizi güvende tutun!",
            upgrade: "Aboneliğimi Yükselt",
            upgradeFeature: "Ek Paket Al",
            featureNotAvailable: "özelliğiniz mevcut değildir.",
            usageLimitExceeded: "Kullanım Sınırı Aşıldı",
            maxAgentCount: "Daha fazla temilsci alarak daha fazla müşteriye hizmet vermek için paketinizi yükseltin.",
            maxTriggerCount: "Daha fazla tetkileyici alıp daha fazla etkileşim yaratmak için paketinizi yükseltin.",
            visitorStartChat:
                "Daha önce etkileşime girmemiş ziyaretçilerle sohbet başlatmak için paketinizi yükseltin.",
            voiceCalling:
                "Müşterileriniz ile sesli görüşme yaparak daha etkili iletişim kurmak için paketinizi yükseltin.",
            videoCalling:
                "Müşterileriniz ile video görüşme yaparak daha etkili iletişim kurmak için paketinizi yükseltin.",
            fileAndVoiceMessage: "Müşterilerinize dosya ve sesli mesaj göndermek için paketinizi yükseltin.",
            autoTranslation:
                "Mesajları otomatik çevirerek daha fazla müşteriye hizmet vermek için paketinizi yükseltin.",
            telegramEntegration: "Telegram entegrasyonu için paketinizi yükseltin.",
            chatCopilot:
                "Yapay zeka destekli Chat Copilot özelliğini kullanarak daha etkili hizmet vermek için paketinizi yükseltin.",
            calenderEntegration:
                "Takvim entegrasyonu ile diğer uygulamalarınızı senkronize etmek için paketinizi yükseltin.",
            mailEntegration:
                "Mail işlerinizi daha etkili yönetmek ve müşteri iletişimini artırmak için paketinizi yükseltin.",
            smsEntegration: "SMS entegrasyonu ile müşterilerinize daha hızlı ulaşmak için paketinizi yükseltin.",
            ticketSystem: "Ticket sistemi ile müşteri taleplerini daha etkili yönetmek için paketinizi yükseltin.",
            taskManagementEntegration:
                "Görev yönetimi entegrasyonu ile iş akışınızı daha etkili yönetmek için paketinizi yükseltin.",
            webhookEntegration:
                "Webhook entegrasyonu ile diğer uygulamalarınızı senkronize etmek için paketinizi yükseltin.",
            readyContents: "Hazır içerikler ile müşteri iletişimini artırmak için paketinizi yükseltin.",
            automationEntegration:
                "Otomasyon entegrasyonu ile iş akışınızı daha etkili yönetmek için paketinizi yükseltin.",
            customerTablesEntegration:
                "Müşteri tabloları ile müşteri bilgilerini daha etkili yönetmek için paketinizi yükseltin.",
            formEntegration: "Formlar ile müşteri taleplerini daha etkili yönetmek için paketinizi yükseltin.",
            maxFormLimit:
                "Daha fazla form oluşturup müşteri taleplerini daha etkili yönetmek için paketinizi yükseltin.",
            maxFormFieldLimit:
                "Daha fazla form alanıp ekleyip müşterilerin taleplerini daha etkili yönetmek için paketinizi yükseltin.",
            maxCustomerTableCount: "Daha fazla müşteri tablosu eklemek için paketinizi yükseltin.",
            maxCustomerTableFieldCount: "Daha fazla müşteri tablosu alanı eklemek için paketinizi yükseltin.",
            maxCustomerTableViewCount: "Daha fazla müşteri tablosu görünümü kaydetmek için paketinizi yükseltin.",
            maxCustomerTableRecordCount: "Daha fazla müşteri tablosu kaydı eklemek için paketinizi yükseltin.",
            maxAutomationButton: "Daha fazla otomasyon bloğu eklemek için paketinizi yükseltin.",
            automationTimerBase: "Otomasyon zamanlayıcıları kullanmak için paketinizi yükseltin.",
            automationEventBase: "Otomasyon olayları kullanmak için paketinizi yükseltin.",
            automationWebhookBase: "Otomasyon webhookları kullanmak için paketinizi yükseltin.",
            automationButtonBase: "Otomasyon butonları kullanmak için paketinizi yükseltin.",
            liveScore: "Canlı izleme özelliğini kullanmak için paketinizi yükseltin.",
            multipleChatWindow: "Birden fazla sohbet penceresi açmak için paketinizi yükseltin.",
            maxTaskWorkflowLimit: "Daha fazla görev akışı eklemek için paketinizi yükseltin.",
            maxTaskColumnLimit: "Daha fazla görev sütunu eklemek için paketinizi yükseltin.",
            maxTaskRowLimit: "Daha fazla görev satırı eklemek için paketinizi yükseltin.",
            maxDepartmentLimit: "Daha fazla departman eklemek için paketinizi yükseltin.",
            maxRoleLimit: "Daha fazla rol eklemek için paketinizi yükseltin.",
            maxReadyContentsLimit: "Daha fazla hazır içerik eklemek için paketinizi yükseltin.",
            excelDownload: "Excel indirme özelliğini kullanmak için paketinizi yükseltin.",
            customerGroup: "Müşteri grupları özelliğini kullanmak için paketinizi yükseltin.",
            maxMailCount: "Daha fazla mail göndermek için paketinizi yükseltin.",
            maxWhatsappChannel: "Daha fazla Whatsapp kanalı eklemek için paketinizi yükseltin.",
            maxBusinessWhatsappChannel: "Daha fazla Whatsapp Business kanalı eklemek için paketinizi yükseltin.",
            maxInstagramChannel: "Daha fazla Instagram kanalı eklemek için paketinizi yükseltin.",
            maxMessengerChannel: "Daha fazla Messenger kanalı eklemek için paketinizi yükseltin.",
            maxTelegramChannel: "Daha fazla Telegram kanalı eklemek için paketinizi yükseltin.",
            maxTrendyolChannel: "Daha fazla Trendyol kanalı eklemek için paketinizi yükseltin.",
            maxMetaLeadChannel: "Daha fazla Meta Lead kanalı eklemek için paketinizi yükseltin.",
        },
    },
};

export default messagesTR;
